(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<body>\r\n  <div class=\"container\">\r\n    <div class=\"row\" style=\"padding-bottom: 10px;\">\r\n      <div class=\"col-lg-12\">\r\n        <h2>TWFG FloodPlus Program</h2>\r\n        <h4>Underwritten by Underwriters of Lloyds</h4>\r\n      </div>\r\n    </div>\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n</body>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/application/application.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/application/application.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\" *ngIf=\"errors.length > 0\">\r\n  <div class=\"col-lg-12\">\r\n    <div class=\"alert alert-warning\">\r\n      <div class=\"errorMessage\" *ngFor=\"let error of errors\">{{error}}</div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<form (ngSubmit)=\"applicationForm.form.valid && onSubmit(applicationForm.form.valid)\" #applicationForm=\"ngForm\" name=\"applicationForm\">\r\n  <div id=\"RiskAddressSection\">\r\n    <!-- Risk Address -->\r\n    <div class=\"row row-margintop-10\">\r\n      <div class=\"col-lg-12 col-md-12 col-sm-12\">\r\n        <h4>Risk Address</h4>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label for=\"RiskStreet\">Street</label>\r\n          <input id=\"RiskStreet\" name=\"RiskStreet\" type=\"text\" class=\"form-control\" [(ngModel)]=\"risk.street\" #street=\"ngModel\" required />\r\n          <div *ngIf=\"street.invalid && (street.dirty || street.touched) || (applicationForm.submitted && street.invalid)\">\r\n            <div class=\"error-message\">required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label for=\"RiskCity\">City</label>\r\n          <input id=\"RiskCity\" name=\"RiskCity\" type=\"text\" class=\"form-control\" [(ngModel)]=\"risk.city\" #city=\"ngModel\" required />\r\n          <div *ngIf=\"city.invalid && (city.dirty || city.touched) || (applicationForm.submitted && city.invalid)\">\r\n            <div class=\"error-message\">required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n        <div class=\"form-group\">\r\n          <label for=\"RiskState\">State</label>\r\n          <select id=\"RiskState\" name=\"RiskState\" class=\"form-control\" [(ngModel)]=\"selectedRiskState\" #riskState=\"ngModel\" (change)=\"changeCounties()\" quotableState required>\r\n            <option *ngFor=\"let state of physicalStates\" [ngValue]=\"state\">{{state.Code}}</option>\r\n          </select>\r\n          <div *ngIf=\"riskState.invalid && (riskState.dirty || riskState.touched) || (applicationForm.submitted && riskState.invalid)\">\r\n            <div *ngIf=\"riskState.errors.required\" class=\"error-message\">required</div>\r\n            <div *ngIf=\"riskState.errors.quotableState\" class=\"error-message\">state is not quotable</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n        <div class=\"form-group\">\r\n          <label for=\"RiskZip\">Zip</label>\r\n          <input id=\"RiskZip\" name=\"RiskZip\" type=\"text\" class=\"form-control\" [(ngModel)]=\"risk.zip\" #rZip=\"ngModel\" pattern=\"^\\d{5}([\\-]\\d{4})?$\" required />\r\n          <div *ngIf=\"rZip.invalid && (rZip.dirty || rZip.touched) || (applicationForm.submitted && rZip.invalid)\">\r\n            <div *ngIf=\"rZip.errors.required\" class=\"error-message\">required</div>\r\n            <div *ngIf=\"rZip.errors.pattern\" class=\"error-message\">invalid zip code</div>\r\n            <!-- <div *ngIf=\"rZip.errors.unquotableZip\" class=\"error-message\">zip code is not quotable</div>-->\r\n          </div>\r\n          </div>\r\n      </div>\r\n      <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label for=\"RiskCounty\" *ngIf=\"showCounty === true\">County</label>\r\n          <label for=\"RiskCounty\" *ngIf=\"showCounty === false\">Parish</label>\r\n          <select id=\"RiskCounty\" name=\"RiskCounty\" class=\"form-control\" [(ngModel)]=\"selectedRiskCounty\" (change)=\"verifyDisabledCounty()\" #riskCounty=\"ngModel\" required>\r\n            <option *ngFor=\"let county of filteredCounties\" [ngValue]=\"county\">{{county.CountyName}}</option>\r\n          </select>\r\n          <div *ngIf=\"riskCounty.invalid && (riskCounty.dirty || riskCounty.touched) || (applicationForm.submitted && riskCounty.invalid)\">\r\n            <div *ngIf=\"riskCounty.errors.required\" class=\"error-message\">required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div id=\"FloodAppSection\">\r\n    <!-- Mailing Address -->\r\n            <div class=\"row row-margintop-10\">\r\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\r\n                <h4>Mailing Address <input id=\"btnCopyAddress\" class=\"btn btn-xs btn-warning\" type=\"button\" value=\"Copy Risk Address\" (click)=\"copyRiskAddress()\" /></h4>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"MailingStreet\">Street</label>\r\n                  <input id=\"MailingStreet\" name=\"MailingStreet\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mailing.street\" #mailingStreet=\"ngModel\" required />\r\n                  <div *ngIf=\"mailingStreet.invalid && (mailingStreet.dirty || mailingStreet.touched) || (applicationForm.submitted && mailingStreet.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"MailingCity\">City</label>\r\n                  <input id=\"MailingCity\" name=\"MailingCity\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mailing.city\" #mailingCity=\"ngModel\" required />\r\n                  <div *ngIf=\"mailingCity.invalid && (mailingCity.dirty || mailingCity.touched) || (applicationForm.submitted && mailingCity.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"MailingState\">State</label>\r\n                  <select id=\"MailingState\" name=\"MailingState\" class=\"form-control\" [(ngModel)]=\"mailing.stateId\" #mailingState=\"ngModel\" #mState=\"ngModel\" required>\r\n                    <option *ngFor=\"let state of mailingStates\" [ngValue]=\"state.Id\">{{state.Code}}</option>\r\n                  </select>\r\n                  <div *ngIf=\"mState.invalid && (mState.dirty || mState.touched) || (applicationForm.submitted && mState.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"MailingZip\">Zip</label>\r\n                  <input id=\"MailingZip\" name=\"MailingZip\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mailing.zip\" pattern=\"^\\d{5}([\\-]\\d{4})?$\" #mZip=\"ngModel\" required />\r\n                  <div *ngIf=\"mZip.invalid && (mZip.dirty || mZip.touched) || (applicationForm.submitted && mZip.invalid)\">\r\n                    <div *ngIf=\"mZip.errors.required\" class=\"error-message\">required</div>\r\n                    <div *ngIf=\"mZip.errors.pattern\" class=\"error-message\">invalid zip code</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Insured Information -->\r\n            <div class=\"row row-margintop-10\">\r\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\r\n                <h4>Insured Information</h4>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-6 col-md-6 col-sm-6\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FirstName\">First Name</label>\r\n                  <input id=\"FirstName\" name=\"FirstName\" type=\"text\" class=\"form-control\" [(ngModel)]=\"insuredFirstName\" #firstName=\"ngModel\" required />\r\n                  <div *ngIf=\"firstName.invalid && (firstName.dirty || firstName.touched) || (applicationForm.submitted && firstName.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-6 col-md-6 col-sm-6\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"LastName\">Last Name</label>\r\n                  <input id=\"LastName\" name=\"LastName\" type=\"text\" class=\"form-control\" [(ngModel)]=\"insuredLastName\" #lastName=\"ngModel\" required />\r\n                  <div *ngIf=\"lastName.invalid && (lastName.dirty || lastName.touched) || (applicationForm.submitted && lastName.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Property Details -->\r\n            <div class=\"row row-margintop-10\">\r\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\r\n                <h4>Property Details</h4>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"PropOccupancy\">Occupancy</label>\r\n                  <select id=\"PropOccupancy\" name=\"PropOccupancy\" [(ngModel)]=\"selectedOccupancy\" class=\"form-control\" #occupancy=\"ngModel\" (change)=\"changeDwellingPercentValues()\" required>\r\n                    <option *ngFor=\"let occupancy of occupancies\" [ngValue]=\"occupancy\">{{occupancy.Text}}</option>\r\n                  </select>\r\n                  <div *ngIf=\"occupancy.invalid && (occupancy.dirty || occupancy.touched) || (applicationForm.submitted && occupancy.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"PropYearBuilt\">Year Built</label>\r\n                  <input id=\"PropYearBuilt\" name=\"PropYearBuilt\" class=\"form-control\" [(ngModel)]=\"yearBuilt\" [customMin]=\"1607\" [customMax]=\"maxDate\" #year=\"ngModel\" pattern=\"^[0-9]*$\" required />\r\n                  <div *ngIf=\"year.invalid && (year.dirty || year.touched) || (applicationForm.submitted && year.invalid)\">\r\n                    <div *ngIf=\"year.errors.required\" class=\"error-message\">required</div>\r\n                    <div *ngIf=\"year.errors.customMin\" class=\"error-message\">invalid year</div>\r\n                    <div *ngIf=\"year.errors.customMax\" class=\"error-message\">invalid year</div>\r\n                    <div *ngIf=\"year.errors.pattern\" class=\"error-message\">invalid year</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"PropConstructionType\">Construction Type</label>\r\n                  <select id=\"PropConstructionType\" name=\"PropConstructionType\" class=\"form-control\" [(ngModel)]=\"selectedConstructionType\" #constType=\"ngModel\" (change)=\"changeConstructionType(selectedConstructionType.Id)\" required>\r\n                    <option *ngFor=\"let construction of constructionType\" [ngValue]=\"construction\">{{construction.Text}}</option>\r\n                  </select>\r\n                  <div *ngIf=\"constType.invalid && (constType.dirty || constType.touched) || (applicationForm.submitted && constType.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"PropNumStories\">Number of Stories</label>\r\n                  <input id=\"PropNumStories\" name=\"PropNumStories\" type=\"number\" class=\"form-control\" [(ngModel)]=\"propNumStories\" [customMin]=\"(basement == 1 || basement == 2) ? 2 : 1\" pattern=\"^[0-9]*$\" #stories=\"ngModel\" required />\r\n                  <div *ngIf=\"stories.invalid && (stories.dirty || stories.touched) || (applicationForm.submitted && stories.invalid)\">\r\n                    <div *ngIf=\"stories.errors.required\" class=\"error-message\">required</div>\r\n                    <div *ngIf=\"stories.errors.customMin\">\r\n                      <div class=\"error-message\" style=\"text-align:left\" *ngIf=\"basement == 1 || basement === 2\">Risks with basements must be 2-stories or more </div>\r\n                      <div class=\"error-message\" *ngIf=\"basement !== 1 && basement !== 2\">invalid number of stories</div>\r\n                    </div>\r\n                    <div class=\"error-message\" *ngIf=\"stories.errors.pattern\">invalid number of stories</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"PropSquareFeet\">Square Feet</label>\r\n                  <input id=\"PropSquareFeet\" name=\"PropSquareFeet\" type=\"number\" class=\"form-control\" [(ngModel)]=\"squareFeet\" #sqFeet=\"ngModel\" [customMin]=\"1\" pattern=\"^[0-9]*$\" required />\r\n                  <div *ngIf=\"sqFeet.invalid && (sqFeet.dirty || sqFeet.touched) || (applicationForm.submitted && sqFeet.invalid)\">\r\n                    <div *ngIf=\"sqFeet.errors.required\" class=\"error-message\">required</div>\r\n                    <div *ngIf=\"sqFeet.errors.customMin || sqFeet.errors.pattern\" class=\"error-message\">invalid square footage</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Replacement Cost -->\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-2 col-md-2 col-sm-2\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"DwellingTiv\">Dwelling Value</label>\r\n                  <input id=\"DwellingTiv\" name=\"DwellingTiv\" type=\"number\" class=\"form-control\" [(ngModel)]=\"dwellingTiv\" #dwellTiv=\"ngModel\" [customMin]=\"squareFeet ? squareFeet * getSquareFeetCost(selectedConstructionType.Id): 100\" pattern=\"^[0-9]*$\" (change)=\"changePersonalPropTiv()\" required />\r\n                  <div *ngIf=\"dwellTiv.invalid && (dwellTiv.dirty || dwellTiv.touched || (applicationForm.submitted && dwellTiv.invalid))\">\r\n                    <div *ngIf=\"dwellTiv.errors.required \" class=\"error-message\">required</div>\r\n                    <div *ngIf=\"dwellTiv.errors.customMin || dwellTiv.errors.pattern\" class=\"error-message\">Dwelling value must at least be ${{getSquareFeetCost(selectedConstructionType.Id)}} per square foot. <span *ngIf=\"squareFeet\">({{squareFeet * getSquareFeetCost(selectedConstructionType.Id) | currency}})</span></div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"DwellingTivPercentage\">Personal Property (% of Dwelling Value)</label>\r\n                  <select id=\"DwellingTivPercentage\" name=\"DwellingTivPercentage\" class=\"form-control\" [(ngModel)]=\"selectedDwellingTivPercentage\" #tiv=\"ngModel\" (change)=\"changePersonalPropTiv()\" required>\r\n                    <option *ngFor=\"let x of dwellingTivPercentage\" [ngValue]=\"x\">{{x.Text}}</option>\r\n                  </select>\r\n                  <div *ngIf=\"tiv.invalid && (tiv.dirty || tiv.touched) || (applicationForm.submitted && tiv.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"PersonalPropertyTiv\">Personal Property Amount</label>\r\n                  <input id=\"PersonalPropertyTiv\" name=\"PersonalPropertyTiv\" type=\"number\" class=\"form-control\" [(ngModel)]=\"personalPropertyTiv\" #propertyTiv=\"ngModel\" required readonly />\r\n                  <div *ngIf=\"propertyTiv.invalid && (propertyTiv.dirty || propertyTiv.touched) || (applicationForm.submitted && propertyTiv.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"PersonalPropertyCostValueType\">Personal Property Coverage Type</label>\r\n                  <select id=\"PersonalPropertyCostValueType\" name=\"PersonalPropertyCostValueType\" class=\"form-control\" [(ngModel)]=\"selectedPropertyCostValueType\" #ppcvt=\"ngModel\" required>\r\n                    <option *ngFor=\"let costValueType of propertyCostValueType\" [ngValue]=\"costValueType\">{{costValueType.Text}}</option>\r\n                  </select>\r\n                  <div *ngIf=\"ppcvt.invalid && (ppcvt.dirty || ppcvt.touched) || (applicationForm.submitted && ppcvt.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"HomeElevated\">Is the Home Elevated? <span class=\"fa fa-info-circle\" role=\"button\" (click)=\"homeElevatedTip = !homeElevatedTip\"></span></label>\r\n                  <div *ngIf=\"homeElevatedTip\">\r\n                    <p>Elevation certificate is not required.</p>\r\n                  </div>\r\n                  <div id=\"HomeElevated\">\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"homeElevated\" class=\"form-check-inline\" name=\"HomeElevated\" type=\"radio\" [value]=\"true\" (change)=\"changeHomeElevated()\" [required]=\"!homeElevated\" #elevated=\"ngModel\" />Yes</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"homeElevated\" class=\"form-check-inline\" name=\"HomeElevated\" type=\"radio\" [value]=\"false\" (change)=\"changeHomeElevated()\" [required]=\"!homeElevated\" #elevated=\"ngModel\" />No</label>\r\n                  </div>\r\n                  <div *ngIf=\"elevated.invalid && (elevated.dirty || elevated.touched) || (applicationForm.submitted && elevated.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\" *ngIf=\"homeElevated != null || homeElevated != undefined\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FoundationType\">Foundation Type <span id=\"btnFoundationInfo\" class=\"fa fa-info-circle\" role=\"button\" (click)=\"showFoundationTypeInfo = !showFoundationTypeInfo\"></span></label>\r\n                  <select id=\"FoundationType\" name=\"FoundationType\" class=\"form-control\" [(ngModel)]=\"selectedFoundationTypeId\" #foundation=\"ngModel\" required>\r\n                    <option *ngFor=\"let foundation of foundationTypes\" [ngValue]=\"foundation.Id\">{{foundation.Text}}</option>\r\n                  </select>\r\n                  <div *ngIf=\"foundation.invalid && (foundation.dirty || foundation.touched) || (applicationForm.submitted && foundation.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-5 col-md-5 col-sm-5\" *ngIf=\"homeElevated == true\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"ElevationHeight\">Elevation Height Above Ground of Lowest Occupied Floor (ft.)</label>\r\n                  <input id=\"ElevationHeight\" name=\"ElevationHeight\" type=\"number\" class=\"form-control\" [(ngModel)]=\"elevationHeight\" #height=\"ngModel\" [required]=\"homeElevated == true\" />\r\n                  <div *ngIf=\"height.invalid && (height.dirty || height.touched) || (applicationForm.submitted && height.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"showFoundationTypeInfo\">\r\n              <div class=\"col-lg-12 col-md-12 col-sm-12\" *ngIf=\"homeElevated == true\">\r\n                <p><b>Piers, Posts, Piles:</b> Sometimes called a post-and-beam or pier-and-beam foundation, consists of wood posts or concrete piers set into the ground to bear the weight of a building or home.</p>\r\n                <p><b>Reinforced/Masonry:</b> Can be load bearing walls or non-load bearing walls. The use of reinforcement in walls helps it to withstand tension forces and heavy compressive loads.</p>\r\n                <p><b>Reinforced Shear Walls:</b> Walls used for structural support but not structurally joined or enclosed at the ends (except by breakaway walls). Shear walls are parallel or nearly parallel, to the flow of the water and can be used in any flood zone.</p>\r\n                <p><b>Solid Foundation Walls:</b> Walls that are used as a means of elevating a building in A Zones and that must contain sufficient openings to allow for the unimpeded flow of floodwaters more than 1 foot deep.</p>\r\n              </div>\r\n              <div class=\"col-lg-12 col-md-12 col-sm-12\" *ngIf=\"homeElevated == false\">\r\n                <p><b>Foundation Wall:</b> Masonry walls, poured concrete walls or precast concrete walls, regardless of height, that extend above grade and support the weight of a building.</p>\r\n                <p><b>Slab on Grade:</b> A concrete slab serves as the foundation for the structure and is formed using a mold set into the ground. The concrete is placed into the mold, leaving no space between the ground and the structure.</p>\r\n                <p><b>Slab on Fill:</b> As per slab on grade, but the slab is placed on a compacted structural fill rather than the ground.</p>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"homeElevated == true\">\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FeatureGarage\">Attached Garage</label>\r\n                  <div id=\"FeatureGarage\">\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"garage\" name=\"FeatureGarage\" class=\"form-check-inline\" type=\"radio\" [value]=\"1\" [required]=\"!garage && homeElevated == true\" #featureGarage=\"ngModel\" />Finished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"garage\" name=\"FeatureGarage\" class=\"form-check-inline\" type=\"radio\" [value]=\"2\" [required]=\"!garage && homeElevated == true\" #featureGarage=\"ngModel\" />Unfinished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"garage\" name=\"FeatureGarage\" class=\"form-check-inline\" type=\"radio\" [value]=\"3\" [required]=\"!garage && homeElevated == true\" #featureGarage=\"ngModel\" />None</label>\r\n                  </div>\r\n                  <div *ngIf=\"featureGarage.invalid && (featureGarage.dirty || featureGarage.touched) || (applicationForm.submitted && featureGarage.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FeatureCrawlspace\">Crawlspace</label>\r\n                  <div id=\"FeatureCrawlspace\">\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"crawlspace\" class=\"form-check-inline\" name=\"FeatureCrawlspace\" type=\"radio\" [value]=\"1\" [required]=\"!crawlspace && homeElevated == true\" #featureCrawlspace=\"ngModel\" (change)=\"changeCrawlspace()\" />Finished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"crawlspace\" class=\"form-check-inline\" name=\"FeatureCrawlspace\" type=\"radio\" [value]=\"2\" [required]=\"!crawlspace && homeElevated == true\" #featureCrawlspace=\"ngModel\" (change)=\"changeCrawlspace()\" />Unfinished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"crawlspace\" class=\"form-check-inline\" name=\"FeatureCrawlspace\" type=\"radio\" [value]=\"3\" [required]=\"!crawlspace && homeElevated == true\" #featureCrawlspace=\"ngModel\" (change)=\"changeCrawlspace()\" />None</label>\r\n                  </div>\r\n                  <div *ngIf=\"featureCrawlspace.invalid && (featureCrawlspace.dirty || featureCrawlspace.touched) || (applicationForm.submitted && featureCrawlspace.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FeatureEnclosure\">Enclosure</label>\r\n                  <div id=\"FeatureEnclosure\">\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"enclosure\" class=\"form-check-inline\" name=\"FeatureEnclosure\" type=\"radio\" [value]=\"1\" [required]=\"!enclosure && homeElevated == true\" #featureEnclosure=\"ngModel\" (change)=\"changeEnclosure()\" />Finished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"enclosure\" class=\"form-check-inline\" name=\"FeatureEnclosure\" type=\"radio\" [value]=\"2\" [required]=\"!enclosure && homeElevated == true\" #featureEnclosure=\"ngModel\" (change)=\"changeEnclosure()\" />Unfinished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"enclosure\" class=\"form-check-inline\" name=\"FeatureEnclosure\" type=\"radio\" [value]=\"3\" [required]=\"!enclosure && homeElevated == true\" #featureEnclosure=\"ngModel\" (change)=\"changeEnclosure()\" />None</label>\r\n                  </div>\r\n                  <div *ngIf=\"featureEnclosure.invalid && (featureEnclosure.dirty || featureEnclosure.touched) || (applicationForm.submitted && featureEnclosure.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"homeElevated == false\">\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FeatureBasement\">Basement (include any basement as an additional story)</label>\r\n                  <div id=\"FeatureBasement\" class=\"radio\">\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"basement\" class=\"form-check-inline\" name=\"FeatureBasement\" type=\"radio\" [value]=\"1\" #featureBasement=\"ngModel\" [required]=\"!basement && homeElevated == false\" />Finished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"basement\" class=\"form-check-inline\" name=\"FeatureBasement\" type=\"radio\" [value]=\"2\" #featureBasement=\"ngModel\" [required]=\"!basement && homeElevated == false\" />Unfinished</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"basement\" class=\"form-check-inline\" name=\"FeatureBasement\" type=\"radio\" [value]=\"3\" #featureBasement=\"ngModel\" [required]=\"!basement && homeElevated == false\" />None</label>\r\n                  </div>\r\n                  <div *ngIf=\"featureBasement.invalid && (featureBasement.dirty || featureBasement.touched) || (applicationForm.submitted && featureBasement.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <div class=\"form-group\">\r\n                    <label for=\"OverWaterType\">Building Located Over Water?</label>\r\n                    <select id=\"OverWaterType\" name=\"OverWaterType\" class=\"form-control\" [(ngModel)]=\"selectedOverWaterType\" #overWaterType=\"ngModel\" required>\r\n                      <option *ngFor=\"let overWaterType of overWaterTypes\" [ngValue]=\"overWaterType\">{{overWaterType.Text}}</option>\r\n                    </select>\r\n                    <div *ngIf=\"overWaterType.invalid && (overWaterType.dirty || overWaterType.touched) || (applicationForm.submitted && overWaterType.invalid)\">\r\n                      <div class=\"error-message\">required</div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- Flood Loss -->\r\n            <div class=\"row row-margintop-10\">\r\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\r\n                <h4>Flood Loss</h4>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FloodLoss\">Do you know of any previous flood losses at this location?</label>\r\n                  <div id=\"FloodLoss\">\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"previousLosses\" class=\"form-check-inline\" name=\"FloodLoss\" type=\"radio\" [value]=\"true\" [required]=\"!previousLosses\" #lossQuestion=\"ngModel\" />Yes</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"previousLosses\" class=\"form-check-inline\" name=\"FloodLoss\" type=\"radio\" [value]=\"false\" [required]=\"!previousLosses\" #lossQuestion=\"ngModel\" (click)=\"resetLosses()\" />No</label>\r\n                  </div>\r\n                  <div *ngIf=\"lossQuestion.invalid && (lossQuestion.dirty || lossQuestion.touched) || (applicationForm.submitted && lossQuestion.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"previousLosses === true\">\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FloodLossYear\">Year of Loss</label>\r\n                  <input id=\"FloodLossYear\" name=\"FloodLossYear\" type=\"number\" class=\"form-control\" [customMin]=\"1607\" pattern=\"^[0-9]*$\" [(ngModel)]=\"floodLossYear\" [customMax]=\"maxDate\" #lossYear=\"ngModel\" [required]=\"false\" />\r\n                  <div *ngIf=\"lossYear.invalid && (lossYear.dirty || lossYear.touched)\">\r\n                    <div *ngIf=\"lossYear.errors.customMin\" class=\"error-message\">year cannot be below 1607</div>\r\n                    <div *ngIf=\"lossYear.errors.customMax || lossYear.errors.pattern\" class=\"error-message\">invalid year</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FloodLossValue\">Value of Loss</label>\r\n                  <input id=\"FloodLossValue\" name=\"FloodLossValue\" type=\"number\" class=\"form-control\" [customMin]=\"0.01\" pattern=\"^[0-9]*?(\\.[0-9]{1,2})?$\" [(ngModel)]=\"floodLossValue\" #lossValue=\"ngModel\" [required]=\"false\" />\r\n                  <div *ngIf=\"lossValue.invalid && (lossValue.dirty || lossValue.touched)\">\r\n                    <div *ngIf=\"lossValue.errors.customMin || lossValue.errors.pattern\" class=\"error-message\">invalid amount</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"previousLosses == true\">\r\n              <div class=\"col-lg-3 col-md-3 col-sm-3\">\r\n                <div class=\"form-group\">\r\n                  <input id=\"btnAddLoss\" class=\"btn btn-warning\" type=\"button\" value=\"Add Loss\" (click)=\"!lossYear?.invalid && !lossValue?.invalid && addLoss()\" />\r\n                  <div *ngIf=\"(buttonClick === true) && (floodLossValue === undefined || floodLossYear === undefined || floodLossValue === null || floodLossYear === null) \">\r\n                    <div class=\"error-message\" *ngIf=\"floodLossYear === undefined || floodLossYear === null\">Year of loss cannot be empty</div>\r\n                    <div class=\"error-message\" *ngIf=\"floodLossValue === undefined  || floodLossValue === null\">Value of loss cannot be empty</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"previousLosses == true && losses.length > 0\">\r\n              <div class=\"col-lg-6 col-md-6 col-sm-6\">\r\n                <table class=\"table table-bordered table-hover table-condensed\">\r\n                  <tr style=\"font-weight: bold\">\r\n                    <td style=\"width:25%\">Year of Loss</td>\r\n                    <td style=\"width:50%\">Value of Loss</td>\r\n                    <td style=\"width:25%\"></td>\r\n                  </tr>\r\n                  <tr *ngFor=\"let loss of losses; let ind = index\">\r\n                    <td>\r\n                      <div>\r\n                        {{ loss.YearOfLoss }}\r\n                      </div>\r\n                    </td>\r\n                    <td>\r\n                      <div>\r\n                        {{  loss.ValueOfLoss }}\r\n                      </div>\r\n                    </td>\r\n                    <td style=\"white-space: nowrap\">\r\n                      <div class=\"buttons\">\r\n                        <button type=\"button\" class=\"btn btn-danger\" (click)=\"removeLoss(ind)\">Delete</button>\r\n                      </div>\r\n                    </td>\r\n                  </tr>\r\n                </table>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"previousLosses == true\">\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <div *ngIf=\"losses.length === 0 && applicationForm.submitted\">\r\n                    <div class=\"error-message\">must have at least one flood loss</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"previousLosses == true\">\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"ElevatedAfterLoss\">House elevated after a prior flood loss?</label>\r\n                  <div id=\"ElevatedAfterLoss\" class=\"radio\">\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"elevatedAfter\" class=\"form-check-inline\" name=\"ElevatedAfterLoss\" type=\"radio\" [value]=\"true\" [required]=\"!elevatedAfter && previousLosses != false\" #elevated=\"ngModel\" />Yes</label>\r\n                    <label class=\"form-check-inline\"><input [(ngModel)]=\"elevatedAfter\" class=\"form-check-inline\" name=\"ElevatedAfterLoss\" type=\"radio\" [value]=\"false\" [required]=\"!elevatedAfter && previousLosses != false\" #elevated=\"ngModel\" />No</label>\r\n                  </div>\r\n                  <div *ngIf=\"elevated.invalid && (elevated.dirty || elevated.touched) || (applicationForm.submitted && elevated.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-4 col-md-4 col-sm-4\">\r\n                <div class=\"form-group\">\r\n                  <label for=\"FemaFloodZone\">Select FEMA Flood Zone</label>\r\n                  <select id=\"FemaFloodZone\" name=\"FemaFloodZone\" class=\"form-control\" [(ngModel)]=\"selectedFloodZone\" #floodZone=\"ngModel\" required>\r\n                    <option *ngFor=\"let zone of floodZones\" [ngValue]=\"zone\">{{zone.Text}}</option>\r\n                  </select>\r\n                  <div *ngIf=\"floodZone.invalid && (floodZone.dirty || floodZone.touched) || (applicationForm.submitted && floodZone.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row row-margin\">\r\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\r\n                <div class=\"pull-right\">\r\n                  <!--<input id=\"btnSubmit\" class=\"btn btn-MorningBlue\" type=\"submit\" value=\"Submit\" ng-click=\"vm.rateQuote(vm.FloodForm.$valid)\" />\r\n        <input id=\"btnCancel\" class=\"btn btn-MorningBlue\" type=\"button\" value=\"Clear/New Quote\" ng-click=\"vm.reset()\" />-->\r\n\r\n                  <input id=\"btnSubmit\" class=\"btn btn-MorningBlue\" [disabled]=\"isDisabledCounty()\" type=\"submit\" value=\"Submit\" />\r\n                  <input id=\"btnCancel\" class=\"btn btn-MorningBlue\" type=\"button\" value=\"Clear/New Quote\" (click)=\"resetForm()\" />\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n</form>\r\n<div id=\"overlay\" *ngIf=\"showSpinner\">\r\n  <div style=\"position:absolute;top:50%;left:50%;\">\r\n    <img src=\"../../assets/images/loading_2x.gif\" />\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/billing/billing.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/billing/billing.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- TODO change display: none to ngIf -->\r\n<div class=\"row-margin\">\r\n  <h2>Quote Summary & Payment</h2>\r\n</div>\r\n<div class=\"row-margin\">\r\n  <div *ngIf=\"isExpired\" style=\"display: inline-block\">\r\n    <span style=\"font-size: 24px; color: red\">This quote is expired and must be requoted.</span>\r\n    <input type=\"button\" class=\"btn btn-xs btn-warning\" value=\"Requote\" (click)=\"requote()\" />\r\n  </div>\r\n</div>\r\n<div class=\"row row-margin\">\r\n  <div class=\"col-lg-12\" align=\"center\" id=\"divBillingInformation\" [ngClass]=\"isPremier?'div-premier' : 'div-nonpremier'\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12 text-left\">\r\n        <div>\r\n          <strong> Quote:</strong> {{quoteNum}}\r\n        </div>\r\n        <div>\r\n          <strong>Client Name:</strong> {{clientInformation}}\r\n        </div>\r\n        <div>\r\n          <strong>Risk Address:</strong> {{riskAddress}}\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-5\">\r\n        <table class=\"table-sm text-right\" style=\"width: 95%\">\r\n          <tr>\r\n            <td>\r\n              <strong>Coverage Effective:</strong>\r\n            </td>\r\n            <td>{{billingInformation.EffectiveDate | date : 'MM/dd/yyyy'}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td>\r\n              <strong>Premium:</strong>\r\n            </td>\r\n            <td>{{billingInformation.Premium | currency}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td>\r\n              <strong>Tax:</strong>\r\n            </td>\r\n            <td>{{billingInformation.Tax | currency}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td>\r\n              <strong>{{billingInformation.FeeText}}</strong>\r\n            </td>\r\n            <td>{{billingInformation.Fee | currency}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td>\r\n              <strong>Total Due:</strong>\r\n            </td>\r\n            <td style=\"border-top: 1px solid black; font-weight: bold;\">{{billingInformation.TotalDue | currency}}</td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n      <div class=\"col-lg-5\">\r\n        <table class=\"table-sm text-right\" style=\"width: 95%\">\r\n          <tr>\r\n            <td>\r\n              <strong>Coverage/Limits:</strong>\r\n            </td>\r\n            <td>{{billingInformation.Option}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td>Dwelling:</td>\r\n            <td>{{billingInformation.Dwelling | currency : 'USD' : '$' : '1.0-0'}}</td>\r\n          </tr>\r\n          <tr *ngIf=\"billingInformation.PersonalProperty != 0\">\r\n            <td>Personal Property:</td>\r\n            <td>{{billingInformation.PersonalProperty | currency : 'USD' : '$' : '1.0-0'}}</td>\r\n          </tr>\r\n          <tr *ngIf=\"billingInformation.OtherStructures != 0\">\r\n            <td>Other Structures:</td>\r\n            <td>{{billingInformation.OtherStructures | currency : 'USD' : '$' : '1.0-0'}}</td>\r\n          </tr>\r\n          <tr *ngIf=\"billingInformation.LossOfUse != 0\">\r\n            <td>Loss of Use:</td>\r\n            <td>{{billingInformation.LossOfUse | currency : 'USD' : '$' : '1.0-0'}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td>\r\n              <strong>Deductible:</strong>\r\n            </td>\r\n            <td *ngIf=\"billingInformation.LossOfUse == 0 && billingInformation.OtherStructures == 0 && billingInformation.PersonalProperty == 0\">{{billingInformation.Deductible | currency : 'USD' : '$' : '1.0-0'}}</td>\r\n            <td *ngIf=\"billingInformation.LossOfUse != 0 || billingInformation.OtherStructures != 0 || billingInformation.PersonalProperty != 0\">{{billingInformation.Deductible | currency : 'USD' : '$' : '1.0-0'}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td></td>\r\n            <td>\r\n              <input type=\"button\" class=\"btn btn-xs btn-warning\" value=\"Change Option\" (click)=\"removeQuoteOption()\" />\r\n            </td>\r\n          </tr>\r\n        </table>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"row row-margin\">\r\n  <div class=\"col-lg-6\">\r\n    <div class=\"form-group\">\r\n      <label>Select Billing Type</label><br />\r\n      <label *ngFor=\"let bType of billingTypes\" class=\"form-check-inline\">\r\n        <input name=\"billingType\"\r\n               type=\"radio\"\r\n               value=\"{{bType}}\"\r\n               class=\"form-check-inline\"\r\n               [(ngModel)]=\"billingType\" />\r\n        {{bType}}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<hr />\r\n\r\n<div class=\"row row-margin\" *ngIf=\"showBillingType('Mortgagee')\">\r\n  <div class=\"row row-margin col-lg-12\">\r\n    <strong class=\"font-size-xlarge\">Current Mortgagee(s)</strong>\r\n    <input type=\"submit\" class=\"btn btn-xs btn-warning\" value=\"Update Mortgagee Information\" (click)=\"updateMortgagee()\" />\r\n  </div>\r\n  <div class=\"row row-margin col-lg-12 pad-left-0\">\r\n    <div class=\"col-md-4 pull-left\" *ngFor=\"let x of mortgageesForQuote\">\r\n      <table>\r\n        <thead></thead>\r\n        <tbody>\r\n          <tr>\r\n            <td class=\"font-weight-bold\">Loan Number:&nbsp;</td>\r\n            <td>{{x.LoanNumber}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td class=\"font-weight-bold\">Name:&nbsp;</td>\r\n            <td>{{x.Name1}}</td>\r\n          </tr>\r\n          <tr *ngIf=\"x.Name2\">\r\n            <td></td>\r\n            <td>{{x.Name2}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td class=\"font-weight-bold\">Street:&nbsp;</td>\r\n            <td>{{x.Street1}}</td>\r\n          </tr>\r\n          <tr *ngIf=\"x.Street2\">\r\n            <td></td>\r\n            <td>{{x.Street2}}</td>\r\n          </tr>\r\n          <tr>\r\n            <td class=\"font-weight-bold\">City, State Zip:&nbsp;</td>\r\n            <td>{{x.City}}, {{x.State.Code}} {{x.Zip}}</td>\r\n          </tr>\r\n          <tr *ngIf=\"!x.Name2\">\r\n            <td colspan=\"2\">&nbsp;</td>\r\n          </tr>\r\n          <tr *ngIf=\"!x.Street2\">\r\n            <td colspan=\"2\">&nbsp;</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <div class=\"row row-margin padding-left-15\">\r\n    <span *ngIf=\"mortgageesForQuote == false\">No current mortgagee information</span>\r\n    <input type=\"submit\" class=\"btn btn-MorningBlue\" [disabled]=\"disabledCounty\" value=\"Submit\" *ngIf=\"mortgageesForQuote != false && isExpired == false && pastEffective == false && !effectiveDateOneWeek && flgPrimaryMort == true && role == 'agent' && agencyNumber != 'TWFGHM'\" (click)=\"bindQuote(true)\" />\r\n  </div>\r\n</div>\r\n<div id=\"divAch\" class=\"row row-margin\" *ngIf=\"showBillingType('ACH')\">\r\n  <form #f=\"ngForm\" name=\"achForm\" [mustMatch]=\"['accountNumber', 'retypedAccountNum']\" [routingMatch]=\"['routingNumber', 'retypedRoutingNum']\">\r\n    <div class=\"col-lg-6\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n          <div class=\"form-group\">\r\n            <label for=\"accountName\">Name on Account:</label>\r\n            <input id=\"accountName\" name=\"accountName\" type=\"text\" class=\"form-control\" [(ngModel)]=\"achInformation.accountName\" #accountName=\"ngModel\" [required]=\"billingType == 'ACH'\">\r\n            <div *ngIf=\"accountName.invalid && (accountName.dirty || accountName.touched) || (f.submitted && accountName.invalid)\">\r\n              <div class=\"error-message\">*Required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-6\">\r\n          <div class=\"form-group\">\r\n            <label for=\"bankName\">Bank Name:</label>\r\n            <input id=\"bankName\" name=\"bankName\" type=\"text\" class=\"form-control\" [(ngModel)]=\"achInformation.bankName\" #bankName=\"ngModel\" [required]=\"billingType == 'ACH'\">\r\n            <div *ngIf=\"bankName.invalid && (bankName.dirty || bankName.touched) || (f.submitted && bankName.invalid)\">\r\n              <div class=\"error-message\">*Required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-6\">\r\n          <div class=\"form-group\">\r\n            <label for=\"accountType\">Account Type:</label>\r\n            <select id=\"accountType\" name=\"accountType\" class=\"form-control\" [(ngModel)]=\"achInformation.accountType\" #accountType=\"ngModel\" [required]=\"billingType == 'ACH'\">\r\n              <option value=\"0\">Checking</option>\r\n              <option value=\"1\">Savings</option>\r\n            </select>\r\n            <div *ngIf=\"accountType.invalid && (accountType.dirty || accountType.touched) || (f.submitted && accountType.invalid)\">\r\n              <div class=\"error-message\">*Required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-6\">\r\n          <div class=\"form-group\">\r\n            <label for=\"routingNumber\">Routing Number:</label>\r\n            <input id=\"routingNumber\" name=\"routingNumber\" type=\"text\" class=\"form-control\" [(ngModel)]=\"achInformation.routingNumber\" #routingNumber=\"ngModel\" [required]=\"billingType == 'ACH'\">\r\n            <div *ngIf=\"routingNumber.invalid && (routingNumber.dirty || routingNumber.touched) || (f.submitted && routingNumber.invalid)\">\r\n              <div class=\"error-message\">*Required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-6\">\r\n          <div class=\"form-group\">\r\n            <label for=\"retypedRoutingNum\">Re-type Routing Number:</label>\r\n            <input id=\"retypedRoutingNum\" name=\"retypedRoutingNum\" type=\"text\" class=\"form-control\" [(ngModel)]=\"achInformation.retypedRoutingNum\" #retypedRoutingNum=\"ngModel\" [required]=\"billingType == 'ACH'\">\r\n            <div *ngIf=\"retypedRoutingNum.invalid && (retypedRoutingNum.dirty || retypedRoutingNum.touched) || (f.submitted && retypedRoutingNum.invalid)\">\r\n              <div class=\"error-message\" *ngIf=\"retypedRoutingNum.errors.required\">*Required</div>\r\n              <div *ngIf=\"retypedRoutingNum.errors.mustMatch\" class=\"error-message\">*Routing Number does not match</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-6\">\r\n          <div class=\"form-group\">\r\n            <label for=\"accountNumber\">Account Number:</label>\r\n            <input id=\"accountNumber\" name=\"accountNumber\" type=\"password\" class=\"form-control\" [(ngModel)]=\"achInformation.accountNumber\" #accountNumber=\"ngModel\" [required]=\"billingType == 'ACH'\">\r\n            <div *ngIf=\"accountNumber.invalid && (accountNumber.dirty || accountNumber.touched) || (f.submitted && accountNumber.invalid)\">\r\n              <div class=\"error-message\">*Required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-6\">\r\n          <div class=\"form-group\">\r\n            <label for=\"retypedAccountNum\">Re-type Account Number:</label>\r\n            <input id=\"retypedAccountNum\" name=\"retypedAccountNum\" type=\"password\" class=\"form-control\" [(ngModel)]=\"achInformation.retypedAccountNum\" #retypedAccountNum=\"ngModel\" [required]=\"billingType == 'ACH'\">\r\n            <div *ngIf=\"retypedAccountNum.invalid && (retypedAccountNum.dirty || retypedAccountNum.touched) || (f.submitted && retypedAccountNum.invalid)\">\r\n              <div *ngIf=\"retypedAccountNum.errors.required\" class=\"error-message\">*Required</div>\r\n              <div *ngIf=\"retypedAccountNum.errors.mustMatch\" class=\"error-message\">*Account Number does not match</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <input type=\"submit\" name=\"btnAchSubmit\" class=\"btn btn-MorningBlue\" [disabled]=\"disabledCounty\" value=\"Submit\" *ngIf=\"f.form.valid && isExpired==false && pastEffective==false && !effectiveDateOneWeek && role == 'agent' && achInformation.retypedAccountNum === achInformation.accountNumber && achInformation.retypedRoutingNum === achInformation.routingNumber && agencyNumber != 'TWFGHM'\" (click)=\"bindQuote(f.form.valid)\" />\r\n    </div>\r\n    <div id=\"AchErrorsWrapper\" class=\"col-lg-4\" *ngIf=\"achErrors != ''\">\r\n      <div id=\"AchErrors\" class=\"col-lg-12 alert alert-warning\" [innerHTML]=\"achErrors\"></div>\r\n    </div>\r\n  </form>\r\n</div>\r\n<div *ngIf=\"pastEffective\">\r\n  <span style=\"color:red\">Policy Effective Date must not be in the past.</span>\r\n</div>\r\n<div *ngIf=\"effectiveDateOneWeek\">\r\n  <span style=\"color:red\">Effective date must be 7 or more days from today.</span>\r\n</div>\r\n<div id=\"overlay\" *ngIf=\"showSpinner\">\r\n  <div style=\"position:absolute;top:50%;left:50%;\">\r\n    <img src=\"../../assets/images/loading_2x.gif\" />\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/drag-and-drop-file/drag-and-drop-file.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/drag-and-drop-file/drag-and-drop-file.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\"  appDragAndDrop (fileDropped)=\"onFileDropped($event)\">\n  <input type=\"file\"  #fileDropRef id=\"fileDropRef\" multiple (change)=\"fileBrowseHandler($event.target.files)\" />\n  <img src=\"assets/images/ic-upload-file.svg\" alt=\"\" width=\"30px\" height=\"30px\">\n  <h3>Drag and drop file here</h3>\n  <h3>or</h3>\n  <label for=\"fileDropRef\">Browse for file</label>\n</div>\n<div class=\"files-list\">\n  <div class=\"single-file\" *ngFor=\"let file of files; let i = index\">\n    <select id=\"{{i}}\" #fileSelect [disabled]=\"this.disabled\" [hidden]=\"this.dynamicSelectFiles.length <= 0\" class=\"form-control\" style=\"width: 30%;\" (change)=\"onSelectType($event.target.value, i)\" [value]=\"this.getSelectTypeValue(i)\">\n      <option disabled hidden [value]=\"0\">Select</option>\n      <option *ngFor=\"let file of this.selectFiles\" value={{file.value}}>\n        {{file.text}}\n      </option>\n    </select>\n    <img src=\"assets/images/ic-file.svg\" width=\"45px\" alt=\"file\">\n    <div class=\"info\">\n      <h4 class=\"name\">\n        {{ file?.file?.name }}\n      </h4>\n      <p class=\"size\">\n        {{ formatBytes(file?.file?.size) }}\n      </p>\n      <app-progress-bar [progress]=\"file?.file?.progress\"></app-progress-bar>\n    </div>\n    <img src=\"assets/images/ic-download.svg\" class=\"delete\" width=\"20px\" alt=\"file\" (click)=\"downloadFile(i)\">\n    <img src=\"assets/images/ic-delete-file.svg\" class=\"delete\" width=\"20px\" alt=\"file\" (click)=\"deleteFile(i)\" [hidden]=\"this.disabled == true\">\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.html":
/*!**********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.html ***!
  \**********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p mat-dialog-title>Edit Moratorium Message</p>\r\n<mat-dialog-content class=\"mat-typography\">\r\n  <mat-form-field appearance=\"fill\">\r\n    <mat-label>Moratorium message here...</mat-label>\r\n    <textarea matInput [(ngModel)]=\"data\"></textarea>\r\n  </mat-form-field>\r\n</mat-dialog-content>\r\n<mat-dialog-actions align=\"end\">\r\n  <button mat-raised-button mat-dialog-close (click)=\"onCancel()\">Cancel</button>\r\n  <button mat-raised-button color=\"primary\" [mat-dialog-close]=\"data\" cdkFocusInitial (click)=\"onSave()\">Save</button>\r\n</mat-dialog-actions>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/moratorium-management/moratorium-management.component.html":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/moratorium-management/moratorium-management.component.html ***!
  \******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"d-flex pb-3 justify-content-end\">\n  <button mat-raised-button color=\"primary\" (click)=\"openMoratoriumMessageDialog()\">Edit Moratorium Message</button>\n</div>\n<div class=\"mat-elevation-z8\">\n  <!-- Filters -->\n  <div class=\"d-flex justify-content-between align-items-center p-3\">\n    <mat-form-field>\n      <!-- Search Filter by Name -->\n      <input matInput [(ngModel)]=\"countyName\" (keyup)=\"applyFilterCounty('county', $event.target.value)\" placeholder=\"Filter\">\n    </mat-form-field>\n    <!-- Search Filter by Activity -->\n    <ng-container class=\"activityFilter\">\n      <mat-radio-group [(ngModel)]=\"activityFilter\" (change)=\"applyFilterCounty('active', $event.value)\">\n        <mat-radio-button value=\"all\" checked=\"true\">All</mat-radio-button>\n        <mat-radio-button value=\"true\" >Active</mat-radio-button>\n        <mat-radio-button value=\"false\">Inactive</mat-radio-button>\n      </mat-radio-group>\n    </ng-container>\n  </div>\n\n  <!-- Counties Table -->\n  <section>\n    <table mat-table [dataSource]=\"dataSource\">\n      <!-- County Column -->\n      <ng-container matColumnDef=\"CountyName\">\n          <th mat-header-cell *matHeaderCellDef> County </th>\n          <td mat-cell *matCellDef=\"let element\"> {{ element.CountyName }} </td>\n      </ng-container>\n      <!-- State Column -->\n      <ng-container matColumnDef=\"StateName\">\n          <th mat-header-cell *matHeaderCellDef> State </th>\n          <td mat-cell *matCellDef=\"let element\"> {{ element.StateName }} </td>\n      </ng-container>\n      <!-- Checkbox Column -->\n      <ng-container matColumnDef=\"flgActive\">\n          <th mat-header-cell *matHeaderCellDef> Active </th>\n          <td mat-cell *matCellDef=\"let row\" (click)=\"$event.stopPropagation()\">\n            <mat-checkbox (click)=\"$event.stopPropagation()\"\n                          (change)=\"$event ? addToUpdatedCounties(row, $event) : null\"\n                          [checked]=\"selection.isSelected(row)\">\n            </mat-checkbox>\n          </td>\n      </ng-container>\n      <!-- Headers ?? -->\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\" (click)=\"selection.toggle(row)\">\n      </tr>\n    </table>\n    <!-- Table Paginator -->\n    <mat-paginator [pageSizeOptions]=\"[10, 20, 30]\" showFirstLastButtons></mat-paginator>\n  </section>\n</div>\n<div class=\"d-flex pt-3 justify-content-end\">\n  <button mat-raised-button color=\"primary\" (click)=\"updateCounties()\">Submit Changes</button>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/mortgagee/mortgagee.component.html":
/*!******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/mortgagee/mortgagee.component.html ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div style=\"padding-bottom: 15px;\">\r\n  <div class=\"row row-margin margin-left-0\">\r\n    <div class=\"div-nonpremier col-lg-12\">\r\n      <div>\r\n        <strong> Quote:</strong> <span> {{quoteNum}}</span>\r\n      </div>\r\n      <div>\r\n        <strong>Client Name:</strong> {{clientInformation}}\r\n      </div>\r\n      <div>\r\n        <strong>Risk Address:</strong> {{riskAddress}}\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-left-add-20\">\r\n    <div class=\"row row-margin\">\r\n      <h2>Mortgagee(s)</h2>\r\n    </div>\r\n  </div>\r\n  <div class=\"row row-margin margin-left-add-20\">\r\n    <div class=\"row\" *ngIf=\"mortgageesForQuote?.length > 0\">\r\n      <div class=\"row col-lg-12\">\r\n        <form #editForm=\"ngForm\" name=\"mortgageeForm\">\r\n          <table class=\"table table-bordered table-hover table-lg table-width\">\r\n            <tr style=\"font-weight: bold\">\r\n              <td style=\"width: 12%; padding: .50rem\">Loan Number</td>\r\n              <td style=\"width: 10%\">Mortgagee Name</td>\r\n              <td style=\"width: 10%\">Mortgagee Name (Cont)</td>\r\n              <td style=\"width: 12%\">Address</td>\r\n              <td style=\"width: 8%\">Address Continued</td>\r\n              <td style=\"width: 10%\">City</td>\r\n              <td style=\"width: 8%\">State</td>\r\n              <td style=\"width: 8%\">Zip</td>\r\n              <td style=\"width: 5%\">Primary</td>\r\n              <td style=\"width: 14%\">Edit</td>\r\n            </tr>\r\n            <tr name=\"rowform\" *ngFor=\"let x of mortgageesForQuote; let i = index;\">\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.LoanNumber}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <input id=\"loanNumber{{i}}\" name=\"loanNumber{{i}}\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].LoanNumber\" #loanNumber=\"ngModel\" required />\r\n                  <div *ngIf=\"loanNumber.invalid && (loanNumber.dirty || loanNumber.touched) || (editForm.submitted && loanNumber.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.Name1}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <input id=\"mortName{{i}}\" name=\"mortName{{i}}\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].Name1\" #mortName=\"ngModel\" required />\r\n                  <div *ngIf=\"mortName.invalid && (mortName.dirty || mortName.touched) || (editForm.submitted && mortName.invalid)\">\r\n                    <div *ngIf=\"mortName.errors.required\" class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.Name2}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <input id=\"mortName2{{i}}\" name=\"mortName2{{i}}\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].Name2\" />\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.Street1}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <input id=\"street{{i}}\" name=\"street{{i}}\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].Street1\" #street=\"ngModel\" required />\r\n                  <div *ngIf=\"street.invalid && (street.dirty || street.touched) || (editForm.submitted && street.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.Street2}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <input id=\"street2{{i}}\" name=\"street2{{i}}\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].Street2\" />\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.City}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <input id=\"city{{i}}\" name=\"city{{i}}\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].City\" #city=\"ngModel\" required />\r\n                  <div *ngIf=\"city.invalid && (city.dirty || city.touched) || (editForm.submitted && city.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.State.Code}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <select class=\"form-control\" name=\"state\" [(ngModel)]=\"mortgageesForQuote[i].State.Id\" #mortState=\"ngModel\" required>\r\n                    <option *ngFor=\"let state of statesDropDown\" [ngValue]=\"state.Id\">{{state.Code}}</option>\r\n                  </select>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{x.Zip}}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <input id=\"zip{{i}}\" name=\"zip{{i}}\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].Zip\" #zip=\"ngModel\" pattern=\"^\\d{5}([\\-]\\d{4})?$\" required />\r\n                  <div *ngIf=\"zip.invalid && (zip.dirty || zip.touched) || (editForm.submitted && zip.invalid)\">\r\n                    <div class=\"error-message\">required</div>\r\n                  </div>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit != i\">{{ x.FlgPrimary && 'Yes' || 'No' }}</div>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <label><input id=\"primary{{i}}\" name=\"primary{{i}}\" type=\"checkbox\" class=\"form-control\" [(ngModel)]=\"mortgageesForQuote[i].FlgPrimary\" #primary=\"ngModel\" /></label>\r\n                </div>\r\n              </td>\r\n              <td>\r\n                <div *ngIf=\"rowToEdit == i\">\r\n                  <button class=\"btn btn-MorningBlue\" type=\"submit\" title=\"Submit\" (click)=\"editForm.valid && updateMortgagee(mortgageesForQuote[i])\">Save</button>\r\n                </div>\r\n                <div *ngIf=\"rowToEdit != i\">\r\n                  <button class=\"btn btn-MorningBlue\" type=\"button\" (click)=\"showEdit(i)\">Edit</button>&nbsp;&nbsp;\r\n                  <button class=\"btn btn-danger\" (click)=\"removeMortgagee(mortgageesForQuote[i])\">Delete</button>\r\n                </div>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </form>\r\n      </div>\r\n      <br />\r\n      <div class=\"col-lg-12\" *ngIf=\"showErrorMessage\">\r\n        <p style=\"color: red;\">{{errorMessage}}</p>\r\n        <br />\r\n      </div>\r\n    </div>\r\n    <div class=\"row row-margin\">\r\n      <h3 *ngIf=\"isExpired\" style=\"color: red\">Quote is expired.</h3>\r\n    </div>\r\n    <div *ngIf=\"toggle === 'one'\" class=\"margin-left-add-20\">\r\n      Would you like to add a Primary Mortgagee to this policy?\r\n      <br />\r\n      <br />\r\n      <input type=\"button\" class=\"btn btn-MorningBlue\" value=\"Yes\" (click)=\"toggleData('two')\" />\r\n    </div>\r\n    <div *ngIf=\"toggle === 'three'\" class=\"margin-left-add-20\">\r\n      Would you like to add another Mortgagee to this policy?\r\n      <br />\r\n      <br />\r\n      <input type=\"button\" class=\"btn btn-MorningBlue\" value=\"Yes\" (click)=\"toggleData('four')\" />\r\n    </div>\r\n    <div *ngIf=\"toggle === 'two' || toggle === 'four'\" class=\"row col-lg-12 margin-left-5\">\r\n      <form #f=\"ngForm\" name=\"mortgageeForm\" (onSubmit)=\"f.form.valid\">\r\n        <div class=\"row col-lg-10\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">Mortgagee Name</label>\r\n            <input type=\"text\" id=\"mort1\" name=\"mort1\" class=\"form-control input-txt-width\" [(ngModel)]=\"mortgagee.name1\" #mort1=\"ngModel\" required />\r\n            <div *ngIf=\"mort1.invalid && (mort1.dirty || mort1.touched) || (f.submitted && mort1.invalid)\">\r\n              <div class=\"error-message\">required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row col-lg-10\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">Mortgagee Name (Cont)</label>\r\n            <input type=\"text\" id=\"mort2\" name=\"mort2\" class=\"form-control input-txt-width\" [(ngModel)]=\"mortgagee.name2\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"row col-lg-10\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">Loan Number</label>\r\n            <input type=\"text\" class=\"form-control input-txt-width\" id=\"loanNumber\" name=\"loanNumber\" [(ngModel)]=\"mortgagee.loanNumber\" #loanNum=\"ngModel\" required />\r\n            <div *ngIf=\"loanNum.invalid && (loanNum.dirty || loanNum.touched) || (f.submitted && loanNum.invalid)\">\r\n              <div class=\"error-message\">required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row col-lg-10\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">Street</label>\r\n            <input id=\"mortStreet11\" name=\"mortStreet11\" type=\"text\" class=\"form-control input-txt-width\" [(ngModel)]=\"mortgagee.street1\" #mortStreet11=\"ngModel\" required />\r\n            <div *ngIf=\"mortStreet11.invalid && (mortStreet11.dirty || mortStreet11.touched) || (f.submitted && mortStreet11.invalid)\">\r\n              <div class=\"error-message\">required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row col-lg-10\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">Street (Cont)</label>\r\n            <input name=\"street2\" type=\"text\" class=\"form-control input-txt-width\" [(ngModel)]=\"mortgagee.street2\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-lg-3\">\r\n            <div class=\"form-group\">\r\n              <label class=\"label-for-mortgage\">City</label>\r\n              <input type=\"text\" name=\"city\" class=\"form-control\" [(ngModel)]=\"mortgagee.city\" #mortCity=\"ngModel\" required=\"required\" />\r\n              <div *ngIf=\"mortCity.invalid && (mortCity.dirty || mortCity.touched) || (f.submitted && mortCity.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-3\">\r\n            <div class=\"form-group\">\r\n              <label class=\"label-for-mortgage\">State</label>\r\n              <select class=\"form-control\" name=\"state\" [(ngModel)]=\"mortgagee.stateId\" #mortState=\"ngModel\" required>\r\n                <option *ngFor=\"let state of statesDropDown\" [ngValue]=\"state.Id\">{{state.Code}}</option>\r\n              </select>\r\n              <div *ngIf=\"mortState.invalid && (mortState.dirty || mortState.touched) || (f.submitted && mortState.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-3\">\r\n            <div class=\"form-group\">\r\n              <label class=\"label-for-mortgage\">Zip</label>\r\n              <input name=\"zip\" type=\"text\" class=\"form-control\" [(ngModel)]=\"mortgagee.zip\" #mortZip=\"ngModel\" required pattern=\"^\\d{5}([\\-]\\d{4})?$\">\r\n              <div *ngIf=\"mortZip.invalid && (mortZip.dirty || mortZip.touched) || (f.submitted && mortZip.invalid)\">\r\n                <div *ngIf=\"mortZip.errors.required\" class=\"error-message\">required</div>\r\n                <div *ngIf=\"mortZip.errors.pattern\" class=\"error-message\">invalid zip code</div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row col-lg-12\">\r\n          <div class=\"form-group\">\r\n            <input type=\"button\" name=\"cancel\" class=\"btn btn-MorningBlue float-left\" value=\"Cancel\" (click)=\"toggle === 'two'? toggleData('one'):toggleData('three')\" />\r\n          </div>\r\n          <div class=\"col-lg-6\"></div>\r\n          <div class=\"form-group\">\r\n            <input type=\"submit\" name=\"add\" class=\"btn btn-MorningBlue float-right\" value=\"Add Mortgagee\" (click)=\"addMortgagee(f.form.valid);\" />\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row margin-left-add-20\">\r\n    <div class=\"row row-margin\">\r\n      <h2>Additional Insured(s)</h2>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row row-margin col-lg-12\" *ngIf=\"additionalInsured?.length > 0\">\r\n    <form #aif=\"ngForm\" name=\"aiForm\" (onSubmit)=\"aif.form.valid\">\r\n      <table class=\"table table-bordered table-hover table-lg table-width\">\r\n        <tr style=\"font-weight: bold\">\r\n          <td style=\"width: 10%\">Additional Insured Type</td>\r\n          <td style=\"width: 10%\">First Name</td>\r\n          <td style=\"width: 10%\">Last Name</td>\r\n          <td style=\"width: 10%\">HOA/Corporation Name</td>\r\n          <td style=\"width: 14%\">Address</td>\r\n          <td style=\"width: 10%\">Address Line 2</td>\r\n          <td style=\"width: 10%\">City</td>\r\n          <td style=\"width: 8%\">State</td>\r\n          <td style=\"width: 8%\">Zip</td>\r\n          <td style=\"width: 10%\">Edit</td>\r\n        </tr>\r\n        <tr name=\"aiRow\" *ngFor=\"let y of additionalInsured; let j = index;\">\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{mapAdditionalInsured(additionalInsured[j]?.AdditionalInsuredTypeId)}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <select class=\"form-control\" name=\"aiType{{j}}\" [(ngModel)]=\"additionalInsured[j].AdditionalInsuredTypeId\" #addInType=\"ngModel\" (change)=\"aiTypeChange(j,additionalInsured[j].AdditionalInsuredTypeId)\" required>\r\n                <option *ngFor=\"let aiType of additionalInsuredTypeDropDown\" [ngValue]=\"aiType.Id\">{{aiType.Value}}</option>\r\n              </select>\r\n              <div *ngIf=\"addInType.invalid && (addInType.dirty || addInType.touched) || (aif.submitted && addInType.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{additionalInsured[j].FirstName}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <input type=\"text\"\r\n                     class=\"form-control\"\r\n                     id=\"aiFirstName{{j}}\"\r\n                     name=\"aiFirstName{{j}}\"\r\n                     [(ngModel)]=\"additionalInsured[j].FirstName\"\r\n                     #addInFirstName=\"ngModel\"\r\n                     [required]=\"additionalInsured[j].AdditionalInsuredTypeId == 1\"\r\n                     [disabled]=\"additionalInsured[j].AdditionalInsuredTypeId != 1\" />\r\n              <div *ngIf=\"addInFirstName.invalid && (addInFirstName.dirty || addInFirstName.touched) || (aif.submitted && addInFirstName.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{additionalInsured[j].LastName}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <input type=\"text\"\r\n                     class=\"form-control\"\r\n                     id=\"aiLastName{{j}}\"\r\n                     name=\"aiLastName{{j}}\"\r\n                     [(ngModel)]=\"additionalInsured[j].LastName\"\r\n                     #addInLastName=\"ngModel\"\r\n                     [required]=\"additionalInsured[j].AdditionalInsuredTypeId == 1\"\r\n                     [disabled]=\"additionalInsured[j].AdditionalInsuredTypeId != 1\" />\r\n              <div *ngIf=\"addInLastName.invalid && (addInLastName.dirty || addInLastName.touched) || (aif.submitted && addInLastName.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{additionalInsured[j].EntityName}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <input type=\"text\"\r\n                     class=\"form-control\"\r\n                     id=\"entity{{j}}\"\r\n                     name=\"entity{{j}}\"\r\n                     [(ngModel)]=\"additionalInsured[j].EntityName\"\r\n                     #entityName=\"ngModel\"\r\n                     [required]=\"(additionalInsured[j].AdditionalInsuredTypeId == 2 || additionalInsured[j].AdditionalInsuredTypeId == 3) ? 'required' : null\"\r\n                     [disabled]=\"additionalInsured[j].AdditionalInsuredTypeId == 1\" />\r\n              <div *ngIf=\"entityName.invalid && (entityName.dirty || entityName.touched) || (aif.submitted && entityName.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{additionalInsured[j].AddressLine1}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <input type=\"text\" class=\"form-control\" id=\"aiAddress1{{j}}\" name=\"aiAddress1{{j}}\" [(ngModel)]=\"additionalInsured[j].AddressLine1\" #aiAddress1=\"ngModel\" required />\r\n              <div *ngIf=\"aiAddress1.invalid && (aiAddress1.dirty || aiAddress1.touched) || (aif.submitted && aiAddress1.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{additionalInsured[j].AddressLine2}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <input type=\"text\" class=\"form-control\" id=\"aiAddress2{{j}}\" name=\"aiAddress2{{j}}\" [(ngModel)]=\"additionalInsured[j].AddressLine2\" />\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{additionalInsured[j].City}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <input type=\"text\" class=\"form-control\" id=\"aiCity{{j}}\" name=\"aiCity{{j}}\" [(ngModel)]=\"additionalInsured[j].City\" #aiCity=\"ngModel\" required />\r\n              <div *ngIf=\"aiCity.invalid && (aiCity.dirty || aiCity.touched) || (aif.submitted && aiCity.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{statesDropDown[additionalInsured[j]?.StateId - 1]?.Code}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <select class=\"form-control\" name=\"aiState\" [(ngModel)]=\"additionalInsured[j].StateId\" #aiStates=\"ngModel\" required>\r\n                <option *ngFor=\"let state of statesDropDown\" [ngValue]=\"state.Id\">{{state.Code}}</option>\r\n              </select>\r\n              <div *ngIf=\"aiStates.invalid && (aiStates.dirty || aiStates.touched) || (aif.submitted && aiStates.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td>\r\n            <div *ngIf=\"aiRowToEdit != j\">{{additionalInsured[j].ZipCode}}</div>\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <input type=\"text\" class=\"form-control\" id=\"aiZip{{j}}\" name=\"aiZip{{j}}\" [(ngModel)]=\"additionalInsured[j].ZipCode\" #aiZip=\"ngModel\" pattern=\"^\\d{5}([\\-]\\d{4})?$\" required />\r\n              <div *ngIf=\"aiZip.invalid && (aiZip.dirty || aiZip.touched) || (aif.submitted && aiZip.invalid)\">\r\n                <div class=\"error-message\">required</div>\r\n                <div *ngIf=\"aiZip.errors.pattern\" class=\"error-message\">XXXXX or XXXXX-XXXX format only</div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n          <td style=\"white-space: nowrap\">\r\n            <div *ngIf=\"aiRowToEdit == j\">\r\n              <button class=\"btn btn-MorningBlue\" type=\"submit\" title=\"Submit\" (click)=\"updateAdditionalInsured(aif.form.valid)\">Save</button>\r\n              <button class=\"btn btn-danger\" (click)=\"cancelAdditionalInsured()\">Cancel</button>\r\n            </div>\r\n            <div *ngIf=\"aiRowToEdit != j\">\r\n              <button class=\"btn btn-MorningBlue\" type=\"button\" (click)=\"editAi(j,aif.form.valid)\">Edit</button>\r\n              <button class=\"btn btn-danger\" (click)=\"removeAdditionalInsured(j)\">Delete</button>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </form>\r\n  </div>\r\n  <div class=\"row row-margin margin-left-10\">\r\n    <div class=\"\" *ngIf=\"!(additionalInsured?.length > 0) && addAdditionalInsured == false\">\r\n      Would you like to add an Additional Insured to this policy?\r\n      <br />\r\n      <br />\r\n      <!--<input type=\"button\" class=\"btn btn-MorningBlue\" value=\"Yes\" (click)=\"addAdditionalInsuredEditableRow()\" [disabled]=\"aiRowToEdit != null\" />-->\r\n      <input type=\"button\" class=\"btn btn-MorningBlue\" value=\"Yes\" (click)=\"addAdditionalInsured = true;\" [disabled]=\"aiRowToEdit != null\" />\r\n    </div>\r\n    <div class=\"\" *ngIf=\"additionalInsured?.length > 0\">\r\n      <button class=\"btn btn-MorningBlue row-margin\" (click)=\"addAdditionalInsured = true\" *ngIf=\"additionalInsured?.length > 0 && additionalInsured?.length < 2\" [disabled]=\"aiRowToEdit != null\">Add Additional Insured</button>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"addAdditionalInsured == true;\" class=\"row col-lg-12 margin-left-0\">\r\n    <form #aiForm=\"ngForm\" name=\"aiForm\" (onSubmit)=\"aiForm.form.valid\">\r\n      <div class=\"form-group\">\r\n        <label class=\"label-for-mortgage\">Additional Insured Type</label>\r\n        <select class=\"form-control input-txt-width\" name=\"aiType\" [(ngModel)]=\"additionalInsuredNew.typeId\" #typeId=\"ngModel\" (change)=\"aiTypeChange(-1,additionalInsuredNew.typeId)\" required>\r\n          <option *ngFor=\"let aiType of additionalInsuredTypeDropDown\" [ngValue]=\"aiType.Id\">{{aiType.Value}}</option>\r\n        </select>\r\n        <div *ngIf=\"typeId.invalid && (typeId.dirty || typeId.touched) || (aiForm.submitted && typeId.invalid)\">\r\n          <div class=\"error-message\">required</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" *ngIf=\"additionalInsuredNew.typeId == 1\">\r\n        <label class=\"label-for-mortgage\">First Name</label>\r\n        <input type=\"text\"\r\n               class=\"form-control input-txt-width\"\r\n               id=\"aiFirstName\"\r\n               name=\"aiFirstName\"\r\n               [(ngModel)]=\"additionalInsuredNew.firstName\"\r\n               #addInFirstName=\"ngModel\"\r\n               [required]=\"additionalInsuredNew.typeId == 1\" />\r\n        <div *ngIf=\"addInFirstName.invalid && (addInFirstName.dirty || addInFirstName.touched) || (aiForm.submitted && addInFirstName.invalid)\">\r\n          <div class=\"error-message\">required</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" *ngIf=\"additionalInsuredNew.typeId == 1\">\r\n        <label class=\"label-for-mortgage\">Last Name</label>\r\n        <input type=\"text\"\r\n               class=\"form-control input-txt-width\"\r\n               id=\"aiLastName\"\r\n               name=\"aiLastName\"\r\n               [(ngModel)]=\"additionalInsuredNew.lastName\"\r\n               #addInLastName=\"ngModel\"\r\n               [required]=\"additionalInsuredNew.typeId == 1\" />\r\n        <div *ngIf=\"addInLastName.invalid && (addInLastName.dirty || addInLastName.touched) || (aiForm.submitted && addInLastName.invalid)\">\r\n          <div class=\"error-message\">required</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" *ngIf=\"(additionalInsuredNew.typeId == 2 ||additionalInsuredNew.typeId == 3)\">\r\n        <label class=\"label-for-mortgage\">HOA/Corporation Name</label>\r\n        <input type=\"text\"\r\n               class=\"form-control input-txt-width\"\r\n               id=\"entity\"\r\n               name=\"entity\"\r\n               [(ngModel)]=\"additionalInsuredNew.entityName\"\r\n               #entityName=\"ngModel\"\r\n               [required]=\"(additionalInsuredNew.typeId == 2 ||additionalInsuredNew.typeId == 3) ? 'required' : null\" />\r\n        <div *ngIf=\"entityName.invalid && (entityName.dirty || entityName.touched) || (aiForm.submitted && entityName.invalid)\">\r\n          <div class=\"error-message\">required</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label class=\"label-for-mortgage\">Street</label>\r\n        <input type=\"text\" class=\"form-control input-txt-width\" id=\"aiAddress1\" name=\"aiAddress1\" [(ngModel)]=\"additionalInsuredNew.street1\" #aiAddress1=\"ngModel\" required />\r\n        <div *ngIf=\"aiAddress1.invalid && (aiAddress1.dirty || aiAddress1.touched) || (aiForm.submitted && aiAddress1.invalid)\">\r\n          <div class=\"error-message\">required</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label class=\"label-for-mortgage\">Street (Cont)</label>\r\n        <input type=\"text\" class=\"form-control input-txt-width\" id=\"aiAddress2\" name=\"aiAddress2\" [(ngModel)]=\"additionalInsuredNew.street2\" />\r\n      </div>\r\n      <div class=\"row row-margin\">\r\n        <div class=\"col-lg-3\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">City</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"aiCity\" name=\"aiCity\" [(ngModel)]=\"additionalInsuredNew.city\" #aiCity=\"ngModel\" required />\r\n            <div *ngIf=\"aiCity.invalid && (aiCity.dirty || aiCity.touched) || (aiForm.submitted && aiCity.invalid)\">\r\n              <div class=\"error-message\">required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-3\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">State</label>\r\n            <select class=\"form-control\" name=\"aiState\" [(ngModel)]=\"additionalInsuredNew.stateId\" #aiStates=\"ngModel\" required>\r\n              <option *ngFor=\"let state of statesDropDown\" [ngValue]=\"state.Id\">{{state.Code}}</option>\r\n            </select>\r\n            <div *ngIf=\"aiStates.invalid && (aiStates.dirty || aiStates.touched) || (aiForm.submitted && aiStates.invalid)\">\r\n              <div class=\"error-message\">required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-3\">\r\n          <div class=\"form-group\">\r\n            <label class=\"label-for-mortgage\">Zip</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"aiZip\" name=\"aiZip\" [(ngModel)]=\"additionalInsuredNew.zip\" #aiZip=\"ngModel\" pattern=\"^\\d{5}([\\-]\\d{4})?$\" required />\r\n            <div *ngIf=\"aiZip.invalid && (aiZip.dirty || aiZip.touched) || (aiForm.submitted && aiZip.invalid)\">\r\n              <div class=\"error-message\">required</div>\r\n              <div *ngIf=\"aiZip.errors.pattern\" class=\"error-message\">XXXXX or XXXXX-XXXX format only</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row row-margin margin-left-0\">\r\n        <div class=\"form-group\">\r\n          <input type=\"button\" name=\"cancel\" class=\"btn btn-MorningBlue float-left\" value=\"Cancel\" (click)=\"addAdditionalInsured = false;\" />\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <input type=\"submit\" name=\"add\" class=\"btn btn-MorningBlue float-right\" value=\"Add Additional Insured\" (click)=\"addAdditionalInsuredEditableRow(aiForm.form.valid)\" />\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n\r\n\r\n\r\n  <!--FLORIDA FORMS-->\r\n  <div class=\"mb-5\" [hidden]=\"!this.isFlorida\">\r\n    <div class=\"row margin-left-add-20\">\r\n      <div class=\"row row-margin\">\r\n        <h2>Florida Forms</h2>\r\n      </div>\r\n    </div>\r\n    <div class=\"row margin-left-add-20\">\r\n      <div class=\"row row-margin\">\r\n        <br>\r\n        <br>\r\n        <span>Please fill out and upload the following documents or sign via DocuSign</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row mb-4\" style=\"margin-left: -6px;\" *ngIf=\"this.preBindSignStatus\">\r\n      <div class=\"col-12\">\r\n        <span style=\"font-weight: bold;\">Status:&nbsp;</span><span></span>{{this.getPreBindStatusText(this.preBindSignStatus.Status).Text}}&nbsp;<span class=\"dot\" [ngStyle]=\"{'background-color': this.getPreBindStatusText(this.preBindSignStatus.Status).Color}\"></span>\r\n      </div>\r\n      <div class=\"col-12\" *ngIf=\"this.preBindSignStatus?.RejectedReason?.length > 0\">\r\n        <span style=\"font-weight: bold;\">Reason:&nbsp;</span><span>{{this.preBindSignStatus.RejectedReason}}</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div id=\"SignType\" class=\"row mt-4 mb-4\" style=\"margin-left: -5px;\">\r\n      <div class=\"col-4\">\r\n        <label class=\"form-check-inline\"><input [(ngModel)]=\"signByDocuSign\" class=\"form-check-inline\" [disabled]=\"this.isDocuSignBlocked()\" name=\"SignType\" type=\"radio\" [value]=\"true\"  #elevated=\"ngModel\" />Sign via DocuSign</label>\r\n      </div>\r\n      <div class=\"col-4\">\r\n        <label class=\"form-check-inline\"><input [(ngModel)]=\"signByDocuSign\" class=\"form-check-inline\" [disabled]=\"this.isManuallyBlocked()\" name=\"SignType\" type=\"radio\" [value]=\"false\" #elevated=\"ngModel\" />Sign Manually</label>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div [hidden]=\"signByDocuSign\" class=\"margin-left-10\">\r\n      <div class=\"row \" >\r\n        <div class=\"col-12\" style=\"margin-left: 0px;\">\r\n          <img src=\"../../assets/images/pdf-icon.svg\" width=\"20px\" height=\"20px\">\r\n          <a href=\"../../assets/documents/Surplus-lines-disclosure-form.pdf\" target=\"_blank\">&nbsp;Surplus Lines Disclosure Form</a>\r\n        </div>\r\n        <div class=\"col-12 mt-3\" style=\"margin-left: 0px;\">\r\n          <img src=\"../../assets/images/pdf-icon.svg\" width=\"20px\" height=\"20px\">\r\n          <a href=\"../../assets/documents/NFIP-acknowledgment-of-understanding-form.pdf\" target=\"_blank\">&nbsp;NFPI Acknowledgment of Understanding Form</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row mt-5\">\r\n        <app-drag-and-drop-file [disabled]=\"this.canSubmitAgain() == false\" #dnd class=\"col-12\" style=\"margin-left: 0px;\"\r\n          [selectFiles]=\"this.allowedFiles\"\r\n          (onFilesLoaded)=\"this.onFloridaFormsDropped($event)\">\r\n        </app-drag-and-drop-file>\r\n      </div>\r\n      <div class=\"row mt-3\">\r\n        <div class=\"float-left\" style=\"margin-left: 15px;\">\r\n          <input type=\"button\" class=\"btn btn-MorningBlue\" [disabled]=\"\r\n            (this.hasFiles && this.hasChanges == false) ||\r\n            (this.hasFiles == false && this.areFilesReadyToSubmit() == false) ||\r\n            this.areFilesReadyToSubmit() == false ||\r\n            this.canSubmitAgain() == false\" value=\"Submit Files\" (click)=\"submitFiles()\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div [hidden]=\"!signByDocuSign\" class=\"margin-left-10\">\r\n\r\n      <div class=\"files-list\" [hidden]=\"this.isQuoteApproved == false || this.hasFiles == false\">\r\n        <div class=\"single-file\" *ngFor=\"let file of floridaFiles; let i = index\">\r\n          <img src=\"assets/images/ic-file.svg\" width=\"45px\" alt=\"file\">\r\n          <div class=\"info\">\r\n            <h4 class=\"name\">\r\n              {{ file?.file?.name }}\r\n            </h4>\r\n            <p class=\"size\">\r\n              {{ formatBytes(file?.file?.size) }}\r\n            </p>\r\n            <app-progress-bar [progress]=\"file?.file?.progress\"></app-progress-bar>\r\n          </div>\r\n          <img src=\"assets/images/ic-download.svg\" class=\"delete\" width=\"20px\" alt=\"file\" (click)=\"downloadFile(i)\">\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"float-left form-group\">\r\n        <label for=\"InsuredEmail\">Insured Email</label>\r\n        <input class=\"form-control\" id=\"InsuredEmail\" name=\"InsuredEmail\" type=\"email\" [disabled]=\"this.isDocuSignRequestButtonBlocked()\"  [(ngModel)]=\"this.insuredEmail\"/>\r\n        <br>\r\n        <input type=\"button\" class=\"btn btn-MorningBlue\" [disabled]=\"this.isDocuSignRequestButtonBlocked()\" value=\"Sign with DocuSign\" (click)=\"this.submitByDocuSign()\" />\r\n        <br>\r\n        <br>\r\n      </div>\r\n      <br>\r\n      <!-- <div class=\"float-left\">\r\n        <input type=\"button\" class=\"btn btn-MorningBlue\" [disabled]=\"this.isDocuSignRequestButtonBlocked()\" value=\"Sign with DocuSign\" (click)=\"this.submitByDocuSign()\" />\r\n      </div> -->\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <!--END FLORIDA FORMS-->\r\n\r\n  <div class=\"float-right mt-5 mb-5\">\r\n    <input type=\"button\" class=\"btn btn-MorningBlue\" value=\"Go to Billing\" [disabled]=\"!isFloridaFormsValid()\" (click)=\"goToBilling()\" />\r\n  </div>\r\n</div>\r\n<div id=\"overlay\" *ngIf=\"showSpinner\">\r\n  <div style=\"position:absolute;top:50%;left:50%;\">\r\n    <img src=\"../../assets/images/loading_2x.gif\" />\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/options/options.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/options/options.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n  <div class=\"col-lg-12\">\r\n    <h2>Quote Options</h2>\r\n  </div>\r\n  <div class=\"div-nonpremier col-lg-9\">\r\n    <div>\r\n      <strong> Quote:</strong> <span> {{quoteModel?.QuoteId}}</span>\r\n      <span style=\"font-size: 24px; color: red\" *ngIf=\"quoteModel?.Expired\">This quote is expired and must be requoted.</span>\r\n      <button id=\"requote\" name=\"requote\" class=\"btn btn-xs btn-warning float-right\" *ngIf=\"userRole == 'agent'\" (click)=\"requote()\">Requote</button>\r\n    </div>\r\n    <div>\r\n      <strong>Quote Date:</strong> {{quoteModel?.RequestDate | date : 'MM/dd/y'}}\r\n    </div>\r\n    <div>\r\n      <strong>Client Name:</strong> {{clientInformation}}\r\n    </div>\r\n    <div>\r\n      <strong>Risk Address:</strong> {{riskAddress}}\r\n      <button class=\"btn btn-xs btn-warning float-right\" (click)=\"printOptions()\">Print Options</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"col-lg-3\">\r\n    <label for=\"deductibleCategory\">Deductible options:</label>\r\n    <select id=\"deductibleCategory\" class=\"form-control\" [(ngModel)]=\"selectedDeductibleCategory\" #dedOptions=\"ngModel\" (ngModelChange)=\"onDeductibleChange($event)\">\r\n      <option *ngFor=\"let category of deductibleCategories\" [ngValue]=\"category\">{{category}}</option>\r\n    </select>\r\n  </div>\r\n  <div class=\"col-lg-3\">\r\n    <label for=\"waitingPeriod\">Waiting Period:</label>\r\n    <select id=\"waitingPeriod\" class=\"form-control\" [(ngModel)]=\"selectedWaitingPeriodCategory\" #waitOptions=\"ngModel\" (ngModelChange)=\"checkDate(effectiveDate, effectiveDateForm.form.valid)\">\r\n      <option *ngFor=\"let period of waitingPeriods\" [ngValue]=\"period\">{{period.Text}}</option>\r\n    </select>\r\n  </div>\r\n  <div class=\"col-lg-3\">\r\n    <form #effectiveDateForm=\"ngForm\">\r\n      <div class=\"form-group\">\r\n        <label for=\"dp\">Effective Date:</label>\r\n        <div class=\"input-group\">\r\n          <input id=\"datePicker\" type=\"text\" name=\"datePicker\" class=\"form-control\" [(ngModel)]=\"effectiveDate\" ngbDatepicker #d=\"ngbDatepicker\" (ngModelChange)=\"checkDate($event, effectiveDateForm.form.valid)\" [maxDate]=\"maxDate\" required>\r\n          <div class=\"input-group-append\">\r\n            <button class=\"btn btn-outline-secondary calendar\" (click)=\"d.toggle()\" type=\"button\"></button>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"effectiveDateForm.form.controls.datePicker?.invalid && (effectiveDateForm.form.controls.datePicker.dirty || effectiveDateForm.form.controls.datePicker.touched)\">\r\n          <div *ngIf=\"effectiveDateForm.form.controls.datePicker.errors.required\" class=\"error-message\">required</div>\r\n          <div *ngIf=\"effectiveDateForm.form.controls.datePicker.invalid && effectiveDateForm.form.controls.datePicker.dirty && !pastMax\" class=\"error-message\">effective date is invalid format</div>\r\n          <div *ngIf=\"effectiveDateForm.form.controls.datePicker.invalid && effectiveDateForm.form.controls.datePicker.dirty && pastMax\" class=\"error-message\">effective date can not be greater than 60 days from today</div>\r\n        </div>\r\n        <div *ngIf=\"pastEffDate\" class=\"error-message\">Effective date cannot be before today</div>\r\n        <div *ngIf=\"effectiveDateOneWeek\" class=\"error-message\">Effective date must be 7 or more days from today.</div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</div>\r\n<div class=\"row row-margintop-10\">\r\n  <ng-container *ngIf=\"quoteModel?.Quote.ProductFormType == '1'\">\r\n    <div style=\"margin-right: 10px;\" *ngFor=\"let x of visibleOptions\" id=\"{{x.OptionName}}\" [ngClass]=\"x.OptionName === 'Premier' ? 'div-premier col-lg-3' : 'div-nonpremier col-lg-3'\">\r\n      <table class=\"table-sm\" style=\"width: 100%;\">\r\n        <tr>\r\n          <td colspan=\"2\">\r\n            <div style=\"min-height: 50px;\" class=\"header-main text-center\">{{x.OptionName}}</div>\r\n          <td>\r\n        </tr>\r\n        <tr>\r\n          <td colspan=\"2\">\r\n            <strong>Coverage</strong>\r\n          </td>\r\n        </tr>\r\n        <tr *ngFor=\"let y of x.Coverage\">\r\n          <td>{{y.CoverageType}}</td>\r\n          <td class=\"float-right\">{{y.Value | currency}}</td>\r\n        </tr>\r\n        <tr *ngFor=\"let n of range(0, 3 - (x.Coverage.length - 1))\">\r\n          <td colspan=\"2\">&nbsp;</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Deductible:</strong></td>\r\n          <td class=\"float-right\">{{x.Deductible | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>&nbsp;</strong></td>\r\n          <td colspan=\"2\">&nbsp;</td>\r\n        </tr>\r\n        <!-- TODO -->\r\n        <tr>\r\n          <td *ngIf=\"!x.noPremChange\"><strong>&nbsp;</strong></td>\r\n          <td colspan=\"2\" *ngIf=\"!x.noPremChange\">&nbsp;</td>\r\n          <td colspan=\"2\" *ngIf=\"x.noPremChange\">\r\n            <div style=\"font-style: italic;\" class=\"text-center\">No Premium Change</div>\r\n          </td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Premium:</strong></td>\r\n          <td class=\"float-right\">{{x.Premium | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>{{riskAddressState == 'LA' ? 'Agency Fee' : 'Policy Fee'}}:</strong></td>\r\n          <td class=\"float-right\">{{x.Fees | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Taxes:</strong></td>\r\n          <td class=\"float-right\">{{x.Taxes | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Total:</strong></td>\r\n          <td class=\"float-right\">{{x.Total | currency}}</td>\r\n        </tr>\r\n        <tr *ngIf=\"userRole == 'agent'\">\r\n          <td colspan=\"2\" class=\"text-center\" *ngIf=\"!quoteModel?.Expired\">\r\n            <button class=\"btn btn-MorningBlue\" style=\"margin: 20px auto 0; display: block;\" (click)=\"effectiveDateForm.form.valid && selectQuoteOption(x)\">Select this option</button>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n<div class=\"row row-margintop-10\">\r\n  <ng-container *ngIf=\"quoteModel?.Quote.ProductFormType == '2'\">\r\n    <div class=\"col-lg-4 align\" style=\"margin-right: 10px;\" *ngFor=\"let x of visibleOptions\" id=\"{{x.OptionName}}\" [ngClass]=\"x.OptionName === 'Premier 5' ? 'div-premier col-lg-3' : x.OptionName === 'Premier 2' ? 'div-premier col-lg-3' : 'div-nonpremier col-lg-3'\">\r\n      <table class=\"table-sm\" style=\"width: 100%;\">\r\n        <tr>\r\n          <td colspan=\"2\">\r\n            <div style=\"min-height: 50px;\" class=\"header-main text-center\">{{x.OptionName}}</div>\r\n            <div *ngIf=\"x.OptionName === 'Premier 2'\" class=\"header-sub\">2% Loss of Use</div>\r\n            <div *ngIf=\"x.OptionName === 'Premier 5'\" class=\"header-sub\">5% Loss of Use</div>\r\n          <td>\r\n        </tr>\r\n        <tr>\r\n          <td colspan=\"2\">\r\n            <strong>Coverage</strong>\r\n          </td>\r\n        </tr>\r\n        <tr *ngFor=\"let y of x.Coverage\">\r\n          <td>{{y.CoverageType}}</td>\r\n          <td class=\"info float-right\">{{y.Value | currency}}</td>\r\n        </tr>\r\n        <tr *ngFor=\"let n of range(0, 3 - (x.Coverage.length - 1))\">\r\n          <td colspan=\"2\">&nbsp;</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Deductible:</strong></td>\r\n          <td class=\"float-right\">{{x.Deductible | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>&nbsp;</strong></td>\r\n          <td colspan=\"2\">&nbsp;</td>\r\n        </tr>\r\n        <tr>\r\n          <td *ngIf=\"!x.noPremChange\"><strong>&nbsp;</strong></td>\r\n          <td colspan=\"2\" *ngIf=\"!x.noPremChange\">&nbsp;</td>\r\n          <td colspan=\"2\" *ngIf=\"x.noPremChange\">\r\n            <div style=\"font-style: italic;\" class=\"text-center\">No Premium Change</div>\r\n          </td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Premium:</strong></td>\r\n          <td class=\"float-right\">{{x.Premium | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>{{riskAddressState == 'LA' ? 'Agency Fee' : 'Policy Fee'}}:</strong></td>\r\n          <td class=\"float-right\">{{x.Fees | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Taxes:</strong></td>\r\n          <td class=\"float-right\">{{x.Taxes | currency}}</td>\r\n        </tr>\r\n        <tr>\r\n          <td><strong>Total:</strong></td>\r\n          <td class=\"float-right\">{{x.Total | currency}}</td>\r\n        </tr>\r\n        <tr *ngIf=\"userRole == 'agent'\">\r\n          <td colspan=\"2\" class=\"text-center\" *ngIf=\"!quoteModel.Expired\">\r\n            <!--<button class=\"btn btn-MorningBlue\" style=\"margin: 20px auto 0; display: block;\" ng-click=\"!vm.FloodForm.effectiveDate.$invalid && vm.selectQuoteOption(x)\">Select this option</button>-->\r\n            <button class=\"btn btn-MorningBlue\" style=\"margin: 20px auto 0; display: block;\" (click)=\"effectiveDateForm.form.valid && selectQuoteOption(x)\">Select this option</button>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n<div id=\"overlay\" *ngIf=\"showSpinner\">\r\n  <div style=\"position:absolute;top:50%;left:50%;\">\r\n    <img src=\"../../assets/images/loading_2x.gif\" />\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/progress-bar/progress-bar.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/progress-bar/progress-bar.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"progress-cont\">\n  <div class=\"progress\" [style.width]=\"progress + '%'\">\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-dialog-content class=\"mat-typography\" align=\"center\">\r\n  <img src=\"../../../assets/images/moratorium-warning.png\" alt=\"warning\" height=\"30%\" width=\"30%\">\r\n  <h1><b>Moratorium</b></h1>\r\n  <h3>{{ data }}</h3>\r\n</mat-dialog-content>\r\n<mat-dialog-actions align=\"center\">\r\n  <button mat-raised-button color=\"primary\" mat-dialog-close cdkFocusInitial>OK</button>\r\n</mat-dialog-actions>\r\n");

/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let AppComponent = class AppComponent {
    constructor() {
        this.title = 'app';
    }
};
AppComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-root',
        template: __importDefault(__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _application_application_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./application/application.component */ "./src/app/application/application.component.ts");
/* harmony import */ var _validators_custom_min_validator_directive__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./validators/custom-min-validator.directive */ "./src/app/validators/custom-min-validator.directive.ts");
/* harmony import */ var _validators_custom_max_validator_directive__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./validators/custom-max-validator.directive */ "./src/app/validators/custom-max-validator.directive.ts");
/* harmony import */ var _validators_custom_quotable_state_directive__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./validators/custom-quotable-state-directive */ "./src/app/validators/custom-quotable-state-directive.ts");
/* harmony import */ var _validators_custom_unquotable_zip_directive__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./validators/custom-unquotable-zip-directive */ "./src/app/validators/custom-unquotable-zip-directive.ts");
/* harmony import */ var _options_options_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./options/options.component */ "./src/app/options/options.component.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _mortgagee_mortgagee_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mortgagee/mortgagee.component */ "./src/app/mortgagee/mortgagee.component.ts");
/* harmony import */ var _billing_billing_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./billing/billing.component */ "./src/app/billing/billing.component.ts");
/* harmony import */ var _validators_custom_matching_directive__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./validators/custom-matching-directive */ "./src/app/validators/custom-matching-directive.ts");
/* harmony import */ var _validators_custom_routing_match_directive__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./validators/custom-routing-match-directive */ "./src/app/validators/custom-routing-match-directive.ts");
/* harmony import */ var _shared_jwt_interceptor__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./shared/jwt.interceptor */ "./src/app/shared/jwt.interceptor.ts");
/* harmony import */ var _shared_Custom_NgbDateParserFormat__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./shared/Custom-NgbDateParserFormat */ "./src/app/shared/Custom-NgbDateParserFormat.ts");
/* harmony import */ var _directives_drag_and_drop_directive__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./directives/drag-and-drop.directive */ "./src/app/directives/drag-and-drop.directive.ts");
/* harmony import */ var _progress_bar_progress_bar_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./progress-bar/progress-bar.component */ "./src/app/progress-bar/progress-bar.component.ts");
/* harmony import */ var _drag_and_drop_file_drag_and_drop_file_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./drag-and-drop-file/drag-and-drop-file.component */ "./src/app/drag-and-drop-file/drag-and-drop-file.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _moratorium_management_moratorium_management_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./moratorium-management/moratorium-management.component */ "./src/app/moratorium-management/moratorium-management.component.ts");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _moratorium_management_dialogs_moratorium_message_dialog_moratorium_message_dialog__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog */ "./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.ts");
/* harmony import */ var _shared_moratorium_warning_dialog_moratorium_warning_dialog__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./shared/moratorium-warning-dialog/moratorium-warning-dialog */ "./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




























let AppModule = class AppModule {
};
AppModule = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"],
            _application_application_component__WEBPACK_IMPORTED_MODULE_6__["ApplicationComponent"],
            _options_options_component__WEBPACK_IMPORTED_MODULE_11__["OptionsComponent"],
            _mortgagee_mortgagee_component__WEBPACK_IMPORTED_MODULE_13__["MortgageeComponent"],
            _billing_billing_component__WEBPACK_IMPORTED_MODULE_14__["BillingComponent"],
            _validators_custom_min_validator_directive__WEBPACK_IMPORTED_MODULE_7__["CustomMinDirective"],
            _validators_custom_max_validator_directive__WEBPACK_IMPORTED_MODULE_8__["CustomMaxDirective"],
            _validators_custom_quotable_state_directive__WEBPACK_IMPORTED_MODULE_9__["CustomQuotableStateDirective"],
            _validators_custom_unquotable_zip_directive__WEBPACK_IMPORTED_MODULE_10__["CustomUnquotableZipDirective"],
            _validators_custom_matching_directive__WEBPACK_IMPORTED_MODULE_15__["CustomMatchingDirective"],
            _validators_custom_routing_match_directive__WEBPACK_IMPORTED_MODULE_16__["CustomRoutingMatchDirective"],
            _directives_drag_and_drop_directive__WEBPACK_IMPORTED_MODULE_19__["DragAndDropDirective"],
            _progress_bar_progress_bar_component__WEBPACK_IMPORTED_MODULE_20__["ProgressBarComponent"],
            _drag_and_drop_file_drag_and_drop_file_component__WEBPACK_IMPORTED_MODULE_21__["DragAndDropFileComponent"],
            _moratorium_management_moratorium_management_component__WEBPACK_IMPORTED_MODULE_23__["MoratoriumManagementComponent"],
            _moratorium_management_dialogs_moratorium_message_dialog_moratorium_message_dialog__WEBPACK_IMPORTED_MODULE_26__["MoratoriumMessageDialog"],
            _shared_moratorium_warning_dialog_moratorium_warning_dialog__WEBPACK_IMPORTED_MODULE_27__["MoratoriumWarningDialog"],
        ],
        entryComponents: [_moratorium_management_dialogs_moratorium_message_dialog_moratorium_message_dialog__WEBPACK_IMPORTED_MODULE_26__["MoratoriumMessageDialog"], _shared_moratorium_warning_dialog_moratorium_warning_dialog__WEBPACK_IMPORTED_MODULE_27__["MoratoriumWarningDialog"]],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_0__["BrowserModule"].withServerTransition({ appId: 'ng-cli-universal' }),
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_12__["NgbModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"].forRoot([
                { path: '', redirectTo: 'application', pathMatch: 'full' },
                { path: 'application', component: _application_application_component__WEBPACK_IMPORTED_MODULE_6__["ApplicationComponent"] },
                { path: 'options', component: _options_options_component__WEBPACK_IMPORTED_MODULE_11__["OptionsComponent"] },
                { path: 'mortgagee', component: _mortgagee_mortgagee_component__WEBPACK_IMPORTED_MODULE_13__["MortgageeComponent"] },
                { path: 'billing', component: _billing_billing_component__WEBPACK_IMPORTED_MODULE_14__["BillingComponent"] },
                { path: 'moratorium-management', component: _moratorium_management_moratorium_management_component__WEBPACK_IMPORTED_MODULE_23__["MoratoriumManagementComponent"] },
            ]),
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_22__["NoopAnimationsModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_24__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatCheckboxModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatRadioModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_2__["ReactiveFormsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_25__["MatSnackBarModule"]
        ],
        providers: [
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HTTP_INTERCEPTORS"], useClass: _shared_jwt_interceptor__WEBPACK_IMPORTED_MODULE_17__["AuthInterceptor"], multi: true },
            { provide: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_12__["NgbDateParserFormatter"], useClass: _shared_Custom_NgbDateParserFormat__WEBPACK_IMPORTED_MODULE_18__["CustomNgbDateFormat"] }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/application/application.component.ts":
/*!******************************************************!*\
  !*** ./src/app/application/application.component.ts ***!
  \******************************************************/
/*! exports provided: ApplicationComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationComponent", function() { return ApplicationComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_address_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/address.model */ "./src/app/shared/address.model.ts");
/* harmony import */ var _shared_dropdown_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/dropdown.service */ "./src/app/shared/dropdown.service.ts");
/* harmony import */ var _application_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./application.service */ "./src/app/application/application.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _shared_application_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shared/application.model */ "./src/app/shared/application.model.ts");
/* harmony import */ var _shared_userDto_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../shared/userDto.model */ "./src/app/shared/userDto.model.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _moratorium_management_moratorium_management_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../moratorium-management/moratorium-management.service */ "./src/app/moratorium-management/moratorium-management.service.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _shared_moratorium_warning_dialog_moratorium_warning_dialog__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../shared/moratorium-warning-dialog/moratorium-warning-dialog */ "./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};












let ApplicationComponent = class ApplicationComponent {
    constructor(dropdownService, applicationService, router, route, arcWebUrl, moratoriumManagementService, dialog) {
        this.dropdownService = dropdownService;
        this.applicationService = applicationService;
        this.router = router;
        this.route = route;
        this.arcWebUrl = arcWebUrl;
        this.moratoriumManagementService = moratoriumManagementService;
        this.dialog = dialog;
        this.disabledCounties = [];
        this.errors = [];
        this.risk = new _shared_address_model__WEBPACK_IMPORTED_MODULE_1__["Address"]();
        this.mailing = new _shared_address_model__WEBPACK_IMPORTED_MODULE_1__["Address"]();
        this.floodZones = new Array();
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            let user = params['u'];
            let token = sessionStorage.getItem('user_token');
            if (token != null || token != undefined) {
                this.init();
            }
            else if (user == undefined || user == null) {
                window.location.href = this.arcWebUrl;
            }
            else {
                this.decodeUser(user);
                let url = this.router.url.substring(0, this.router.url.indexOf("?"));
                this.router.navigateByUrl(url);
            }
        });
    }
    init() {
        this.maxDate = new Date().getFullYear();
        this.risk.street = '';
        this.risk.city = '';
        this.risk.county = '';
        this.mailing.street = '';
        this.mailing.city = '';
        this.insuredFirstName = '';
        this.insuredLastName = '';
        this.losses = [];
        this.showFoundationTypeInfo = false;
        this.homeElevatedTip = false;
        this.populateDropdowns();
        this.applicationService.getStates().subscribe(response => this.getQuoteableStates(response));
        this.applicationService.getFloodZones().subscribe(response => this.getFloodZones(response));
        this.applicationService.getCounties().subscribe(response => this.getCounties(response));
        this.showCounty = true;
        this.showSpinner = false;
        this.moratoriumManagementService.getCounties().subscribe(response => this.getDisabledCounties(response));
        this.moratoriumManagementService.getMoratoriumMessage().subscribe(response => this.moratoriumMessage = response);
    }
    decodeUser(obj) {
        var userObject = JSON.parse(atob(obj));
        sessionStorage.setItem("user_id", userObject.userId);
        sessionStorage.setItem("name", userObject.name);
        sessionStorage.setItem("permissions", JSON.stringify(userObject.user_permissions));
        sessionStorage.setItem("refreshToken", userObject.refreshToken);
        sessionStorage.setItem("user_token", userObject.user_token);
        sessionStorage.setItem("state_access", userObject.state_access);
        sessionStorage.setItem("token_expiration", userObject.token_expiration);
        sessionStorage.setItem("user_agency", userObject.agency);
        sessionStorage.setItem('user_roles', JSON.stringify(userObject.user_roles));
        sessionStorage.setItem('agentId', userObject.agentId);
        sessionStorage.setItem('agencyId', userObject.agencyId);
    }
    getQuoteableStates(response) {
        var requoteId = sessionStorage.getItem("requoteId");
        this.physicalStates = response;
        var importQuoteNum = sessionStorage.getItem("quote_id");
        // todo
        if (requoteId == null) {
            if (importQuoteNum === null) {
                //this.risk.stateId = this.physicalStates;
            }
        }
        else {
            this.requote(requoteId);
        }
    }
    getCounties(response) {
        this.counties = response;
        this.filteredCounties = response;
    }
    getFloodZones(response) {
        this.floodZones = response.sort((a, b) => a.SortingNum - b.SortingNum);
    }
    getDisabledCounties(response) {
        response.forEach(county => {
            if (county.FlgActive == 'false') {
                this.disabledCounties.push(county);
            }
        });
    }
    copyRiskAddress() {
        this.mailing.street = this.risk.street;
        this.mailing.city = this.risk.city;
        this.mailing.zip = this.risk.zip;
        if (this.selectedRiskState != null || this.selectedRiskState != undefined) {
            this.mailing.stateId = this.selectedRiskState.Id;
        }
    }
    populateDropdowns() {
        this.mailingStates = this.dropdownService.getMailingStates();
        this.occupancies = this.dropdownService.getOccupancies();
        this.constructionType = this.dropdownService.getConstructionTypes();
        this.dwellingTivPercentage = this.dropdownService.getDwellingTivPercentages();
        this.propertyCostValueType = this.dropdownService.getPersonalPropertyCostValueTypes();
        this.overWaterTypes = this.dropdownService.getOverWaterTypes();
        this.foundationTypes = this.dropdownService.getFoundationTypes();
        this.selectedPropertyCostValueType = this.propertyCostValueType[1];
    }
    changeDwellingPercentValues() {
        switch (this.selectedOccupancy.Id) {
            case 1:
                this.dwellingTivPercentage = [
                    { Value: '35', Text: '35%' },
                    { Value: '40', Text: '40%' },
                    { Value: '45', Text: '45%' },
                    { Value: '50', Text: '50%' },
                    { Value: '55', Text: '55%' },
                    { Value: '60', Text: '60%' },
                    { Value: '65', Text: '65%' },
                    { Value: '70', Text: '70%' }
                ];
                this.personalPropertyTiv = null;
                this.selectedDwellingTivPercentage = this.dwellingTivPercentage[0];
                break;
            case 2: // secondary
            case 3: // seasonal
            case 4: // tenated
                this.dwellingTivPercentage = [
                    { Value: '10', Text: '10%' },
                    { Value: '15', Text: '15%' },
                    { Value: '20', Text: '20%' },
                    { Value: '25', Text: '25%' },
                    { Value: '30', Text: '30%' },
                    { Value: '35', Text: '35%' },
                    { Value: '40', Text: '40%' },
                    { Value: '45', Text: '45%' },
                    { Value: '50', Text: '50%' },
                    { Value: '55', Text: '55%' },
                    { Value: '60', Text: '60%' },
                    { Value: '65', Text: '65%' },
                    { Value: '70', Text: '70%' }
                ];
                this.personalPropertyTiv = null;
                this.selectedDwellingTivPercentage = this.dwellingTivPercentage[0];
                break;
            case 5: // vacant
            case 6: // course of construction
            case 7: // vacant (renovation)
                this.dwellingTivPercentage = [
                    { Value: '0', Text: '0%' }
                ];
                this.selectedDwellingTivPercentage = this.dwellingTivPercentage[0];
                this.personalPropertyTiv = 0;
                break;
        }
        this.changePersonalPropTiv();
    }
    changePersonalPropTiv() {
        if (this.dwellingTiv !== null && this.dwellingTiv !== undefined && this.selectedDwellingTivPercentage !== null && this.selectedDwellingTivPercentage !== undefined) {
            var ceilValue = Math.ceil(this.dwellingTiv * (this.selectedDwellingTivPercentage.Value / 100));
            var floorValue = Math.floor(this.dwellingTiv * (this.selectedDwellingTivPercentage.Value / 100));
            var checkValue = this.dwellingTiv * (this.selectedDwellingTivPercentage.Value / 100);
            if (this.selectedDwellingTivPercentage.Value === '70' && ceilValue > checkValue) {
                this.personalPropertyTiv = floorValue;
            }
            else {
                this.personalPropertyTiv = ceilValue;
            }
        }
        else {
            this.personalPropertyTiv = null;
        }
    }
    changeConstructionType(constructionType) {
        if (this.dwellingTiv !== null && this.dwellingTiv) {
            //this.applicationForm.controls['DwellingTiv'].markAsUntouched();
            //this.applicationForm.controls['DwellingTiv'].setErrors({ 'customMin': false });
            this.applicationForm.controls['DwellingTiv'].setErrors(null);
            if (constructionType === 5) {
                if (this.dwellingTiv < this.squareFeet * 120) {
                    this.applicationForm.controls['DwellingTiv'].markAsTouched();
                    this.applicationForm.controls['DwellingTiv'].setErrors({ 'customMin': true });
                }
            }
            else {
                if (this.dwellingTiv < this.squareFeet * 100) {
                    this.applicationForm.controls['DwellingTiv'].markAsTouched();
                    this.applicationForm.controls['DwellingTiv'].setErrors({ 'customMin': true });
                }
            }
        }
    }
    validateConstructionType(constructionType, dwellingValue, squareFeetValue) {
        //console.log(constructionType, dwellingValue, squareFeetValue);
        if (dwellingValue !== null && dwellingValue) {
            //this.applicationForm.controls['DwellingTiv'].markAsUntouched();
            this.applicationForm.controls['DwellingTiv'].setErrors(null);
            if (constructionType === 5) {
                if (dwellingValue < squareFeetValue * 120) {
                    this.applicationForm.controls['DwellingTiv'].markAsTouched();
                    this.applicationForm.controls['DwellingTiv'].setErrors({ 'customMin': true });
                }
            }
            else {
                if (dwellingValue < squareFeetValue * 100) {
                    this.applicationForm.controls['DwellingTiv'].markAsTouched();
                    this.applicationForm.controls['DwellingTiv'].setErrors({ 'customMin': true });
                }
            }
        }
    }
    changeHomeElevated() {
        this.selectedFoundationTypeId = null;
        this.elevationHeight = null;
        this.garage = null;
        this.crawlspace = null;
        this.enclosure = null;
        this.basement = null;
        if (this.homeElevated) {
            this.foundationTypes = [
                { Id: 1, Value: 'PiersPostsPiles', Text: 'Piers, Posts, Piles' },
                { Id: 2, Value: 'ReinforcedMasonryEtc', Text: 'Reinforced Masonry, Etc.' },
                { Id: 3, Value: 'ReinforcedShearWalls', Text: 'Reinforced Shear Walls' },
                { Id: 4, Value: 'SolidFoundationWalls', Text: 'Solid Foundation Walls' }
            ];
        }
        else {
            this.foundationTypes = [
                { Id: 5, Value: 'FoundationWall', Text: 'Foundation Wall' },
                { Id: 6, Value: 'SlabOnGrade', Text: 'Slab On Grade' },
                { Id: 7, Value: 'SlabOnFill', Text: 'Slab On Fill' }
            ];
        }
    }
    changeCrawlspace() {
        if (this.crawlspace != 3 && this.crawlspace !== null && this.crawlspace !== undefined) {
            this.enclosure = 3;
        }
    }
    changeEnclosure() {
        if (this.enclosure != 3 && this.enclosure !== null && this.enclosure !== undefined) {
            this.crawlspace = 3;
        }
    }
    resetLosses() {
        this.floodLossYear = null;
        this.floodLossValue = null;
        this.losses = [];
        this.elevatedAfter = null;
    }
    addLoss() {
        this.buttonClick = true;
        if (this.floodLossValue !== undefined && this.floodLossYear !== undefined && this.floodLossValue !== null && this.floodLossYear !== null) {
            var loss = {
                YearOfLoss: this.floodLossYear,
                ValueOfLoss: this.floodLossValue
            };
            this.losses.push(loss);
            this.floodLossValue = null;
            this.floodLossYear = null;
            this.applicationForm.form.markAsPristine();
            this.applicationForm.form.markAsUntouched();
            this.applicationForm.form.updateValueAndValidity();
            this.buttonClick = false;
        }
    }
    removeLoss(index) {
        this.losses.splice(index, 1);
    }
    toggleFoundationTypeInfo() {
        this.showFoundationTypeInfo = !this.showFoundationTypeInfo;
    }
    isDisabledCounty() {
        if (this.selectedRiskCounty == undefined) {
            return false;
        }
        return this.applicationService.isDisabledCounty(this.selectedRiskCounty.Id);
    }
    requote(requoteId) {
        this.loading = true;
        let app = new _shared_application_model__WEBPACK_IMPORTED_MODULE_5__["Application"]();
        let user = new _shared_userDto_model__WEBPACK_IMPORTED_MODULE_6__["UserDto"]();
        this.applicationService.requote(requoteId).subscribe(response => {
            this.risk.street = response.RiskAddressStreet1;
            this.risk.city = response.RiskAddressCity;
            this.selectedRiskState = this.physicalStates.filter(x => x.Id === response.RiskAddressState)[0];
            this.changeCounties();
            this.selectedRiskCounty = this.filteredCounties.filter(x => x.CountyName === response.RiskAddressCounty)[0];
            this.risk.zip = response.RiskAddressZip;
            this.mailing.street = response.MailingAddressStreet1;
            this.mailing.city = response.MailingAddressCity;
            this.mailing.stateId = response.MailingAddressState;
            this.mailing.zip = response.MailingAddressZip;
            this.insuredFirstName = response.FirstName;
            this.insuredLastName = response.LastName;
            this.selectedOccupancy = this.occupancies.filter(x => x.Id === response.Occupancy)[0];
            this.yearBuilt = response.YearBuilt;
            this.selectedConstructionType = this.constructionType.filter(x => x.Id === response.Construction)[0];
            this.propNumStories = response.NoOfStories;
            this.squareFeet = response.FloorArea;
            this.validateConstructionType(this.constructionType.filter(x => x.Id === response.Construction)[0].Id, response.DwellingTiv, response.FloorArea);
            //console.log(this.selectedConstructionType);
            this.dwellingTiv = response.DwellingTiv;
            this.personalPropertyTiv = response.PersonalPropertyTiv;
            this.setDwellingTivPercentage();
            this.selectedPropertyCostValueType = this.propertyCostValueType.filter(x => x.Id === response.PersonalPropertyCostValueType)[0];
            this.homeElevated = Boolean(response.IsElevated);
            this.changeHomeElevated();
            this.selectedFoundationTypeId = response.FoundationType;
            this.elevationHeight = response.ElevationHeight;
            if (response.IsElevated) {
                this.basement = null;
                let elevationDetails = response.ElevationDetailDtos;
                let garage = elevationDetails.filter(x => x.ElevationTypeId === 1);
                if (garage.length > 0) {
                    this.garage = garage[0].CompletionStatusId;
                }
                else {
                    this.garage = 3;
                }
                let crawlspace = elevationDetails.filter(x => x.ElevationTypeId === 2);
                if (crawlspace.length > 0) {
                    this.crawlspace = crawlspace[0].CompletionStatusId;
                    this.enclosure = 3;
                }
                else {
                    this.crawlspace = 3;
                }
                let enclosure = elevationDetails.filter(x => x.ElevationTypeId === 3);
                if (enclosure.length > 0) {
                    this.enclosure = enclosure[0].CompletionStatusId;
                    this.crawlspace = 3;
                }
                else {
                    this.enclosure = 3;
                }
            }
            else {
                this.garage = null;
                this.crawlspace = null;
                this.enclosure = null;
                if (response.HasBasement) {
                    this.basement = response.CompletionStatus;
                }
                else {
                    this.basement = 3;
                }
            }
            if (response.PriorFloodLosses.length > 0) {
                this.previousLosses = true;
                response.PriorFloodLosses.forEach(loss => {
                    this.losses.push(loss);
                });
                this.elevatedAfter = response.HouseElevatedAfterPriorFloodLoss;
            }
            else {
                this.previousLosses = false;
            }
            this.selectedOverWaterType = this.overWaterTypes.filter(x => x.Id === response.BuildingOverWater)[0];
            this.selectedFloodZone = this.floodZones.filter(x => x.Id === response.FemaFloodZoneId)[0];
            //todo Not sure if this is needed ??
            //this.changeDwellingPercentValues();
            this.loading = false;
        }, error => {
            this.loading = false;
            sweetalert2__WEBPACK_IMPORTED_MODULE_8___default.a.fire({
                icon: 'error',
                title: 'Something went wrong',
                text: 'There was an issue pre-filling the applicants information'
            });
        });
    }
    setDwellingTivPercentage() {
        if (this.dwellingTiv !== null && this.dwellingTiv !== undefined && this.personalPropertyTiv !== null && this.personalPropertyTiv !== undefined) {
            let percent = Math.floor((this.personalPropertyTiv / this.dwellingTiv) * 100);
            let TivPercentage;
            if (percent % 5 === 0 && percent >= 10 && percent <= 70) {
                TivPercentage = { Value: percent.toString(), Text: percent.toString() + "%" };
            }
            else if (percent === 69) {
                TivPercentage = { Value: "70", Text: "70%" };
            }
            else {
                TivPercentage = null;
            }
            this.selectedDwellingTivPercentage = this.dwellingTivPercentage.filter(x => x.Text === TivPercentage.Text)[0];
        }
    }
    getSquareFeetCost(constructionType) {
        if (constructionType === 5)
            return 120;
        else
            return 100;
    }
    onSubmit(isValid) {
        this.showSpinner = true;
        if (!this.verifyDisabledCounty()) {
            isValid = false;
        }
        if (this.previousLosses && this.losses.length === 0) {
            isValid = false;
        }
        if (isValid) {
            this.loading = true;
            let app = new _shared_application_model__WEBPACK_IMPORTED_MODULE_5__["Application"]();
            let user = new _shared_userDto_model__WEBPACK_IMPORTED_MODULE_6__["UserDto"]();
            user.username = sessionStorage.getItem('user_agency');
            user.agencyNumber = sessionStorage.getItem('user_agency');
            user.userid = Number(sessionStorage.getItem("user_id"));
            user.agentid = Number(sessionStorage.getItem("agentId"));
            user.agencyid = Number(sessionStorage.getItem("agencyId"));
            app.user = user;
            app.riskAddressStreet1 = this.risk.street;
            app.riskAddressCity = this.risk.city;
            app.riskAddressState = this.selectedRiskState.Id;
            app.riskAddressZip = this.risk.zip;
            app.riskAddressCounty = this.selectedRiskCounty.CountyName;
            app.mailingAddressStreet1 = this.mailing.street;
            app.mailingAddressCity = this.mailing.city;
            app.mailingAddressState = this.mailing.stateId;
            app.mailingAddressZip = this.mailing.zip;
            app.firstName = this.insuredFirstName;
            app.lastName = this.insuredLastName;
            app.occupancy = this.selectedOccupancy.Id;
            app.yearBuilt = this.yearBuilt;
            app.construction = this.selectedConstructionType.Id;
            app.buildingPurpose = 1;
            app.noOfStories = this.propNumStories;
            app.floorArea = this.squareFeet;
            app.dwellingTiv = this.dwellingTiv;
            app.personalPropertyTiv = this.personalPropertyTiv;
            app.personalPropertyCostValueType = this.selectedPropertyCostValueType.Id;
            app.isElevated = this.homeElevated;
            app.foundationType = this.selectedFoundationTypeId;
            app.elevationHeight = this.elevationHeight;
            app.garage = this.garage != 3 && this.garage !== null && this.garage !== undefined;
            app.garageStatus = (this.garage != 3 && this.garage !== null && this.garage !== undefined) ? this.garage : null;
            app.crawlspace = this.crawlspace != 3 && this.crawlspace !== null && this.crawlspace !== undefined;
            app.crawlspaceStatus = (this.crawlspace != 3 && this.crawlspace !== null && this.crawlspace !== undefined)
                ? this.crawlspace
                : null;
            app.enclosure = this.enclosure != 3 && this.enclosure !== null && this.enclosure !== undefined;
            app.enclosureStatus = (this.enclosure != 3 && this.enclosure !== null && this.enclosure !== undefined)
                ? this.enclosure
                : null;
            app.hasBasement = this.homeElevated == true ? null : this.basement != 3 && this.basement !== null && this.basement !== undefined;
            app.completionStatus = this.basement != 3 && this.basement !== null && this.basement !== undefined
                ? this.basement
                : null;
            app.buildingOverWater = this.selectedOverWaterType.Id;
            app.houseElevatedAfterPriorFloodLoss = this.elevatedAfter;
            app.femaFloodZoneId = this.selectedFloodZone.Id;
            if (this.losses.length > 0) {
                app.priorFloodLosses = this.losses;
            }
            this.applicationService.rateQuote(app).subscribe(response => {
                if (response.Errors != null && response.Errors.length > 0) {
                    this.errors = this.parseValidationErrors(response.Errors);
                    window.scrollTo(0, 0);
                    this.loading = false;
                    this.showSpinner = false;
                }
                else {
                    var quote = {
                        quoteNumber: response.QuoteId
                    };
                    sessionStorage.setItem('quote', JSON.stringify(quote));
                    this.router.navigate(['/options']);
                }
            });
        }
        else {
            this.showSpinner = false;
        }
    }
    parseValidationErrors(errors) {
        var lstErrors = [];
        for (var i = 0; i < errors.length; i++) {
            var error = errors[i];
            // coastal TIV hotfix, US8813
            if (error.indexOf('twfg.warning.tiv') !== -1) {
                var messageArray = error.split(":");
                this.selectedDwellingTivPercentage = { Value: messageArray[1].toString(), Text: messageArray.toString() + "%" };
                this.changePersonalPropTiv();
                lstErrors.push(messageArray[messageArray.length - 1]);
            }
            else if (error.indexOf('request.') !== -1) {
                var messageArray = error.split(":");
                lstErrors.push(messageArray[messageArray.length - 1]);
            }
            else {
                lstErrors.push(error);
            }
        }
        return lstErrors;
    }
    resetForm() {
        this.applicationForm.resetForm();
        window.scrollTo(0, 0);
    }
    changeCounties() {
        if (this.selectedRiskState != null) {
            this.filteredCounties = this.counties.filter(element => element.StateId == this.selectedRiskState.Id);
            this.selectedRiskCounty = null;
            this.showCounty = this.selectedRiskState == 18 ? false : true;
        }
    }
    verifyDisabledCounty() {
        if (this.selectedRiskCounty) {
            if (this.disabledCounties.findIndex(x => x.Id == this.selectedRiskCounty.Id) >= 0) {
                this.openMoratoriumWarningDialog();
                this.previousCountySelection = this.selectedRiskCounty;
                return false;
            }
            this.previousCountySelection = this.selectedRiskCounty;
        }
        return true;
    }
    openMoratoriumWarningDialog() {
        this.moratoriumWarningDialogRef = this.dialog.open(_shared_moratorium_warning_dialog_moratorium_warning_dialog__WEBPACK_IMPORTED_MODULE_11__["MoratoriumWarningDialog"], {
            width: '30%',
            data: 'County is currently under a moratorium. Cannot bind this quote.'
        });
    }
};
ApplicationComponent.ctorParameters = () => [
    { type: _shared_dropdown_service__WEBPACK_IMPORTED_MODULE_2__["DropdownService"] },
    { type: _application_service__WEBPACK_IMPORTED_MODULE_3__["ApplicationService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_7__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_7__["ActivatedRoute"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_WEB_URL',] }] },
    { type: _moratorium_management_moratorium_management_service__WEBPACK_IMPORTED_MODULE_9__["MoratoriumManagementService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_10__["MatDialog"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])('applicationForm', { static: false }),
    __metadata("design:type", _angular_forms__WEBPACK_IMPORTED_MODULE_4__["NgForm"])
], ApplicationComponent.prototype, "applicationForm", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])('dwellTiv', { static: false }),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"])
], ApplicationComponent.prototype, "DwellingInput", void 0);
ApplicationComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-application-component',
        template: __importDefault(__webpack_require__(/*! raw-loader!./application.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/application/application.component.html")).default
    }),
    __param(4, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_WEB_URL')),
    __metadata("design:paramtypes", [_shared_dropdown_service__WEBPACK_IMPORTED_MODULE_2__["DropdownService"], _application_service__WEBPACK_IMPORTED_MODULE_3__["ApplicationService"], _angular_router__WEBPACK_IMPORTED_MODULE_7__["Router"], _angular_router__WEBPACK_IMPORTED_MODULE_7__["ActivatedRoute"], String, _moratorium_management_moratorium_management_service__WEBPACK_IMPORTED_MODULE_9__["MoratoriumManagementService"], _angular_material__WEBPACK_IMPORTED_MODULE_10__["MatDialog"]])
], ApplicationComponent);



/***/ }),

/***/ "./src/app/application/application.service.ts":
/*!****************************************************!*\
  !*** ./src/app/application/application.service.ts ***!
  \****************************************************/
/*! exports provided: ApplicationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationService", function() { return ApplicationService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let ApplicationService = class ApplicationService {
    constructor(httpClient, arcApiBaseUrl) {
        this.httpClient = httpClient;
        this.DisabledCounties = [
        //26, 27, //Acadia
        //1, 29, //Ascension
        //2, 30, //Assumption
        //3, 33, //Calcasieu
        //4, 34, //Cameron
        //5, 37, //East Baton Rouge
        //38, //East Feliciana
        //8, 41, //Iberville
        //9, 42, //Jefferson
        //10, 43, //Jefferson Davis
        //11, 44, //Lafayette
        //12, 45, //Lafourche
        //13, 46, //Livingston
        //14, 47, //Orleans
        //15, 48, //Plaquemines
        //49, //Pointe Coupee
        //16, 52, //St. Bernard
        //17, 53, //St. Charles
        //54, //St. Helena
        //18, 55, //st. James
        //19, 56, //st. John the Baptist
        //57, //st. Landry
        //20, 58, //st. Martin
        //21, 59, //st. Mary
        //22, 60, //st. Tammany
        //23, 61, //st. Tangipahoa
        //24, 62, //st. Terrebonne
        //25, 63, //Vermilion
        //65, //Washington
        //66, //West Baton Rouge
        //67, //West Feliciana
        ];
        this.arcApiBaseUrl = arcApiBaseUrl;
    }
    getStates() {
        var permStates = sessionStorage.getItem('state_access');
        var model = { PermStates: permStates, User: null };
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/states', model);
    }
    getFloodZones() {
        return this.httpClient.get(this.arcApiBaseUrl + '/api/1000/hiscox/floodzones');
    }
    rateQuote(app) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/quote', app);
    }
    getCounties() {
        return this.httpClient.get(this.arcApiBaseUrl + '/api/1000/hiscox/counties');
    }
    requote(requoteId) {
        return this.httpClient.get(this.arcApiBaseUrl + '/api/1000/hiscox/quote/getapplication/' + requoteId);
    }
    isDisabledCounty(countyId) {
        return this.DisabledCounties.indexOf(countyId) !== -1;
    }
};
ApplicationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_API_URL',] }] }
];
ApplicationService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    }),
    __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_API_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], String])
], ApplicationService);



/***/ }),

/***/ "./src/app/billing/billing.component.ts":
/*!**********************************************!*\
  !*** ./src/app/billing/billing.component.ts ***!
  \**********************************************/
/*! exports provided: BillingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BillingComponent", function() { return BillingComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _billing_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./billing.service */ "./src/app/billing/billing.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_userDto_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/userDto.model */ "./src/app/shared/userDto.model.ts");
/* harmony import */ var _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/role-mapper.service */ "./src/app/shared/role-mapper.service.ts");
/* harmony import */ var _shared_redirect_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shared/redirect.service */ "./src/app/shared/redirect.service.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _shared_moratorium_warning_dialog_moratorium_warning_dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../shared/moratorium-warning-dialog/moratorium-warning-dialog */ "./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};








let BillingComponent = class BillingComponent {
    constructor(billingService, router, roleMapper, arcWebUrl, redirectService, dialog) {
        this.billingService = billingService;
        this.router = router;
        this.roleMapper = roleMapper;
        this.arcWebUrl = arcWebUrl;
        this.redirectService = redirectService;
        this.dialog = dialog;
        this.disabledCounty = false;
    }
    ngOnInit() {
        let quote = JSON.parse(sessionStorage.getItem('quote'));
        if (quote === null || quote == undefined) {
            this.router.navigate(['/application']);
        }
        else {
            this.isExpired = false;
            this.isPremier = false;
            this.clientInformation = '';
            this.riskAddress = '';
            this.billingInformation = {};
            this.billingTypes = ["Mortgagee", "ACH"];
            this.mortgageesForQuote = [];
            this.achInformation = [];
            this.agencyNumber = '';
            this.achErrors = '';
            this.achSubmitted = false;
            let user = new _shared_userDto_model__WEBPACK_IMPORTED_MODULE_3__["UserDto"]();
            user.username = sessionStorage.getItem('user_agency');
            user.agencyNumber = sessionStorage.getItem('user_agency');
            user.userid = Number(sessionStorage.getItem("user_id"));
            user.agentid = Number(sessionStorage.getItem("agentId"));
            user.agencyid = Number(sessionStorage.getItem("agencyId"));
            this.role = this.roleMapper.mapRole(sessionStorage.getItem('user_roles'));
            user.role = this.role;
            this.user = user;
            this.quoteNum = quote.quoteNumber;
            this.billingService.checkQuoteStage(this.quoteNum).subscribe(response => this.checkQuoteStage(response));
            this.billingService.isQuoteExpired(this.quoteNum).subscribe(response => {
                this.isExpired = response.Expired;
                this.pastEffective = response.PastEffective;
            });
            this.billingService.getBillingInformation(this.quoteNum, user).subscribe(response => this.getBillingInformation(response));
            this.billingService.getMortgageesForQuote(this.quoteNum).subscribe(response => this.getMortgagees(response));
            this.billingService.getRatedQuote(this.quoteNum, user).subscribe(response => { this.quoteId = response.QuoteId; });
            this.billingService.getRiskAddress(this.quoteNum).subscribe(response => this.setRiskAddress(response));
            this.billingService.getCountyMoratoriumStatus(this.quoteNum).subscribe(response => this.isQuoteCountyDisabled = response);
        }
    }
    getMortgagees(response) {
        this.mortgageesForQuote = response;
        let flgPrimary = false;
        this.mortgageesForQuote.forEach(function (mort) {
            if (mort.FlgPrimary) {
                flgPrimary = true;
            }
        });
        this.flgPrimaryMort = flgPrimary;
    }
    getBillingInformation(response) {
        this.billingInformation = response;
        this.role = response.User.Role;
        this.agencyNumber = response.User.AgencyNumber;
        this.clientInformation = response.Quote.ClientName;
        var today = new Date();
        var oneWeek = new Date();
        oneWeek.setDate(oneWeek.getDate() + 7);
        oneWeek.setHours(0);
        oneWeek.setMinutes(0);
        oneWeek.setSeconds(0);
        oneWeek.setMilliseconds(0);
        var effDate = new Date(this.billingInformation.EffectiveDate);
        effDate.setHours(0);
        effDate.setMinutes(0);
        effDate.setSeconds(0);
        effDate.setMilliseconds(0);
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
        if (response.Quote.WaitingPeriodType == 2 || response.Quote.WaitingPeriodType == 3 || effDate >= oneWeek) {
            this.effectiveDateOneWeek = false;
        }
        else {
            this.effectiveDateOneWeek = true;
        }
        this.isPremier = this.billingInformation.Option.indexOf('Premier') > -1;
    }
    checkQuoteStage(response) {
        if (response != '/billing') {
            if (response == '/policy') {
                this.redirectService.policyByQuoteNumber(this.quoteNum).subscribe(response => {
                    this.redirectService.xenithRedirect(response);
                });
            }
            else {
                this.router.navigate([response]);
            }
        }
    }
    reQuote() {
        sessionStorage.setItem("requoteId", JSON.stringify(this.quoteId));
        this.router.navigate(['/application']);
    }
    removeQuoteOption() {
        this.billingService.removeQuoteOption(this.quoteNum).subscribe(response => {
            this.router.navigate(['/options']);
        });
    }
    showBillingType(billingType) {
        return billingType == this.billingType;
    }
    updateMortgagee() {
        this.router.navigate(['/mortgagee']);
    }
    bindQuote(isValid) {
        let billingValue = 0;
        if (this.isQuoteCountyDisabled == false) {
            this.openMoratoriumWarningDialog();
            isValid = false;
        }
        if (isValid) {
            switch (this.billingType) {
                case 'ACH':
                    this.achSubmitted = true;
                    billingValue = 1;
                    break;
                case 'Mortgagee':
                    billingValue = 2;
                    break;
            }
            var bindObject = {
                user: this.user,
                quoteId: this.quoteNum,
                paymentType: billingValue
            };
            this.showSpinner = true;
            switch (billingValue) {
                case 1:
                    var achModel = {
                        Amount: this.billingInformation.TotalDue,
                        BankName: this.achInformation.bankName,
                        AccountNumber: this.achInformation.accountNumber,
                        RoutingNumber: this.achInformation.routingNumber,
                        AccountName: this.achInformation.accountName,
                        AccountType: this.achInformation.accountType,
                        CustomerId: this.quoteNum
                    };
                    this.billingService.processAch(achModel).subscribe(response => {
                        if (!response.success) {
                            this.showSpinner = false;
                            this.achErrors = '';
                            this.achErrors = `<div>${response.data}</div>`;
                            return true;
                        }
                        else {
                            this.billingService.bindQuote(bindObject).subscribe(response => {
                                sessionStorage.setItem('policyNumber', response);
                                this.redirectService.xenithRedirect(response);
                            });
                        }
                    });
                    break;
                case 2:
                    this.billingService.bindQuote(bindObject).subscribe(response => {
                        sessionStorage.setItem('policyNumber', response);
                        this.redirectService.xenithRedirect(response);
                    });
                    break;
            }
        }
    }
    setRiskAddress(response) {
        this.riskAddress = response.Street1 + ((response.Street2 == null || response.Street2 == "") ? "" : (" " + response.Street2)) + " " + response.City + ", " + response.State + " " + response.Zip;
        if (this.billingService.isDisabledCounty(response.County)) {
            this.disabledCounty = true;
        }
    }
    openMoratoriumWarningDialog() {
        this.moratoriumWarningDialogRef = this.dialog.open(_shared_moratorium_warning_dialog_moratorium_warning_dialog__WEBPACK_IMPORTED_MODULE_7__["MoratoriumWarningDialog"], {
            width: '30%',
            data: 'County is currently under a moratorium. Cannot bind this quote.'
        });
    }
};
BillingComponent.ctorParameters = () => [
    { type: _billing_service__WEBPACK_IMPORTED_MODULE_1__["BillingService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_4__["RoleMapperService"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_WEB_URL',] }] },
    { type: _shared_redirect_service__WEBPACK_IMPORTED_MODULE_5__["RedirectService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatDialog"] }
];
BillingComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-billing-component',
        template: __importDefault(__webpack_require__(/*! raw-loader!./billing.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/billing/billing.component.html")).default
    }),
    __param(3, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_WEB_URL')),
    __metadata("design:paramtypes", [_billing_service__WEBPACK_IMPORTED_MODULE_1__["BillingService"], _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"], _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_4__["RoleMapperService"], String, _shared_redirect_service__WEBPACK_IMPORTED_MODULE_5__["RedirectService"], _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatDialog"]])
], BillingComponent);



/***/ }),

/***/ "./src/app/billing/billing.service.ts":
/*!********************************************!*\
  !*** ./src/app/billing/billing.service.ts ***!
  \********************************************/
/*! exports provided: BillingService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BillingService", function() { return BillingService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let BillingService = class BillingService {
    constructor(httpClient, arcApiBaseUrl) {
        this.httpClient = httpClient;
        this.arcApiBaseUrl = arcApiBaseUrl;
        this.DisabledCounties = [
        //"Acadia Parish",
        //"Ascension Parish",
        //"Assumption Parish",
        //"Calcasieu Parish",
        //"Cameron Parish",
        //"East Baton Rouge Parish",
        //"East Feliciana Parish",
        //"Iberville Parish",
        //"Jefferson Davis Parish",
        //"Jefferson Parish",
        //"Lafayette Parish",
        //"Lafourche Parish",
        //"Livingston Parish",
        //"Orleans Parish",
        //"Plaquemines Parish",
        //"Pointe Coupee Parish",
        //"St. Bernard Parish",
        //"St. Charles Parish",
        //"St. Helena Parish",
        //"St. James Parish",
        //"St. John the Baptist Parish",
        //"St. Landry Parish",
        //"St. Martin Parish",
        //"St. Mary Parish",
        //"St. Tammany Parish",
        //"Tangipahoa Parish",
        //"Terrebonne Parish",
        //"Vermilion Parish",
        //"Washington Parish",
        //"West Baton Rouge Parish",
        //"West Feliciana Parish"
        ];
    }
    getRiskAddress(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/number/${quoteNumber}/riskAddress`);
    }
    checkQuoteStage(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}/stage`);
    }
    isQuoteExpired(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/number/${quoteNumber}/expired`);
    }
    getBillingInformation(quoteNumber, user) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}/billing`, user);
    }
    getMortgageesForQuote(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/mortgagee/quote/${quoteNumber}`);
    }
    getRatedQuote(quoteNumber, user) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}`, user);
    }
    ;
    removeQuoteOption(quoteNumber) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}/removeOption`, null);
    }
    processAch(achModel) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/ach/process`, achModel);
    }
    bindQuote(bindObject) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/quote/bind`, bindObject);
    }
    isDisabledCounty(county) {
        return this.DisabledCounties.indexOf(county) !== -1;
    }
    getCountyMoratoriumStatus(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}/county/status`);
    }
};
BillingService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_API_URL',] }] }
];
BillingService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    }),
    __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_API_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], String])
], BillingService);



/***/ }),

/***/ "./src/app/directives/drag-and-drop.directive.ts":
/*!*******************************************************!*\
  !*** ./src/app/directives/drag-and-drop.directive.ts ***!
  \*******************************************************/
/*! exports provided: DragAndDropDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragAndDropDirective", function() { return DragAndDropDirective; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let DragAndDropDirective = class DragAndDropDirective {
    constructor() {
        this.fileDropped = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
    }
    // Dragover listener
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
    }
    // Dragleave listener
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
    }
    // Drop listener
    ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        let files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["HostBinding"])('class.fileover'),
    __metadata("design:type", Boolean)
], DragAndDropDirective.prototype, "fileOver", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"])(),
    __metadata("design:type", Object)
], DragAndDropDirective.prototype, "fileDropped", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"])('dragover', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DragAndDropDirective.prototype, "onDragOver", null);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"])('dragleave', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DragAndDropDirective.prototype, "onDragLeave", null);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["HostListener"])('drop', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DragAndDropDirective.prototype, "ondrop", null);
DragAndDropDirective = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"])({
        selector: '[appDragAndDrop]'
    })
], DragAndDropDirective);



/***/ }),

/***/ "./src/app/drag-and-drop-file/drag-and-drop-file.component.scss":
/*!**********************************************************************!*\
  !*** ./src/app/drag-and-drop-file/drag-and-drop-file.component.scss ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container {\n  width: 450px;\n  height: 200px;\n  padding: 2rem;\n  text-align: center;\n  border: dashed 1px #979797;\n  position: relative;\n  margin: 0 auto;\n}\n.container input {\n  opacity: 0;\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.container label {\n  color: white;\n  width: 183px;\n  height: 44px;\n  border-radius: 21.5px;\n  background-color: #4b9394;\n  padding: 8px 16px;\n}\n.container h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #38424c;\n}\n.fileover {\n  -webkit-animation: shake 1s;\n          animation: shake 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.files-list {\n  margin-top: 1.5rem;\n}\n.files-list .single-file {\n  display: flex;\n  padding: 0.5rem;\n  justify-content: space-between;\n  align-items: center;\n  border: dashed 1px #979797;\n  margin-bottom: 1rem;\n  display: flex;\n  flex-grow: 1;\n}\n.files-list .single-file img.delete {\n  margin-left: 0.5rem;\n  cursor: pointer;\n  align-self: flex-end;\n}\n.files-list .single-file .name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #353f4a;\n  margin: 0;\n}\n.files-list .single-file .size {\n  font-size: 12px;\n  font-weight: 500;\n  color: #a4a4a4;\n  margin: 0;\n  margin-bottom: 0.25rem;\n}\n.files-list .single-file .info {\n  width: 100%;\n}\n/* Shake animation */\n@-webkit-keyframes shake {\n  0% {\n    transform: translate(1px, 1px) rotate(0deg);\n  }\n  10% {\n    transform: translate(-1px, -2px) rotate(-1deg);\n  }\n  20% {\n    transform: translate(-3px, 0px) rotate(1deg);\n  }\n  30% {\n    transform: translate(3px, 2px) rotate(0deg);\n  }\n  40% {\n    transform: translate(1px, -1px) rotate(1deg);\n  }\n  50% {\n    transform: translate(-1px, 2px) rotate(-1deg);\n  }\n  60% {\n    transform: translate(-3px, 1px) rotate(0deg);\n  }\n  70% {\n    transform: translate(3px, 1px) rotate(-1deg);\n  }\n  80% {\n    transform: translate(-1px, -1px) rotate(1deg);\n  }\n  90% {\n    transform: translate(1px, 2px) rotate(0deg);\n  }\n  100% {\n    transform: translate(1px, -2px) rotate(-1deg);\n  }\n}\n@keyframes shake {\n  0% {\n    transform: translate(1px, 1px) rotate(0deg);\n  }\n  10% {\n    transform: translate(-1px, -2px) rotate(-1deg);\n  }\n  20% {\n    transform: translate(-3px, 0px) rotate(1deg);\n  }\n  30% {\n    transform: translate(3px, 2px) rotate(0deg);\n  }\n  40% {\n    transform: translate(1px, -1px) rotate(1deg);\n  }\n  50% {\n    transform: translate(-1px, 2px) rotate(-1deg);\n  }\n  60% {\n    transform: translate(-3px, 1px) rotate(0deg);\n  }\n  70% {\n    transform: translate(3px, 1px) rotate(-1deg);\n  }\n  80% {\n    transform: translate(-1px, -1px) rotate(1deg);\n  }\n  90% {\n    transform: translate(1px, 2px) rotate(0deg);\n  }\n  100% {\n    transform: translate(1px, -2px) rotate(-1deg);\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/drag-and-drop-file/drag-and-drop-file.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/drag-and-drop-file/drag-and-drop-file.component.ts ***!
  \********************************************************************/
/*! exports provided: DragAndDropFileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragAndDropFileComponent", function() { return DragAndDropFileComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../models/enums/pre-bind-file-type-enum */ "./src/app/models/enums/pre-bind-file-type-enum.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let DragAndDropFileComponent = class DragAndDropFileComponent {
    constructor() {
        this.disabled = false;
        this.onFilesLoaded = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.files = [];
    }
    set selectFiles(value) {
        this.staticSelectFiles = value;
        this.dynamicSelectFiles = value;
    }
    get selectFiles() {
        return this.staticSelectFiles;
    }
    onFileDropped($event) {
        if (this.disabled) {
            return;
        }
        this.prepareFilesList($event);
    }
    fileBrowseHandler(files) {
        if (this.disabled) {
            return;
        }
        this.prepareFilesList(files);
    }
    setFiles(files) {
        this.prepareFilesList(files, true);
    }
    clearFiles() {
        this.dynamicSelectFiles = this.staticSelectFiles;
        this.files = [];
        this.onFilesLoaded.next(this.files);
    }
    onSelectType(type, index) {
        this.files[index].type = type;
        this.onFilesLoaded.next(this.files);
    }
    deleteFile(index) {
        if (this.files[index].file.progress < 100) {
            return;
        }
        this.files.splice(index, 1);
        this.onFilesLoaded.next(this.files);
    }
    uploadFilesSimulator(index) {
        setTimeout(() => {
            if (index === this.files.length) {
                return;
            }
            else {
                const progressInterval = setInterval(() => {
                    if (this.files[index].file.progress === 100) {
                        clearInterval(progressInterval);
                        this.uploadFilesSimulator(index + 1);
                    }
                    else {
                        this.files[index].file.progress += 5;
                    }
                }, 200);
            }
        }, 1000);
    }
    prepareFilesList(files, preloadedFiles = false) {
        if (!files || files.length <= 0) {
            return;
        }
        const currentLength = this.files.length;
        if ((this.selectFiles.length > 0 && currentLength == this.selectFiles.length) || (this.selectFiles.length > 0 && (files.length + currentLength) > this.selectFiles.length)) {
            return;
        }
        for (const item of files) {
            if (preloadedFiles) {
                item.file.progress = 0;
                this.files.push(item);
                continue;
            }
            item.progress = 0;
            this.files.push({
                file: item,
                type: _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_1__["PreBindFileTypeEnum"].None
            });
        }
        this.fileDropEl.nativeElement.value = "";
        this.uploadFilesSimulator(0);
        if (preloadedFiles == false) {
            this.onFilesLoaded.next(this.files);
        }
    }
    getSelectTypeValue(index) {
        const currentSelect = this.fileSelects.find(x => x.nativeElement.id == index.toString());
        if (currentSelect && this.files[index].type != _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_1__["PreBindFileTypeEnum"].None && currentSelect.nativeElement.value == _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_1__["PreBindFileTypeEnum"].None.valueOf()) {
            currentSelect.nativeElement.value = this.files[index].type;
        }
    }
    downloadFile(index) {
        const file = this.files[index];
        this.getBase64(file.file).then((result) => {
            var blobContent = this.convertBase64StringToBlob(result, "application/pdf");
            let url = window.URL.createObjectURL(blobContent);
            window.open(url);
        });
    }
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    convertBase64StringToBlob(base64, contentType) {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return "0 Bytes";
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])("fileDropRef", { static: false }),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["ElementRef"])
], DragAndDropFileComponent.prototype, "fileDropEl", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChildren"])("fileSelect"),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["QueryList"])
], DragAndDropFileComponent.prototype, "fileSelects", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Boolean)
], DragAndDropFileComponent.prototype, "disabled", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DragAndDropFileComponent.prototype, "selectFiles", null);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"])(),
    __metadata("design:type", Object)
], DragAndDropFileComponent.prototype, "onFilesLoaded", void 0);
DragAndDropFileComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-drag-and-drop-file',
        template: __importDefault(__webpack_require__(/*! raw-loader!./drag-and-drop-file.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/drag-and-drop-file/drag-and-drop-file.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./drag-and-drop-file.component.scss */ "./src/app/drag-and-drop-file/drag-and-drop-file.component.scss")).default]
    })
], DragAndDropFileComponent);



/***/ }),

/***/ "./src/app/models/enums/pre-bind-file-type-enum.ts":
/*!*********************************************************!*\
  !*** ./src/app/models/enums/pre-bind-file-type-enum.ts ***!
  \*********************************************************/
/*! exports provided: PreBindFileTypeEnum */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreBindFileTypeEnum", function() { return PreBindFileTypeEnum; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var PreBindFileTypeEnum;
(function (PreBindFileTypeEnum) {
    PreBindFileTypeEnum[PreBindFileTypeEnum["None"] = 0] = "None";
    PreBindFileTypeEnum[PreBindFileTypeEnum["FloridaSurplusLinesForm"] = 1] = "FloridaSurplusLinesForm";
    PreBindFileTypeEnum[PreBindFileTypeEnum["FloridaNFIPForm"] = 2] = "FloridaNFIPForm";
})(PreBindFileTypeEnum || (PreBindFileTypeEnum = {}));


/***/ }),

/***/ "./src/app/models/enums/pre-bind-sign-status-enum.ts":
/*!***********************************************************!*\
  !*** ./src/app/models/enums/pre-bind-sign-status-enum.ts ***!
  \***********************************************************/
/*! exports provided: PreBindSignStatusEnum */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreBindSignStatusEnum", function() { return PreBindSignStatusEnum; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var PreBindSignStatusEnum;
(function (PreBindSignStatusEnum) {
    PreBindSignStatusEnum[PreBindSignStatusEnum["WaitingSignature"] = 1] = "WaitingSignature";
    PreBindSignStatusEnum[PreBindSignStatusEnum["WaitingApproval"] = 2] = "WaitingApproval";
    PreBindSignStatusEnum[PreBindSignStatusEnum["Approved"] = 3] = "Approved";
    PreBindSignStatusEnum[PreBindSignStatusEnum["Rejected"] = 4] = "Rejected";
    PreBindSignStatusEnum[PreBindSignStatusEnum["Failed"] = 5] = "Failed";
    PreBindSignStatusEnum[PreBindSignStatusEnum["Completed"] = 6] = "Completed";
})(PreBindSignStatusEnum || (PreBindSignStatusEnum = {}));


/***/ }),

/***/ "./src/app/models/enums/pre-bind-sign-type-enum.ts":
/*!*********************************************************!*\
  !*** ./src/app/models/enums/pre-bind-sign-type-enum.ts ***!
  \*********************************************************/
/*! exports provided: PreBindSignTypeEnum */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreBindSignTypeEnum", function() { return PreBindSignTypeEnum; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var PreBindSignTypeEnum;
(function (PreBindSignTypeEnum) {
    PreBindSignTypeEnum[PreBindSignTypeEnum["DocuSign"] = 1] = "DocuSign";
    PreBindSignTypeEnum[PreBindSignTypeEnum["Manually"] = 2] = "Manually";
})(PreBindSignTypeEnum || (PreBindSignTypeEnum = {}));


/***/ }),

/***/ "./src/app/models/moratorium-message-dto.ts":
/*!**************************************************!*\
  !*** ./src/app/models/moratorium-message-dto.ts ***!
  \**************************************************/
/*! exports provided: MoratoriumMessageDTO */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoratoriumMessageDTO", function() { return MoratoriumMessageDTO; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class MoratoriumMessageDTO {
}


/***/ }),

/***/ "./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.css":
/*!*******************************************************************************************************!*\
  !*** ./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.css ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".mat-form-field {\r\n  font-size: 14px;\r\n  width: 100%;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9yYXRvcml1bS1tYW5hZ2VtZW50L2RpYWxvZ3MvbW9yYXRvcml1bS1tZXNzYWdlLWRpYWxvZy9tb3JhdG9yaXVtLW1lc3NhZ2UtZGlhbG9nLmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGVBQWU7RUFDZixXQUFXO0FBQ2IiLCJmaWxlIjoic3JjL2FwcC9tb3JhdG9yaXVtLW1hbmFnZW1lbnQvZGlhbG9ncy9tb3JhdG9yaXVtLW1lc3NhZ2UtZGlhbG9nL21vcmF0b3JpdW0tbWVzc2FnZS1kaWFsb2cuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm1hdC1mb3JtLWZpZWxkIHtcclxuICBmb250LXNpemU6IDE0cHg7XHJcbiAgd2lkdGg6IDEwMCU7XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.ts":
/*!******************************************************************************************************!*\
  !*** ./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.ts ***!
  \******************************************************************************************************/
/*! exports provided: MoratoriumMessageDialog */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoratoriumMessageDialog", function() { return MoratoriumMessageDialog; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var src_app_models_moratorium_message_dto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/models/moratorium-message-dto */ "./src/app/models/moratorium-message-dto.ts");
/* harmony import */ var _moratorium_management_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../moratorium-management.service */ "./src/app/moratorium-management/moratorium-management.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




let MoratoriumMessageDialog = class MoratoriumMessageDialog {
    constructor(_moratoriumManagementService, _snackBar, dialogRef, data) {
        this._moratoriumManagementService = _moratoriumManagementService;
        this._snackBar = _snackBar;
        this.dialogRef = dialogRef;
        this.data = data;
        this.moratoriumMessage = new src_app_models_moratorium_message_dto__WEBPACK_IMPORTED_MODULE_2__["MoratoriumMessageDTO"];
    }
    onCancel() {
        this.dialogRef.close();
    }
    onSave() {
        this.dialogRef.afterClosed().subscribe(result => {
            this.moratoriumMessage.Message = result;
            this._moratoriumManagementService.createMoratoriumMessage(this.moratoriumMessage).subscribe(() => {
                this._snackBar.open('Moratorium message saved successfully', 'OK', {
                    horizontalPosition: 'end',
                    verticalPosition: 'top',
                    duration: 3000
                });
            });
        });
    }
};
MoratoriumMessageDialog.ctorParameters = () => [
    { type: _moratorium_management_service__WEBPACK_IMPORTED_MODULE_3__["MoratoriumManagementService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_1__["MatSnackBar"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_1__["MatDialogRef"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material__WEBPACK_IMPORTED_MODULE_1__["MAT_DIALOG_DATA"],] }] }
];
MoratoriumMessageDialog = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'moratorium-message-dialog',
        template: __importDefault(__webpack_require__(/*! raw-loader!./moratorium-message-dialog.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./moratorium-message-dialog.css */ "./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.css")).default]
    }),
    __param(3, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"])()), __param(3, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])(_angular_material__WEBPACK_IMPORTED_MODULE_1__["MAT_DIALOG_DATA"])),
    __metadata("design:paramtypes", [_moratorium_management_service__WEBPACK_IMPORTED_MODULE_3__["MoratoriumManagementService"], _angular_material__WEBPACK_IMPORTED_MODULE_1__["MatSnackBar"], _angular_material__WEBPACK_IMPORTED_MODULE_1__["MatDialogRef"], String])
], MoratoriumMessageDialog);



/***/ }),

/***/ "./src/app/moratorium-management/moratorium-management.component.css":
/*!***************************************************************************!*\
  !*** ./src/app/moratorium-management/moratorium-management.component.css ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table {\r\n  width: 100%;\r\n}\r\n\r\n.mat-form-field {\r\n  font-size: 14px;\r\n  width: 70%;\r\n}\r\n\r\nmat-radio-button {\r\n  padding-left: 10px;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9yYXRvcml1bS1tYW5hZ2VtZW50L21vcmF0b3JpdW0tbWFuYWdlbWVudC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBVztBQUNiOztBQUVBO0VBQ0UsZUFBZTtFQUNmLFVBQVU7QUFDWjs7QUFFQTtFQUNFLGtCQUFrQjtBQUNwQiIsImZpbGUiOiJzcmMvYXBwL21vcmF0b3JpdW0tbWFuYWdlbWVudC9tb3JhdG9yaXVtLW1hbmFnZW1lbnQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbInRhYmxlIHtcclxuICB3aWR0aDogMTAwJTtcclxufVxyXG5cclxuLm1hdC1mb3JtLWZpZWxkIHtcclxuICBmb250LXNpemU6IDE0cHg7XHJcbiAgd2lkdGg6IDcwJTtcclxufVxyXG5cclxubWF0LXJhZGlvLWJ1dHRvbiB7XHJcbiAgcGFkZGluZy1sZWZ0OiAxMHB4O1xyXG59XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/moratorium-management/moratorium-management.component.ts":
/*!**************************************************************************!*\
  !*** ./src/app/moratorium-management/moratorium-management.component.ts ***!
  \**************************************************************************/
/*! exports provided: MoratoriumManagementComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoratoriumManagementComponent", function() { return MoratoriumManagementComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/collections */ "./node_modules/@angular/cdk/esm2015/collections.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _moratorium_management_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./moratorium-management.service */ "./src/app/moratorium-management/moratorium-management.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_userDto_model__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../shared/userDto.model */ "./src/app/shared/userDto.model.ts");
/* harmony import */ var _dialogs_moratorium_message_dialog_moratorium_message_dialog__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./dialogs/moratorium-message-dialog/moratorium-message-dialog */ "./src/app/moratorium-management/dialogs/moratorium-message-dialog/moratorium-message-dialog.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _models_moratorium_message_dto__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../models/moratorium-message-dto */ "./src/app/models/moratorium-message-dto.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};











let MoratoriumManagementComponent = class MoratoriumManagementComponent {
    constructor(_moratoriumManagementService, router, route, arcWebUrl, dialog, _snackBar, _location) {
        this._moratoriumManagementService = _moratoriumManagementService;
        this.router = router;
        this.route = route;
        this.arcWebUrl = arcWebUrl;
        this.dialog = dialog;
        this._snackBar = _snackBar;
        this._location = _location;
        this.displayedColumns = ['CountyName', 'StateName', 'flgActive'];
        this.selection = new _angular_cdk_collections__WEBPACK_IMPORTED_MODULE_1__["SelectionModel"](true, []);
        this.filterValues = {};
        this.updatedCounties = [];
        this.activityFilter = 'all';
        this.user = new _shared_userDto_model__WEBPACK_IMPORTED_MODULE_7__["UserDto"]();
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            let user = params['u'];
            let token = sessionStorage.getItem('user_token');
            if (token != null || token != undefined) {
                this.init();
            }
            else if (user == undefined || user == null) {
                window.location.href = this.arcWebUrl;
            }
            else {
                this.decodeUser(user);
                let url = this.router.url.substring(0, this.router.url.indexOf("?"));
                this.router.navigateByUrl(url);
            }
        });
        this._moratoriumManagementService.getMoratoriumMessage().subscribe(response => {
            if (response != null) {
                this.moratoriumMessage = response;
            }
            else {
                this.moratoriumMessage = new _models_moratorium_message_dto__WEBPACK_IMPORTED_MODULE_10__["MoratoriumMessageDTO"]();
            }
        });
    }
    init() {
        this._moratoriumManagementService.getCounties()
            .subscribe(response => this.getCounties(response));
    }
    // Session authentication method
    decodeUser(obj) {
        var userObject = JSON.parse(atob(obj));
        sessionStorage.setItem("user_id", userObject.userId);
        sessionStorage.setItem("name", userObject.name);
        sessionStorage.setItem("permissions", JSON.stringify(userObject.user_permissions));
        sessionStorage.setItem("refreshToken", userObject.refreshToken);
        sessionStorage.setItem("user_token", userObject.user_token);
        sessionStorage.setItem("state_access", userObject.state_access);
        sessionStorage.setItem("token_expiration", userObject.token_expiration);
        sessionStorage.setItem("user_agency", userObject.agency);
        sessionStorage.setItem('user_roles', JSON.stringify(userObject.user_roles));
        sessionStorage.setItem('agentId', userObject.agentId);
        sessionStorage.setItem('agencyId', userObject.agencyId);
    }
    // Data manipulation methods
    getCounties(response) {
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_2__["MatTableDataSource"](response);
        this.dataSource.paginator = this.paginator;
        // Check the checkboxes of the counties that are active
        this.dataSource.data.forEach(row => {
            if (row.FlgActive == 'true') {
                this.selection.select(row);
            }
        });
    }
    updateCounties() {
        this._moratoriumManagementService.updateCountyActivity(JSON.stringify(this.updatedCounties))
            .subscribe(response => this.openSubmitedSnackBar());
        this.updatedCounties = [];
    }
    addToUpdatedCounties(row, event) {
        var newRow = row;
        event.checked ? newRow.FlgActive = 'true' : newRow.FlgActive = 'false';
        if (!this.updatedCounties.includes(row)) {
            this.updatedCounties.push(row);
        }
        else {
            this.updatedCounties[this.updatedCounties.indexOf(row)] = newRow;
        }
    }
    // Filter methods
    applyFilterCounty(column, filterValue) {
        this.dataSource.filterPredicate = ((data, filter) => {
            const filterValues = JSON.parse(filter);
            return (this.countyName ? data.CountyName.trim().toLowerCase().indexOf(filterValues.county) !== -1 : true) &&
                (this.activityFilter == 'all' ? true : data.FlgActive.trim().toLowerCase() == filterValues.active);
        });
        this.filterValues[column] = filterValue;
        this.dataSource.filter = JSON.stringify(this.filterValues);
        if (this.dataSource.filteredData.length > 0) {
            this.dataSource.filteredData.forEach(row => {
                if (this.filterValues['active'] == 'true') {
                    this.selection.select(row);
                }
                else if (this.filterValues['active'] == 'false') {
                    this.selection.deselect(row);
                }
                else {
                    if (row.FlgActive == 'true')
                        this.selection.select(row);
                    else
                        this.selection.deselect(row);
                }
            });
        }
        if (this.updatedCounties.length > 0) {
            this.updatedCounties.forEach(row => {
                if (this.filterValues['active'] == 'true') {
                    this.selection.select(row);
                }
                else if (this.filterValues['active'] == 'false') {
                    this.selection.deselect(row);
                }
            });
        }
    }
    // Dialog methods
    openMoratoriumMessageDialog() {
        const dialogRef = this.dialog.open(_dialogs_moratorium_message_dialog_moratorium_message_dialog__WEBPACK_IMPORTED_MODULE_8__["MoratoriumMessageDialog"], {
            width: '30%',
            data: this.moratoriumMessage.Message
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result != undefined) {
                this.moratoriumMessage.Message = result;
            }
        });
    }
    // SnackBar method
    openSubmitedSnackBar() {
        let snackbar = this._snackBar.open('The status of the counties were updated', 'OK', {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration: 3000
        });
    }
};
MoratoriumManagementComponent.ctorParameters = () => [
    { type: _moratorium_management_service__WEBPACK_IMPORTED_MODULE_5__["MoratoriumManagementService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["ActivatedRoute"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_WEB_URL',] }] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialog"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatSnackBar"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_9__["Location"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], MoratoriumManagementComponent.prototype, "paginator", void 0);
MoratoriumManagementComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-moratorium-management',
        template: __importDefault(__webpack_require__(/*! raw-loader!./moratorium-management.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/moratorium-management/moratorium-management.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./moratorium-management.component.css */ "./src/app/moratorium-management/moratorium-management.component.css")).default]
    }),
    __param(3, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_WEB_URL')),
    __metadata("design:paramtypes", [_moratorium_management_service__WEBPACK_IMPORTED_MODULE_5__["MoratoriumManagementService"], _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"], _angular_router__WEBPACK_IMPORTED_MODULE_6__["ActivatedRoute"], String, _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialog"], _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatSnackBar"], _angular_common__WEBPACK_IMPORTED_MODULE_9__["Location"]])
], MoratoriumManagementComponent);



/***/ }),

/***/ "./src/app/moratorium-management/moratorium-management.service.ts":
/*!************************************************************************!*\
  !*** ./src/app/moratorium-management/moratorium-management.service.ts ***!
  \************************************************************************/
/*! exports provided: MoratoriumManagementService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoratoriumManagementService", function() { return MoratoriumManagementService; });
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




let MoratoriumManagementService = class MoratoriumManagementService {
    constructor(httpClient, arcApiBaseUrl) {
        this.httpClient = httpClient;
        this.arcApiBaseUrl = arcApiBaseUrl;
    }
    getCounties() {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/moratorium/counties`)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('getCounties', [])), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(response => {
            return response.map(county => {
                return {
                    Id: county.Id,
                    CountyName: county.CountyName,
                    StateName: county.StateName,
                    FlgActive: county.FlgActive.toString()
                };
            });
        }));
    }
    updateCountyActivity(updatedCounties) {
        return this.httpClient.put(this.arcApiBaseUrl + `/api/1000/hiscox/moratorium/counties`, JSON.parse(updatedCounties))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('updateCountyActivity', [])));
    }
    createMoratoriumMessage(message) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/moratorium/message`, message)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('createMoratoriumMessage', [])));
    }
    getMoratoriumMessage() {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/moratorium/message`)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('getMoratoriumMessage', [])));
    }
    /**
    * Handle Http operation that failed.
    * Let the app continue.
    *
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    log(message) {
        console.log(message);
    }
};
MoratoriumManagementService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_0__["HttpClient"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: ['ARC_API_URL',] }] }
];
MoratoriumManagementService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])('ARC_API_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_0__["HttpClient"], String])
], MoratoriumManagementService);



/***/ }),

/***/ "./src/app/mortgagee/mortgagee.component.scss":
/*!****************************************************!*\
  !*** ./src/app/mortgagee/mortgagee.component.scss ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container {\n  width: 450px;\n  height: 200px;\n  padding: 2rem;\n  text-align: center;\n  border: dashed 1px #979797;\n  position: relative;\n  margin: 0 auto;\n}\n.container input {\n  opacity: 0;\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.container label {\n  color: white;\n  width: 183px;\n  height: 44px;\n  border-radius: 21.5px;\n  background-color: #4b9394;\n  padding: 8px 16px;\n}\n.container h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #38424c;\n}\n.fileover {\n  -webkit-animation: shake 1s;\n          animation: shake 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.files-list {\n  margin-top: 1.5rem;\n}\n.files-list .single-file {\n  display: flex;\n  padding: 0.5rem;\n  justify-content: space-between;\n  align-items: center;\n  border: dashed 1px #979797;\n  margin-bottom: 1rem;\n  display: flex;\n  flex-grow: 1;\n}\n.files-list .single-file img.delete {\n  margin-left: 0.5rem;\n  cursor: pointer;\n  align-self: flex-end;\n}\n.files-list .single-file .name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #353f4a;\n  margin: 0;\n}\n.files-list .single-file .size {\n  font-size: 12px;\n  font-weight: 500;\n  color: #a4a4a4;\n  margin: 0;\n  margin-bottom: 0.25rem;\n}\n.files-list .single-file .info {\n  width: 100%;\n}\n/* Shake animation */\n@-webkit-keyframes shake {\n  0% {\n    transform: translate(1px, 1px) rotate(0deg);\n  }\n  10% {\n    transform: translate(-1px, -2px) rotate(-1deg);\n  }\n  20% {\n    transform: translate(-3px, 0px) rotate(1deg);\n  }\n  30% {\n    transform: translate(3px, 2px) rotate(0deg);\n  }\n  40% {\n    transform: translate(1px, -1px) rotate(1deg);\n  }\n  50% {\n    transform: translate(-1px, 2px) rotate(-1deg);\n  }\n  60% {\n    transform: translate(-3px, 1px) rotate(0deg);\n  }\n  70% {\n    transform: translate(3px, 1px) rotate(-1deg);\n  }\n  80% {\n    transform: translate(-1px, -1px) rotate(1deg);\n  }\n  90% {\n    transform: translate(1px, 2px) rotate(0deg);\n  }\n  100% {\n    transform: translate(1px, -2px) rotate(-1deg);\n  }\n}\n@keyframes shake {\n  0% {\n    transform: translate(1px, 1px) rotate(0deg);\n  }\n  10% {\n    transform: translate(-1px, -2px) rotate(-1deg);\n  }\n  20% {\n    transform: translate(-3px, 0px) rotate(1deg);\n  }\n  30% {\n    transform: translate(3px, 2px) rotate(0deg);\n  }\n  40% {\n    transform: translate(1px, -1px) rotate(1deg);\n  }\n  50% {\n    transform: translate(-1px, 2px) rotate(-1deg);\n  }\n  60% {\n    transform: translate(-3px, 1px) rotate(0deg);\n  }\n  70% {\n    transform: translate(3px, 1px) rotate(-1deg);\n  }\n  80% {\n    transform: translate(-1px, -1px) rotate(1deg);\n  }\n  90% {\n    transform: translate(1px, 2px) rotate(0deg);\n  }\n  100% {\n    transform: translate(1px, -2px) rotate(-1deg);\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/mortgagee/mortgagee.component.ts":
/*!**************************************************!*\
  !*** ./src/app/mortgagee/mortgagee.component.ts ***!
  \**************************************************/
/*! exports provided: MortgageeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MortgageeComponent", function() { return MortgageeComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _mortgagee_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mortgagee.service */ "./src/app/mortgagee/mortgagee.service.ts");
/* harmony import */ var _shared_mortgagee_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/mortgagee.model */ "./src/app/shared/mortgagee.model.ts");
/* harmony import */ var _shared_additionalInsured_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/additionalInsured.model */ "./src/app/shared/additionalInsured.model.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_userDto_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shared/userDto.model */ "./src/app/shared/userDto.model.ts");
/* harmony import */ var _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../shared/role-mapper.service */ "./src/app/shared/role-mapper.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _drag_and_drop_file_drag_and_drop_file_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../drag-and-drop-file/drag-and-drop-file.component */ "./src/app/drag-and-drop-file/drag-and-drop-file.component.ts");
/* harmony import */ var _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../models/enums/pre-bind-file-type-enum */ "./src/app/models/enums/pre-bind-file-type-enum.ts");
/* harmony import */ var _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../models/enums/pre-bind-sign-status-enum */ "./src/app/models/enums/pre-bind-sign-status-enum.ts");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _models_enums_pre_bind_sign_type_enum__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../models/enums/pre-bind-sign-type-enum */ "./src/app/models/enums/pre-bind-sign-type-enum.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};













let MortgageeComponent = class MortgageeComponent {
    constructor(mortgageeService, router, route, roleMapper) {
        this.mortgageeService = mortgageeService;
        this.router = router;
        this.route = route;
        this.roleMapper = roleMapper;
        this.floridaFiles = [];
        this.state = '';
        this.signByDocuSign = false;
        this.isFlorida = false;
        this.hasFiles = false;
        this.hasChanges = false;
        this.uploadFileSuccess = false;
        this.isQuoteApproved = false;
        this.preBindSignStatus = null;
        this.currentPreBindSign = null;
        this.insuredEmail = '';
        this.mortgagee = new _shared_mortgagee_model__WEBPACK_IMPORTED_MODULE_2__["Mortgagee"]();
        this.tempMortgagee = new _shared_mortgagee_model__WEBPACK_IMPORTED_MODULE_2__["Mortgagee"]();
        this.tempMortgagee2 = new _shared_mortgagee_model__WEBPACK_IMPORTED_MODULE_2__["Mortgagee"]();
        this.user = new _shared_userDto_model__WEBPACK_IMPORTED_MODULE_5__["UserDto"]();
        this.additionalInsured = [];
        this.addAdditionalInsured = false;
        this.additionalInsuredNew = new _shared_additionalInsured_model__WEBPACK_IMPORTED_MODULE_3__["AdditionalInsured"]();
        this.additionalInsuredNew.typeId = 1;
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            let user = params['u'];
            if (user != undefined || user != null) {
                this.decodeUser(user);
                let quoteNumber = params['q'];
                var quote = {
                    quoteNumber: Number(quoteNumber)
                };
                sessionStorage.setItem('quote', JSON.stringify(quote));
                let url = this.router.url.substring(0, this.router.url.indexOf("?"));
                this.router.navigateByUrl(url);
            }
        });
        this.allowedFiles = [
            { text: "Surplus Lines", value: _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].FloridaSurplusLinesForm },
            { text: "NFIP Acknowledgment", value: _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].FloridaNFIPForm }
        ];
        let quote = JSON.parse(sessionStorage.getItem('quote'));
        if (quote == undefined || quote == null) {
            this.router.navigate(['/application']);
        }
        this.populateDropDowns();
        this.user.username = sessionStorage.getItem('user_agency');
        this.user.agencyNumber = sessionStorage.getItem('user_agency');
        this.user.role = this.roleMapper.mapRole(sessionStorage.getItem('user_roles'));
        this.user.userid = Number(sessionStorage.getItem("user_id"));
        this.user.agentid = Number(sessionStorage.getItem("agentId"));
        this.user.agencyid = Number(sessionStorage.getItem("agencyId"));
        this.quoteNum = quote.quoteNumber;
        this.clientInformation = '';
        this.riskAddress = '';
        this.toggle = 'one';
        this.mortgageeService.getQuoteId(quote.quoteNumber).subscribe(response => {
            this.quoteId = response;
            this.getPreBindSign();
            this.downloadPreBindDocuments();
            this.isFloridaFormsApproved();
            this.getPreBindStatus();
        });
        this.mortgageeService.expiredCheck(quote.quoteNumber).subscribe(response => this.isExpired = response.Expired);
        this.mortgageeService.mortgageesByQuoteNumber(quote.quoteNumber).subscribe(response => this.getMortgageesForQuote(response));
        this.mortgageeService.getRatedQuote(quote.quoteNumber, this.user).subscribe(response => this.getRatedQuote(response));
        this.mortgageeService.getStates().subscribe(response => this.statesDropDown = response);
        this.mortgageeService.getRiskAddress(quote.quoteNumber).subscribe(response => this.setRiskAddress(response));
        this.mortgageeService.getAdditionalInsured(quote.quoteNumber).subscribe(response => this.additionalInsured = response);
    }
    isFloridaFormsApproved() {
        this.mortgageeService.isQuoteApproved(this.quoteId).subscribe((result) => {
            if (result != null && result == true) {
                this.isQuoteApproved = true;
            }
            else {
                this.isQuoteApproved = false;
            }
        });
    }
    getPreBindStatus() {
        this.mortgageeService.getPreBindStatus(this.quoteId).subscribe((result) => {
            if (result) {
                this.preBindSignStatus = result;
            }
        });
    }
    getPreBindSign() {
        this.mortgageeService.getPreBindSign(this.quoteId).subscribe((result) => {
            if (result) {
                this.currentPreBindSign = result;
                this.insuredEmail = result.InsuredEmail;
                this.signByDocuSign = this.currentPreBindSign.SignTypeId == _models_enums_pre_bind_sign_type_enum__WEBPACK_IMPORTED_MODULE_12__["PreBindSignTypeEnum"].DocuSign ? true : false;
            }
        });
    }
    toggleData(val) {
        this.toggle = val;
    }
    addMortgagee(valid) {
        if (valid) {
            if (this.toggle === 'two') {
                this.quoteMortgagee.flgPrimary = true;
            }
            let mortgageeObject = {
                QuoteNum: this.quoteNum,
                LoanNumber: this.mortgagee.loanNumber.trim(),
                Name1: this.mortgagee.name1.trim(),
                Name2: this.mortgagee.name2 ? this.mortgagee.name2.trim() : this.mortgagee.name2,
                Street1: this.mortgagee.street1.trim(),
                Street2: this.mortgagee.street2 ? this.mortgagee.street2.trim() : this.mortgagee.street2,
                City: this.mortgagee.city.trim(),
                StateId: this.mortgagee.stateId,
                Zip: this.mortgagee.zip.trim(),
                FlgPrimary: this.quoteMortgagee.flgPrimary,
                user: this.user
            };
            this.mortgageeService.createMortgagee(mortgageeObject).subscribe(response => {
                this.showSpinner = false;
                this.mortgageeService.mortgageesByQuoteNumber(this.quoteNum).subscribe(response => this.getMortgageesForQuote(response));
                this.rowToEdit = null;
            });
        }
    }
    getMortgageesForQuote(response) {
        this.mortgageesForQuote = response;
        if (response.length === 1) {
            this.toggle = 'three';
        }
        else if (response.length === 2) {
            this.toggle = 'five';
        }
        else {
            this.toggle = 'one';
        }
        this.mortgagee = new _shared_mortgagee_model__WEBPACK_IMPORTED_MODULE_2__["Mortgagee"]();
        this.showSpinner = false;
    }
    getRatedQuote(response) {
        this.clientInformation = response.ClientName;
    }
    setRiskAddress(response) {
        this.isFlorida = response.State == 'FL';
        this.state = response.State;
        this.riskAddress = response.Street1 + ((response.Street2 == null || response.Street2 == "") ? "" : (" " + response.Street2)) + " " + response.City + ", " + response.State + " " + response.Zip;
    }
    populateDropDowns() {
        this.quoteMortgagee = {
            enableSorting: true,
            columnDefs: [
                { name: 'Id', field: 'Id' },
                { name: 'loanNumber', field: 'LoanNumber' },
                { name: 'name1', field: 'Name1' },
                { name: 'name2', field: 'Name2' },
                { name: 'street1', field: 'Street1' },
                { name: 'street2', field: 'Street2' },
                { name: 'city', field: 'City' },
                { name: 'stateId', field: 'StateId' },
                { name: 'zip', field: 'Zip' },
                { name: 'flgPrimary', field: 'FlgPrimary' }
            ]
        };
        this.additionalInsuredTypeDropDown = [
            { Id: 1, Value: "Individual" },
            { Id: 3, Value: "HOA" },
            { Id: 2, Value: "Corporation" }
        ];
    }
    goToBilling() {
        this.router.navigate(['/billing']);
    }
    showEdit(index) {
        this.rowToEdit = index;
    }
    editAi(index, valid) {
        if (valid) {
            this.aiRowToEdit = index;
        }
    }
    removeMortgagee(mortgagee) {
        this.showSpinner = true;
        let mortgageeObject = {
            Id: mortgagee.Id,
            User: this.user
        };
        this.mortgageeService.removeMortgagee(mortgageeObject).subscribe(response => {
            this.mortgageeService.mortgageesByQuoteNumber(this.quoteNum).subscribe(response => {
                this.getMortgageesForQuote(response);
                this.showSpinner = false;
            });
        });
    }
    updateMortgagee(mortgagee) {
        this.showSpinner = true;
        mortgagee.QuoteNum = this.quoteNum;
        this.mortgageeService.updateMortgagee(mortgagee).subscribe(response => {
            this.showSpinner = false;
            if (response === false) {
                this.showSpinner = false;
                this.showErrorMessage = true;
                this.errorMessage = 'Only one mortgagee can be primary';
            }
            else if (response === true) {
                this.mortgageeService.mortgageesByQuoteNumber(this.quoteNum).subscribe(response => {
                    this.getMortgageesForQuote(response);
                    this.rowToEdit = null;
                    this.showSpinner = false;
                });
            }
        });
    }
    mapAdditionalInsured(id) {
        if (id == 1) {
            return 'Individual';
        }
        else if (id == 2) {
            return 'Corporation';
        }
        else if (id == 3) {
            return 'HOA';
        }
    }
    addAdditionalInsuredEditableRow(valid) {
        if (valid) {
            let temp = {
                Id: 0,
                QuoteId: this.quoteId,
                FirstName: this.additionalInsuredNew.firstName,
                LastName: this.additionalInsuredNew.lastName,
                EntityName: this.additionalInsuredNew.entityName,
                AdditionalInsuredTypeId: this.additionalInsuredNew.typeId,
                AddressLine1: this.additionalInsuredNew.street1,
                AddressLine2: this.additionalInsuredNew.street2,
                City: this.additionalInsuredNew.city,
                StateId: this.additionalInsuredNew.stateId,
                ZipCode: this.additionalInsuredNew.zip
            };
            this.additionalInsured.push(temp);
            this.aiRowToEdit = this.additionalInsured.length - 1;
            this.addAdditionalInsured = false;
            this.additionalInsuredNew = new _shared_additionalInsured_model__WEBPACK_IMPORTED_MODULE_3__["AdditionalInsured"]();
            this.additionalInsuredNew.typeId = 1;
            this.updateAdditionalInsured(valid);
        }
    }
    aiTypeChange(index, type) {
        switch (type) {
            case 1:
                if (index !== -1) {
                    this.additionalInsured[index].EntityName = '';
                }
                else {
                    this.additionalInsuredNew.entityName = '';
                }
                break;
            case 2:
            case 3:
                if (index !== -1) {
                    this.additionalInsured[index].FirstName = '';
                    this.additionalInsured[index].LastName = '';
                }
                else {
                    this.additionalInsuredNew.firstName = '';
                    this.additionalInsuredNew.lastName = '';
                }
                break;
        }
    }
    updateAdditionalInsured(valid) {
        if (valid) {
            this.additionalInsured[this.aiRowToEdit].QuoteId = this.quoteId;
            let model = this.additionalInsured[this.aiRowToEdit];
            model.user = this.user;
            this.mortgageeService.updateAdditionalInsured(model).subscribe(response => {
                this.mortgageeService.getAdditionalInsured(this.quoteNum).subscribe(ai => {
                    this.aiForm.resetForm();
                    this.additionalInsured = ai;
                    this.aiRowToEdit = null;
                });
            });
        }
    }
    cancelAdditionalInsured() {
        if (this.additionalInsured[this.aiRowToEdit].Id == 0) {
            this.aiForm.resetForm();
            this.additionalInsured.splice(this.aiRowToEdit, 1);
        }
        else {
            this.mortgageeService.getAdditionalInsured(this.quoteNum).subscribe(ai => {
                this.aiForm.resetForm();
                this.additionalInsured = ai;
                this.aiRowToEdit = null;
            });
        }
        this.aiRowToEdit = null;
    }
    removeAdditionalInsured(index) {
        let id = this.additionalInsured[index].Id;
        this.mortgageeService.removeAdditionalInsured(id).subscribe(response => {
            this.aiForm.resetForm();
            this.additionalInsured.splice(index, 1);
        });
    }
    onFloridaFormsDropped(forms) {
        if (this.hasFiles) {
            this.hasChanges = true;
        }
        this.floridaFiles = forms;
    }
    isFloridaFormsValid() {
        if (this.state != 'FL') {
            return true;
        }
        else if (!this.isQuoteApproved) {
            return false;
        }
        return true;
    }
    isFileTypeDuplicated() {
        for (const allowed of this.allowedFiles) {
            if (this.floridaFiles.filter(x => x.type == allowed.value).length > 1) {
                return true;
            }
        }
        return false;
    }
    submitFiles() {
        if (this.hasFiles && this.hasChanges == false) {
            return;
        }
        else if (this.floridaFiles.filter(x => x.type == _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].None).length > 0) {
            sweetalert2__WEBPACK_IMPORTED_MODULE_11___default.a.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Error sending files',
                html: 'Unable to upload files without a type, please select one.',
                confirmButtonText: 'Ok'
            });
            return;
        }
        else if (this.isFileTypeDuplicated()) {
            sweetalert2__WEBPACK_IMPORTED_MODULE_11___default.a.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Error sending files',
                html: 'Unable to upload files of the same type, please select again.',
                confirmButtonText: 'Ok'
            });
            return;
        }
        this.showSpinner = true;
        let surplusForm = {
            quoteId: this.quoteId,
            policyId: 0,
            user: this.user,
            fileName: 'Surplus_Lines.pdf',
            fileData: '',
            fileType: _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].FloridaSurplusLinesForm,
            docDescription: 'Signed Florida Surplus Lines'
        };
        let NFIPForm = {
            quoteId: this.quoteId,
            policyId: 0,
            user: this.user,
            fileName: 'NFIP_Acknowledgment.pdf',
            fileData: '',
            fileType: _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].FloridaNFIPForm,
            docDescription: 'Signed Florida NFIP'
        };
        this.getBase64(this.floridaFiles.find(x => x.type == _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].FloridaSurplusLinesForm).file).then((surplusBase64) => {
            surplusForm.fileData = surplusBase64;
            this.getBase64(this.floridaFiles.find(x => x.type == _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].FloridaNFIPForm).file).then((NFIPBase64) => {
                NFIPForm.fileData = NFIPBase64;
                const filesToUpload = new Array();
                filesToUpload.push(surplusForm, NFIPForm);
                this.mortgageeService.uploadFloridaFormsManuallySigned(filesToUpload).subscribe((result) => {
                    this.showSpinner = false;
                    if (result) {
                        sweetalert2__WEBPACK_IMPORTED_MODULE_11___default.a.fire({
                            icon: 'success',
                            showCloseButton: true,
                            title: 'Documents sent!',
                            html: '<div style="font-size: 14px"><p align="justify">Your signed documents have been submitted to Underwriting for review. Please allow 24 business hours for a response.<br/><br/>' +
                                'NOTE: <br/></div>' +
                                '<div style="font-size: 10px" align="justify">1. Coverage has not been bound. If approved, you must access the quote from the Approved Quotes section and submit the application to Underwriting for final approval.<br/>' +
                                '2. A successful quote submission does not guaranty binding of coverage. TWFG Underwriting retains final binding authority.<br/>' +
                                '3. Coverage cannot be back-dated for any reason (this includes the 7-day waiting period).<br/><br/>' +
                                'If you have any questions or need this review expedited, please contact our Underwriting team at (281) 367-3424 or underwriting@twfg.com. </p></div>',
                            confirmButtonText: 'Ok'
                        });
                        this.uploadFileSuccess = true;
                        this.dndComponent.clearFiles();
                        this.getPreBindSign();
                        this.downloadPreBindDocuments();
                        this.getPreBindStatus();
                        this.isFloridaFormsApproved();
                        this.hasChanges = false;
                    }
                }, error => {
                    this.showSpinner = false;
                });
            });
        });
    }
    downloadPreBindDocuments() {
        this.showSpinner = true;
        this.mortgageeService.getPreBindDocuments(this.quoteId).subscribe((response) => {
            this.showSpinner = false;
            if (response && response.length > 0) {
                this.hasFiles = true;
                for (let file of response) {
                    const blobFileData = this.base64ToBlob(file.FileBase64, file.ContentType);
                    this.floridaFiles.push({
                        file: new File([blobFileData], file.FileName),
                        type: file.FileType
                    });
                }
                this.dndComponent.setFiles(this.floridaFiles);
            }
            else {
                this.floridaFiles = [];
                this.dndComponent.clearFiles();
            }
        }, error => {
            this.showSpinner = false;
        });
    }
    base64ToBlob(dataURI, contentType) {
        const byteString = atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: contentType });
        return blob;
    }
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    getPreBindStatusText(status) {
        switch (status) {
            case _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Approved:
                return {
                    Text: "Approved",
                    Color: "#15b800"
                };
            case _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Rejected:
                return {
                    Text: "Rejected",
                    Color: "#e30000"
                };
            case _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingApproval:
                return {
                    Text: "Waiting for approval",
                    Color: "#e0ad02"
                };
            case _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingSignature:
                return {
                    Text: "Waiting for signature",
                    Color: "#e0ad02"
                };
            case _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Completed:
                return {
                    Text: "Completed",
                    Color: "#15b800"
                };
            case _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Failed:
                return {
                    Text: "Failed",
                    Color: "#e30000"
                };
        }
    }
    areFilesReadyToSubmit() {
        return this.floridaFiles.length >= 2 && this.floridaFiles.filter(x => x.type == _models_enums_pre_bind_file_type_enum__WEBPACK_IMPORTED_MODULE_9__["PreBindFileTypeEnum"].None).length <= 0;
    }
    canSubmitAgain() {
        if (this.preBindSignStatus == null) {
            return true;
        }
        else if (this.preBindSignStatus.Status == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Approved ||
            this.preBindSignStatus.Status == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Completed ||
            this.preBindSignStatus.Status == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Failed) {
            return false;
        }
    }
    isManuallyBlocked() {
        if (this.currentPreBindSign == null) {
            return false;
        }
        else if (this.currentPreBindSign.SignTypeId == _models_enums_pre_bind_sign_type_enum__WEBPACK_IMPORTED_MODULE_12__["PreBindSignTypeEnum"].DocuSign &&
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Approved ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Completed ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingApproval ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingSignature) {
            return true;
        }
        return false;
    }
    isDocuSignBlocked() {
        if (this.currentPreBindSign == null) {
            return false;
        }
        else if (this.currentPreBindSign.SignTypeId == _models_enums_pre_bind_sign_type_enum__WEBPACK_IMPORTED_MODULE_12__["PreBindSignTypeEnum"].Manually &&
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Approved ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Completed ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingApproval ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingSignature) {
            return true;
        }
        return false;
    }
    isDocuSignRequestButtonBlocked() {
        if (this.currentPreBindSign == null) {
            return false;
        }
        else if (this.currentPreBindSign.SignTypeId == _models_enums_pre_bind_sign_type_enum__WEBPACK_IMPORTED_MODULE_12__["PreBindSignTypeEnum"].DocuSign &&
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Approved ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].Completed ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingApproval ||
            this.currentPreBindSign.StatusId == _models_enums_pre_bind_sign_status_enum__WEBPACK_IMPORTED_MODULE_10__["PreBindSignStatusEnum"].WaitingSignature) {
            return true;
        }
        return false;
    }
    isInsuredEmailValid() {
        if (this.insuredEmail == null || this.insuredEmail == '' || this.insuredEmail.length <= 0) {
            sweetalert2__WEBPACK_IMPORTED_MODULE_11___default.a.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Error validating email',
                html: 'Insured e-mail is required.',
                confirmButtonText: 'Ok'
            });
            return false;
        }
        let control = new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](this.insuredEmail, _angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].email);
        if (control.errors) {
            console.log(control.errors);
            sweetalert2__WEBPACK_IMPORTED_MODULE_11___default.a.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Error validating email',
                html: 'Insured e-mail is not in the right format.',
                confirmButtonText: 'Ok'
            });
            return false;
        }
        return true;
    }
    submitByDocuSign() {
        if (!this.isInsuredEmailValid()) {
            return;
        }
        this.showSpinner = true;
        this.mortgageeService.signViaDocuSign(this.quoteId, this.user.userid, this.insuredEmail).subscribe((result) => {
            if (result && result == true) {
                this.getPreBindSign();
                this.downloadPreBindDocuments();
                this.getPreBindStatus();
                this.isFloridaFormsApproved();
            }
            this.showSpinner = false;
        }, error => {
            this.showSpinner = false;
        });
    }
    decodeUser(obj) {
        var userObject = JSON.parse(atob(obj));
        sessionStorage.setItem("user_id", userObject.userId);
        sessionStorage.setItem("name", userObject.name);
        sessionStorage.setItem("permissions", JSON.stringify(userObject.user_permissions));
        sessionStorage.setItem("refreshToken", userObject.refreshToken);
        sessionStorage.setItem("user_token", userObject.user_token);
        sessionStorage.setItem("state_access", userObject.state_access);
        sessionStorage.setItem("token_expiration", userObject.token_expiration);
        sessionStorage.setItem("user_agency", userObject.agency);
        sessionStorage.setItem('user_roles', JSON.stringify(userObject.user_roles));
        sessionStorage.setItem('agentId', userObject.agentId);
        sessionStorage.setItem('agencyId', userObject.agencyId);
    }
    downloadFile(index) {
        const file = this.floridaFiles[index];
        this.getBase64(file.file).then((result) => {
            var blobContent = this.convertBase64StringToBlob(result, "application/pdf");
            let url = window.URL.createObjectURL(blobContent);
            window.open(url);
        });
    }
    convertBase64StringToBlob(base64, contentType) {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return "0 Bytes";
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
};
MortgageeComponent.ctorParameters = () => [
    { type: _mortgagee_service__WEBPACK_IMPORTED_MODULE_1__["MortgageeService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_6__["RoleMapperService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])('aif', { static: false }),
    __metadata("design:type", _angular_forms__WEBPACK_IMPORTED_MODULE_7__["NgForm"])
], MortgageeComponent.prototype, "aiForm", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])('dnd', { static: false }),
    __metadata("design:type", _drag_and_drop_file_drag_and_drop_file_component__WEBPACK_IMPORTED_MODULE_8__["DragAndDropFileComponent"])
], MortgageeComponent.prototype, "dndComponent", void 0);
MortgageeComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-mortgagee-component',
        template: __importDefault(__webpack_require__(/*! raw-loader!./mortgagee.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/mortgagee/mortgagee.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./mortgagee.component.scss */ "./src/app/mortgagee/mortgagee.component.scss")).default]
    }),
    __metadata("design:paramtypes", [_mortgagee_service__WEBPACK_IMPORTED_MODULE_1__["MortgageeService"], _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"], _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"], _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_6__["RoleMapperService"]])
], MortgageeComponent);



/***/ }),

/***/ "./src/app/mortgagee/mortgagee.service.ts":
/*!************************************************!*\
  !*** ./src/app/mortgagee/mortgagee.service.ts ***!
  \************************************************/
/*! exports provided: MortgageeService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MortgageeService", function() { return MortgageeService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let MortgageeService = class MortgageeService {
    constructor(httpClient, arcApiBaseUrl) {
        this.httpClient = httpClient;
        this.arcApiBaseUrl = arcApiBaseUrl;
    }
    getStates() {
        return this.httpClient.get(this.arcApiBaseUrl + '/api/1000/hiscox/mortgagee/states');
    }
    getQuoteId(number) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/number/${number}`);
    }
    expiredCheck(number) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/number/${number}/expired`);
    }
    mortgageesByQuoteNumber(number) {
        let arcApiBaseUrl = "http://localhost:50290/";
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/mortgagee/quote/${number}`);
    }
    getRatedQuote(quoteNumber, user) {
        var arcApiBaseUrl = "http://localhost:50290/";
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}`, user);
    }
    ;
    getRiskAddress(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/number/${quoteNumber}/riskAddress`);
    }
    createMortgagee(mortgagee) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/mortgagee', mortgagee);
    }
    updateMortgagee(mortgagee) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/mortgagee/update', mortgagee);
    }
    removeMortgagee(mortgagee) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/mortgagee/remove', mortgagee);
    }
    updateAdditionalInsured(ai) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/quote/additionalInsured', ai);
    }
    getAdditionalInsured(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/number/${quoteNumber}/additionalinsured`);
    }
    removeAdditionalInsured(id) {
        return this.httpClient.delete(this.arcApiBaseUrl + `/api/1000/hiscox/quote/additionalinsured/${id}`);
    }
    /*******PRE BIND METHODS ABOVE**********/
    uploadFloridaFormsManuallySigned(fileForms) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/documents/UploadSignedFloridaForms', fileForms);
    }
    getPreBindDocuments(quoteId) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/documents/GetPreBindDocuments/${quoteId}`);
    }
    isQuoteApproved(quoteId) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/documents/IsQuoteApproved/${quoteId}`);
    }
    getPreBindStatus(quoteId) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/documents/GetPreBindSignStatus/${quoteId}`);
    }
    getPreBindSign(quoteId) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/documents/GetPreBindSign/${quoteId}`);
    }
    signViaDocuSign(quoteId, userId, insuredEmail) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/documents/SignViaDocuSign`, {
            QuoteId: quoteId,
            UserId: userId,
            InsuredEmail: insuredEmail
        });
    }
};
MortgageeService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_API_URL',] }] }
];
MortgageeService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    }),
    __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_API_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], String])
], MortgageeService);



/***/ }),

/***/ "./src/app/options/options.component.ts":
/*!**********************************************!*\
  !*** ./src/app/options/options.component.ts ***!
  \**********************************************/
/*! exports provided: OptionsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OptionsComponent", function() { return OptionsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _options_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./options.service */ "./src/app/options/options.service.ts");
/* harmony import */ var _shared_userDto_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/userDto.model */ "./src/app/shared/userDto.model.ts");
/* harmony import */ var _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/role-mapper.service */ "./src/app/shared/role-mapper.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_redirect_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../shared/redirect.service */ "./src/app/shared/redirect.service.ts");
/* harmony import */ var _shared_dropdown_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../shared/dropdown.service */ "./src/app/shared/dropdown.service.ts");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_8__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};









let OptionsComponent = class OptionsComponent {
    constructor(optionsService, dropdownService, roleMapper, router, route, redirectService) {
        this.optionsService = optionsService;
        this.dropdownService = dropdownService;
        this.roleMapper = roleMapper;
        this.router = router;
        this.route = route;
        this.redirectService = redirectService;
        this.showSpinner = true;
        this.maxDate = {};
        this.pastMax = false;
        this.rejectedDocuments = true;
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            let user = params['u'];
            if (user != undefined || user != null) {
                this.decodeUser(user);
                let quoteNumber = params['q'];
                var quote = {
                    quoteNumber: Number(quoteNumber)
                };
                sessionStorage.setItem('quote', JSON.stringify(quote));
                let url = this.router.url.substring(0, this.router.url.indexOf("?"));
                this.router.navigateByUrl(url);
            }
        });
        let today = new Date();
        this.user = new _shared_userDto_model__WEBPACK_IMPORTED_MODULE_3__["UserDto"]();
        let quote = JSON.parse(sessionStorage.getItem('quote'));
        if (quote === undefined || quote == null) {
            this.router.navigate(['/application']);
        }
        else {
            this.max = new Date();
            this.max.setDate(this.max.getDate() + 60);
            this.max.setHours(0);
            this.max.setMinutes(0);
            this.max.setSeconds(0);
            this.max.setMilliseconds(0);
            this.maxDate = { year: this.max.getFullYear(), month: this.max.getMonth() + 1, day: this.max.getDate() };
            this.optionsService.checkQuoteStage(quote.quoteNumber).subscribe(response => {
                if (response == '/options') {
                    this.waitingPeriods = this.dropdownService.getWaitingPeriodTypes();
                    this.userRole = this.roleMapper.mapRole(sessionStorage.getItem('user_roles'));
                    this.user.username = sessionStorage.getItem('user_agency');
                    this.user.agencyNumber = sessionStorage.getItem('user_agency');
                    this.user.userid = Number(sessionStorage.getItem("user_id"));
                    this.user.agentid = Number(sessionStorage.getItem("agentId"));
                    this.user.agencyid = Number(sessionStorage.getItem("agencyId"));
                    this.user.role = this.userRole;
                    this.riskAddress = '';
                    this.optionsService.getRiskAddress(quote.quoteNumber).subscribe(response => this.setRiskAddress(response));
                    this.optionsService.getRatedQuote(quote.quoteNumber, this.user).subscribe(response => {
                        //console.log(response)
                        this.setModel(response);
                        this.optionsService.GetRejectedDocumentValidation(quote.quoteNumber).subscribe(response => {
                            this.rejectedDocuments = response;
                        });
                    });
                    this.showSpinner = false;
                }
                else if (response === '/policy') {
                    this.redirectService.policyByQuoteNumber(quote.quoteNumber).subscribe(response => this.redirectService.xenithRedirect(response));
                }
                else {
                    this.router.navigate([response]);
                }
            });
        }
    }
    decodeUser(obj) {
        var userObject = JSON.parse(atob(obj));
        sessionStorage.setItem("user_id", userObject.userId);
        sessionStorage.setItem("name", userObject.name);
        sessionStorage.setItem("permissions", JSON.stringify(userObject.user_permissions));
        sessionStorage.setItem("refreshToken", userObject.refreshToken);
        sessionStorage.setItem("user_token", userObject.user_token);
        sessionStorage.setItem("state_access", userObject.state_access);
        sessionStorage.setItem("token_expiration", userObject.token_expiration);
        sessionStorage.setItem("user_agency", userObject.agency);
        sessionStorage.setItem('user_roles', JSON.stringify(userObject.user_roles));
        sessionStorage.setItem('agentId', userObject.agentId);
        sessionStorage.setItem('agencyId', userObject.agencyId);
    }
    setRiskAddress(response) {
        this.riskAddress = response.Street1 + ((response.Street2 == null || response.Street2 == "") ? "" : (" " + response.Street2)) + " " + response.City + ", " + response.State + " " + response.Zip;
        this.riskAddressState = response.State;
    }
    setModel(response) {
        this.quoteModel = response;
        if (response.EffectiveDate != null) {
            let effDate = new Date(response.EffectiveDate);
            this.effectiveDate = new _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbDate"](effDate.getFullYear(), effDate.getMonth() + 1, effDate.getDate());
        }
        else {
            let effDate = new Date();
            effDate.setDate(effDate.getDate() + 7);
            this.effectiveDate = new _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbDate"](effDate.getFullYear(), effDate.getMonth() + 1, effDate.getDate());
        }
        let mappedOptions = this.quoteModel.Quote.Options.map(options => options.DeductibleCategory);
        let uniqueOptions = mappedOptions.filter((item, index, array) => index === array.indexOf(item));
        let numberArray = uniqueOptions.map((options, index) => ({ id: index, option: Number(options.replace(/[^0-9\.-]+/g, "")) }));
        let sortedNumberArray = numberArray.sort((a, b) => (a.option > b.option) ? 1 : ((b.option > a.option) ? -1 : 0));
        this.deductibleCategories = this.reorder(uniqueOptions, sortedNumberArray);
        this.selectedDeductibleCategory = this.deductibleCategories[0];
        //vm.loading = false;
        this.clientInformation = this.quoteModel.ClientName;
        this.visibleOptions = this.quoteModel.Quote.Options.filter(option => option.DeductibleCategory === this.selectedDeductibleCategory);
        if (this.riskAddressState == 'TX') {
            this.assignTaxes();
        }
        this.previousVisibleOptions = this.visibleOptions;
        if (response.WaitingPeriodTypeId != null) {
            this.selectedWaitingPeriodCategory = this.waitingPeriods.filter(cat => cat.Id === response.WaitingPeriodTypeId)[0];
        }
        else {
            this.selectedWaitingPeriodCategory = this.waitingPeriods[0];
        }
    }
    reorder(mappedArray, indexArray) {
        let temp = [];
        for (var i = 0; i < mappedArray.length; i++) {
            temp.push(mappedArray[indexArray[i].id]);
        }
        return temp;
    }
    requote() {
        sessionStorage.setItem("requoteId", this.quoteModel.QuoteId);
        this.router.navigate(['/application']);
    }
    printOptions() {
        this.showSpinner = true;
        let effDate = new Date(this.effectiveDate.year, this.effectiveDate.month - 1, this.effectiveDate.day);
        let optionObject = {
            effectiveDate: effDate,
            deductibleOption: this.selectedDeductibleCategory,
            quoteNumber: this.quoteModel.QuoteId
        };
        this.optionsService.printQuoteOptions(optionObject).subscribe(response => {
            var filename = response.FileDownloadName;
            var byteCharacters = atob(response.FileContents);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var fileType = 'application/pdf';
            var blob = new Blob([byteArray], { type: fileType });
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
            }
            else {
                var objectUrl = URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = objectUrl;
                link.download = filename;
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(objectUrl);
                });
            }
            this.showSpinner = false;
        });
    }
    range(min, max, step) {
        step = step || 1;
        let input = [];
        for (var i = min; i <= max; i += step) {
            input.push(i);
        }
        return input;
    }
    onDeductibleChange(event) {
        if (this.previousVisibleOptions !== event) {
            this.previousVisibleOptions = this.visibleOptions;
            this.visibleOptions = this.quoteModel.Quote.Options.filter(option => option.DeductibleCategory === this.selectedDeductibleCategory);
            this.previousVisibleOptions.forEach(prevOpt => {
                prevOpt.noPremChange = false;
                this.visibleOptions.forEach(currentOpt => {
                    if (currentOpt.OptionName === prevOpt.OptionName && currentOpt.Premium == prevOpt.Premium) {
                        currentOpt.noPremChange = true;
                    }
                });
            });
        }
    }
    checkDate(date, valid) {
        if (valid) {
            var today = new Date();
            var oneWeek = new Date();
            oneWeek.setDate(oneWeek.getDate() + 7);
            oneWeek.setHours(0);
            oneWeek.setMinutes(0);
            oneWeek.setSeconds(0);
            oneWeek.setMilliseconds(0);
            let effDate = new Date(date.year, date.month - 1, date.day);
            effDate.setHours(0);
            effDate.setMinutes(0);
            effDate.setSeconds(0);
            effDate.setMilliseconds(0);
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);
            var submitDatePlusSevenDays = new Date();
            var requestDate = new Date(this.quoteModel.RequestDate);
            let dateRequest = requestDate.toLocaleDateString();
            //console.log(dateRequest)
            let dateArray = dateRequest.split("/");
            let requestDateCorrectFormat = new Date(+dateArray[2], +dateArray[0] - 1, +dateArray[1]);
            dateRequest = today.toLocaleDateString();
            //console.log(dateRequest)
            dateArray = dateRequest.split("/");
            var sevenDaysAgo = new Date(+dateArray[2], +dateArray[0] - 1, +dateArray[1] - 7);
            submitDatePlusSevenDays.setDate(requestDateCorrectFormat.getDate() + 7);
            if (effDate < today) {
                this.pastEffDate = true;
            }
            else {
                this.pastEffDate = false;
            }
            if (this.selectedWaitingPeriodCategory.Id == 2 || this.selectedWaitingPeriodCategory.Id == 3 || effDate >= oneWeek) {
                this.effectiveDateOneWeek = false;
            }
            else {
                this.effectiveDateOneWeek = true;
            }
            if (this.riskAddressState == 'TX') {
                this.assignTaxes();
            }
            if (this.riskAddressState == 'FL' && (this.selectedWaitingPeriodCategory.Id == 2 || this.selectedWaitingPeriodCategory.Id == 3) && this.rejectedDocuments) {
                // console.log(requestDateCorrectFormat)
                // console.log(effDate)
                // console.log(submitDatePlusSevenDays)
                // console.log(sevenDaysAgo)
                // console.log(requestDateCorrectFormat < today)
                // console.log(effDate >= requestDateCorrectFormat)
                // console.log(effDate <= submitDatePlusSevenDays)
                // console.log(effDate >= sevenDaysAgo)
                if (requestDateCorrectFormat < today && effDate >= requestDateCorrectFormat && effDate <= submitDatePlusSevenDays && effDate >= sevenDaysAgo) {
                    this.pastEffDate = false;
                }
            }
        }
        if (date != null || date != undefined) {
            let effDate = new Date(date.year, date.month - 1, date.day);
            this.pastMax = effDate > this.max;
        }
        else {
            this.pastMax = false;
        }
    }
    selectQuoteOption(option) {
        //console.log("entro")
        let effDate = new Date(this.effectiveDate.year, this.effectiveDate.month - 1, this.effectiveDate.day);
        let today = new Date();
        let oneWeek = new Date();
        oneWeek.setDate(oneWeek.getDate() + 7);
        oneWeek.setHours(0);
        oneWeek.setMinutes(0);
        oneWeek.setSeconds(0);
        oneWeek.setMilliseconds(0);
        effDate.setHours(0);
        effDate.setMinutes(0);
        effDate.setSeconds(0);
        effDate.setMilliseconds(0);
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
        var submitDatePlusSevenDays = new Date();
        var requestDate = new Date(this.quoteModel.RequestDate);
        let dateRequest = requestDate.toLocaleDateString();
        let dateArray = dateRequest.split("/");
        let requestDateCorrectFormat = new Date(+dateArray[2], +dateArray[0] - 1, +dateArray[1]);
        dateRequest = today.toLocaleDateString();
        dateArray = dateRequest.split("/");
        var sevenDaysAgo = new Date(+dateArray[2], +dateArray[0] - 1, +dateArray[1] - 7);
        submitDatePlusSevenDays.setDate(requestDateCorrectFormat.getDate() + 7);
        let continueQuote = () => {
            this.showSpinner = true;
            if (((this.selectedWaitingPeriodCategory.Id == 2 || this.selectedWaitingPeriodCategory.Id == 3) && effDate >= today) || effDate >= oneWeek) {
                let model = {
                    effectiveDate: effDate,
                    optionNumber: option.OptionNumber,
                    quoteNumber: this.quoteModel.QuoteId,
                    user: this.user,
                    waitingPeriod: this.selectedWaitingPeriodCategory.Id
                };
                this.optionsService.selectOption(model).subscribe(response => {
                    //sessionFactory.setSession('quoteId');   TODO ? set session to blank? need to check next page.
                    this.router.navigate(['/mortgagee']);
                });
            }
            else if (effDate >= today && effDate < oneWeek) {
                this.effectiveDateOneWeek = true;
                this.showSpinner = false;
            }
            if (effDate < today) {
                this.pastEffDate = true;
                this.showSpinner = false;
            }
            if (this.riskAddressState == 'FL' && (this.selectedWaitingPeriodCategory.Id == 2 || this.selectedWaitingPeriodCategory.Id == 3) && this.rejectedDocuments) {
                // console.log(requestDateCorrectFormat)
                // console.log(effDate)
                // console.log(submitDatePlusSevenDays)
                // console.log(sevenDaysAgo)
                // console.log(requestDateCorrectFormat < today)
                // console.log(effDate >= requestDateCorrectFormat)
                // console.log(effDate <= submitDatePlusSevenDays)
                // console.log(effDate >= sevenDaysAgo)
                if (requestDateCorrectFormat < today && effDate >= requestDateCorrectFormat && effDate <= submitDatePlusSevenDays && effDate >= sevenDaysAgo) {
                    this.pastEffDate = false;
                    this.showSpinner = true;
                    let model = {
                        effectiveDate: effDate,
                        optionNumber: option.OptionNumber,
                        quoteNumber: this.quoteModel.QuoteId,
                        user: this.user,
                        waitingPeriod: this.selectedWaitingPeriodCategory.Id
                    };
                    this.optionsService.selectOption(model).subscribe(response => {
                        //sessionFactory.setSession('quoteId');   TODO ? set session to blank? need to check next page.
                        this.router.navigate(['/mortgagee']);
                    });
                }
            }
        };
        if ((this.selectedWaitingPeriodCategory.Id == 2 || this.selectedWaitingPeriodCategory.Id == 3) && effDate >= today) {
            sweetalert2__WEBPACK_IMPORTED_MODULE_8___default.a.fire({
                input: 'checkbox',
                inputPlaceholder: '<p style=\"text-align:left;\">I hereby acknowledge that I am requesting the waiver of the waiting period due to either a loan closing or the property is being reclassified by FEMA. As the agent, I will keep the supporting documentation on file that will support this request.</p>',
                confirmButtonText: 'Continue'
            }).then(function (result) {
                if (result.value) {
                    continueQuote();
                }
            });
        }
        else if (this.riskAddressState == 'FL' && (this.selectedWaitingPeriodCategory.Id == 2 || this.selectedWaitingPeriodCategory.Id == 3) && this.rejectedDocuments) {
            if (requestDateCorrectFormat < today && effDate >= requestDateCorrectFormat && effDate <= submitDatePlusSevenDays && effDate >= sevenDaysAgo) {
                sweetalert2__WEBPACK_IMPORTED_MODULE_8___default.a.fire({
                    input: 'checkbox',
                    inputPlaceholder: '<p style=\"text-align:left;\">I hereby acknowledge that I am requesting the waiver of the waiting period due to either a loan closing or the property is being reclassified by FEMA. As the agent, I will keep the supporting documentation on file that will support this request.</p>',
                    confirmButtonText: 'Continue'
                }).then(function (result) {
                    if (result.value) {
                        continueQuote();
                    }
                });
            }
        }
        else {
            continueQuote();
        }
    }
    assignTaxes() {
        let effDate = new Date();
        if (this.effectiveDate != null) {
            effDate = new Date(this.effectiveDate.year, this.effectiveDate.month - 1, this.effectiveDate.day);
        }
        else {
            effDate.setDate(effDate.getDate() + 7);
        }
        let today = new Date();
        let december25 = new Date("December 25, 2020 00:00:00");
        let january01 = new Date("January 01, 2021 00:00:00");
        if (today >= december25) {
            return;
        }
        else {
            if (effDate >= january01) {
                this.visibleOptions.forEach(x => x.Taxes = x.Taxes2021);
            }
            else {
                this.visibleOptions.forEach(x => x.Taxes = x.Taxes2020);
            }
            this.visibleOptions.forEach(x => x.Total = (x.Premium) + (x.Fees) + (x.Taxes));
        }
    }
};
OptionsComponent.ctorParameters = () => [
    { type: _options_service__WEBPACK_IMPORTED_MODULE_2__["OptionsService"] },
    { type: _shared_dropdown_service__WEBPACK_IMPORTED_MODULE_7__["DropdownService"] },
    { type: _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_4__["RoleMapperService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["ActivatedRoute"] },
    { type: _shared_redirect_service__WEBPACK_IMPORTED_MODULE_6__["RedirectService"] }
];
OptionsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-options-component',
        template: __importDefault(__webpack_require__(/*! raw-loader!./options.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/options/options.component.html")).default
    }),
    __metadata("design:paramtypes", [_options_service__WEBPACK_IMPORTED_MODULE_2__["OptionsService"],
        _shared_dropdown_service__WEBPACK_IMPORTED_MODULE_7__["DropdownService"],
        _shared_role_mapper_service__WEBPACK_IMPORTED_MODULE_4__["RoleMapperService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_5__["ActivatedRoute"],
        _shared_redirect_service__WEBPACK_IMPORTED_MODULE_6__["RedirectService"]])
], OptionsComponent);



/***/ }),

/***/ "./src/app/options/options.service.ts":
/*!********************************************!*\
  !*** ./src/app/options/options.service.ts ***!
  \********************************************/
/*! exports provided: OptionsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OptionsService", function() { return OptionsService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let OptionsService = class OptionsService {
    constructor(httpClient, arcApiBaseUrl) {
        this.httpClient = httpClient;
        this.arcApiBaseUrl = arcApiBaseUrl;
    }
    getRiskAddress(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/number/${quoteNumber}/riskAddress`);
    }
    getRatedQuote(quoteNumber, user) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}`, user);
    }
    selectOption(option) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/quote/option', option);
    }
    checkQuoteStage(quoteNumber) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}/stage`);
    }
    printQuoteOptions(model) {
        return this.httpClient.post(this.arcApiBaseUrl + '/api/1000/hiscox/quote/options/print', model);
    }
    GetRejectedDocumentValidation(quoteId) {
        return this.httpClient.get(this.arcApiBaseUrl + `/api/1000/hiscox/PreBind/GetRejectedDocumentValidation/${quoteId}`);
    }
};
OptionsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_API_URL',] }] }
];
OptionsService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    }),
    __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_API_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], String])
], OptionsService);



/***/ }),

/***/ "./src/app/progress-bar/progress-bar.component.scss":
/*!**********************************************************!*\
  !*** ./src/app/progress-bar/progress-bar.component.scss ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".progress-cont {\n  height: 7px;\n  width: 100%;\n  border-radius: 4px;\n  background-color: #d0d0d0;\n  position: relative;\n}\n.progress-cont .progress {\n  width: 0;\n  height: 100%;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  border-radius: 4px;\n  background-color: #4c97cb;\n  transition: 0.5s all;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcHJvZ3Jlc3MtYmFyL0M6XFxVc2Vyc1xcdG9tLmtpbmdcXHNvdXJjZVxcV29ya3NwYWNlc1xcV29ya3NwYWNlXFxUd2ljb1xcSGlzY294Rmxvb2RcXEhpc2NveEZsb29kXFxDbGllbnRBcHAvc3JjXFxhcHBcXHByb2dyZXNzLWJhclxccHJvZ3Jlc3MtYmFyLmNvbXBvbmVudC5zY3NzIiwic3JjL2FwcC9wcm9ncmVzcy1iYXIvcHJvZ3Jlc3MtYmFyLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBQTtFQUNBLFdBQUE7RUFDQSxrQkFBQTtFQUNBLHlCQUFBO0VBQ0Esa0JBQUE7QUNDRjtBRENFO0VBQ0UsUUFBQTtFQUNBLFlBQUE7RUFDQSxrQkFBQTtFQUNBLFVBQUE7RUFDQSxNQUFBO0VBQ0EsT0FBQTtFQUNBLGtCQUFBO0VBQ0EseUJBQUE7RUFDQSxvQkFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvcHJvZ3Jlc3MtYmFyL3Byb2dyZXNzLWJhci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5wcm9ncmVzcy1jb250IHtcclxuICBoZWlnaHQ6IDdweDtcclxuICB3aWR0aDogMTAwJTtcclxuICBib3JkZXItcmFkaXVzOiA0cHg7XHJcbiAgYmFja2dyb3VuZC1jb2xvcjogI2QwZDBkMDtcclxuICBwb3NpdGlvbjogcmVsYXRpdmU7XHJcblxyXG4gIC5wcm9ncmVzcyB7XHJcbiAgICB3aWR0aDogMDtcclxuICAgIGhlaWdodDogMTAwJTtcclxuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcclxuICAgIHotaW5kZXg6IDE7XHJcbiAgICB0b3A6IDA7XHJcbiAgICBsZWZ0OiAwO1xyXG4gICAgYm9yZGVyLXJhZGl1czogNHB4O1xyXG4gICAgYmFja2dyb3VuZC1jb2xvcjogIzRjOTdjYjtcclxuICAgIHRyYW5zaXRpb246IDAuNXMgYWxsO1xyXG4gIH1cclxufVxyXG4iLCIucHJvZ3Jlc3MtY29udCB7XG4gIGhlaWdodDogN3B4O1xuICB3aWR0aDogMTAwJTtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZDBkMGQwO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG4ucHJvZ3Jlc3MtY29udCAucHJvZ3Jlc3Mge1xuICB3aWR0aDogMDtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHotaW5kZXg6IDE7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjNGM5N2NiO1xuICB0cmFuc2l0aW9uOiAwLjVzIGFsbDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/progress-bar/progress-bar.component.ts":
/*!********************************************************!*\
  !*** ./src/app/progress-bar/progress-bar.component.ts ***!
  \********************************************************/
/*! exports provided: ProgressBarComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressBarComponent", function() { return ProgressBarComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let ProgressBarComponent = class ProgressBarComponent {
    constructor() {
        this.progress = 0;
    }
    ngOnInit() { }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], ProgressBarComponent.prototype, "progress", void 0);
ProgressBarComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-progress-bar',
        template: __importDefault(__webpack_require__(/*! raw-loader!./progress-bar.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/progress-bar/progress-bar.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./progress-bar.component.scss */ "./src/app/progress-bar/progress-bar.component.scss")).default]
    }),
    __metadata("design:paramtypes", [])
], ProgressBarComponent);



/***/ }),

/***/ "./src/app/shared/Custom-NgbDateParserFormat.ts":
/*!******************************************************!*\
  !*** ./src/app/shared/Custom-NgbDateParserFormat.ts ***!
  \******************************************************/
/*! exports provided: CustomNgbDateFormat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomNgbDateFormat", function() { return CustomNgbDateFormat; });
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let CustomNgbDateFormat = class CustomNgbDateFormat extends _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_0__["NgbDateParserFormatter"] {
    constructor() {
        super();
    }
    format(date) {
        if (date === null || date === undefined || date.year === null || date.month === null || date.day === null) {
            return '';
        }
        return `${String(date.month)}/${String(date.day)}/${String(date.year)}`;
    }
    parse(value) {
        if (!value) {
            return null;
        }
        let result = {
            year: +value.split('/')[2],
            month: +value.split('/')[0],
            day: +value.split('/')[1]
        };
        return result;
    }
};
CustomNgbDateFormat = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], CustomNgbDateFormat);



/***/ }),

/***/ "./src/app/shared/additionalInsured.model.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/additionalInsured.model.ts ***!
  \***************************************************/
/*! exports provided: AdditionalInsured */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdditionalInsured", function() { return AdditionalInsured; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class AdditionalInsured {
}


/***/ }),

/***/ "./src/app/shared/address.model.ts":
/*!*****************************************!*\
  !*** ./src/app/shared/address.model.ts ***!
  \*****************************************/
/*! exports provided: Address */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Address", function() { return Address; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class Address {
}


/***/ }),

/***/ "./src/app/shared/application.model.ts":
/*!*********************************************!*\
  !*** ./src/app/shared/application.model.ts ***!
  \*********************************************/
/*! exports provided: Application, HiscoxPriorFloodLossesDto, ElevationDetailDto */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Application", function() { return Application; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HiscoxPriorFloodLossesDto", function() { return HiscoxPriorFloodLossesDto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElevationDetailDto", function() { return ElevationDetailDto; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class Application {
}
class HiscoxPriorFloodLossesDto {
}
class ElevationDetailDto {
}


/***/ }),

/***/ "./src/app/shared/dropdown.service.ts":
/*!********************************************!*\
  !*** ./src/app/shared/dropdown.service.ts ***!
  \********************************************/
/*! exports provided: DropdownService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownService", function() { return DropdownService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let DropdownService = class DropdownService {
    getMailingStates() {
        return [
            { Id: 1, Code: 'AL' },
            { Id: 2, Code: 'AK' },
            { Id: 3, Code: 'AZ' },
            { Id: 4, Code: 'AR' },
            { Id: 5, Code: 'CA' },
            { Id: 6, Code: 'CO' },
            { Id: 7, Code: 'CT' },
            { Id: 8, Code: 'DE' },
            { Id: 9, Code: 'FL' },
            { Id: 10, Code: 'GA' },
            { Id: 11, Code: 'HI' },
            { Id: 12, Code: 'ID' },
            { Id: 13, Code: 'IL' },
            { Id: 14, Code: 'IN' },
            { Id: 15, Code: 'IA' },
            { Id: 16, Code: 'KS' },
            { Id: 17, Code: 'KY' },
            { Id: 18, Code: 'LA' },
            { Id: 19, Code: 'ME' },
            { Id: 20, Code: 'MD' },
            { Id: 21, Code: 'MA' },
            { Id: 22, Code: 'MI' },
            { Id: 23, Code: 'MN' },
            { Id: 24, Code: 'MS' },
            { Id: 25, Code: 'MO' },
            { Id: 26, Code: 'MT' },
            { Id: 27, Code: 'NE' },
            { Id: 28, Code: 'NV' },
            { Id: 29, Code: 'NH' },
            { Id: 30, Code: 'NJ' },
            { Id: 31, Code: 'NM' },
            { Id: 32, Code: 'NY' },
            { Id: 33, Code: 'NC' },
            { Id: 34, Code: 'ND' },
            { Id: 35, Code: 'OH' },
            { Id: 36, Code: 'OK' },
            { Id: 37, Code: 'OR' },
            { Id: 38, Code: 'PA' },
            { Id: 39, Code: 'RI' },
            { Id: 40, Code: 'SC' },
            { Id: 41, Code: 'SD' },
            { Id: 42, Code: 'TN' },
            { Id: 43, Code: 'TX' },
            { Id: 44, Code: 'UT' },
            { Id: 45, Code: 'VT' },
            { Id: 46, Code: 'VA' },
            { Id: 47, Code: 'WA' },
            { Id: 48, Code: 'WV' },
            { Id: 49, Code: 'WI' },
            { Id: 50, Code: 'WY' },
            { Id: 51, Code: 'DC' }
        ];
    }
    getOccupancies() {
        return [
            { Id: 1, Value: 'Primary', Text: 'Primary' },
            { Id: 2, Value: 'Secondary', Text: 'Secondary' },
            { Id: 3, Value: 'Seasonal', Text: 'Seasonal' },
            { Id: 4, Value: 'Tenanted', Text: 'Tenanted' },
            { Id: 5, Value: 'Vacant', Text: 'Vacant' },
            { Id: 6, Value: 'Coc', Text: 'Course of Construction' },
            { Id: 7, Value: 'VacantRenovation', Text: 'Vacant (Renovation)' }
        ];
    }
    getConstructionTypes() {
        return [
            { Id: 1, Value: 'BrickVeneer', Text: 'Brick Veneer' },
            { Id: 2, Value: 'EIFS', Text: 'EIFS' },
            { Id: 3, Value: 'Frame', Text: 'Frame' },
            { Id: 4, Value: 'Log', Text: 'Log' },
            { Id: 5, Value: 'Masonry', Text: 'Masonry' },
            { Id: 6, Value: 'Stucco', Text: 'Stucco' },
            { Id: 7, Value: 'Asbestos', Text: 'Asbestos' }
        ];
    }
    getDwellingTivPercentages() {
        return [
            { Id: 1, Value: '10', Text: '10%' },
            { Id: 2, Value: '15', Text: '15%' },
            { Id: 3, Value: '20', Text: '20%' },
            { Id: 4, Value: '25', Text: '25%' },
            { Id: 5, Value: '30', Text: '30%' },
            { Id: 6, Value: '35', Text: '35%' },
            { Id: 7, Value: '40', Text: '40%' },
            { Id: 8, Value: '45', Text: '45%' },
            { Id: 9, Value: '50', Text: '50%' },
            { Id: 10, Value: '55', Text: '55%' },
            { Id: 11, Value: '60', Text: '60%' },
            { Id: 12, Value: '65', Text: '65%' },
            { Id: 13, Value: '70', Text: '70%' }
        ];
    }
    getPersonalPropertyCostValueTypes() {
        return [
            { Id: 1, Value: 'ActualCostValue', Text: 'Actual Cost Value' },
            { Id: 2, Value: 'ReplacementCostValue', Text: 'Replacement Cost Value' }
        ];
    }
    getFoundationTypes() {
        return [
            { Id: 1, Value: 'PiersPostsPiles', Text: 'Piers, Posts, Piles' },
            { Id: 2, Value: 'ReinforcedMasonryEtc', Text: 'Reinforced Masonry, Etc.' },
            { Id: 3, Value: 'ReinforcedShearWalls', Text: 'Reinforced Shear Walls' },
            { Id: 4, Value: 'SolidFoundationWalls', Text: 'Solid Foundation Walls' },
            { Id: 5, Value: 'FoundationWall', Text: 'Foundation Wall' },
            { Id: 6, Value: 'SlabOnGrade', Text: 'Slab On Grade' },
            { Id: 7, Value: 'SlabOnFill', Text: 'Slab On Fill' }
        ];
    }
    getOverWaterTypes() {
        return [
            { Id: 1, Value: 'No', Text: 'No' },
            { Id: 2, Value: 'Partially', Text: 'Partially' },
            { Id: 3, Value: 'Entirely', Text: 'Entirely' }
        ];
    }
    getWaitingPeriodTypes() {
        return [
            { Id: 1, Text: '7-Day Waiting Period' },
            { Id: 2, Text: 'Loan Closing - No Wait' },
            { Id: 3, Text: 'Reclassified (within last 60 days) - No Wait' }
        ];
    }
};
DropdownService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    })
], DropdownService);



/***/ }),

/***/ "./src/app/shared/jwt.interceptor.ts":
/*!*******************************************!*\
  !*** ./src/app/shared/jwt.interceptor.ts ***!
  \*******************************************/
/*! exports provided: AuthInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthInterceptor", function() { return AuthInterceptor; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};



let AuthInterceptor = class AuthInterceptor {
    constructor(arcWebUrl) {
        this.arcWebUrl = arcWebUrl;
        this.AUTH_HEADER = "Authorization";
    }
    intercept(req, next) {
        req = this.addAuthenticationToken(req);
        return next.handle(req).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["catchError"])((error) => {
            if (error && error.status === 401) {
                sessionStorage.clear();
                window.location.href = this.arcWebUrl;
            }
            else {
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_1__["throwError"])(error);
            }
        }));
    }
    addAuthenticationToken(request) {
        // If you are calling an outside domain then do not add the token.
        if (!request.url.match(/api\/1000\/hiscox/)) {
            return request;
        }
        let token = sessionStorage.getItem('user_token');
        return request.clone({
            headers: request.headers.set(this.AUTH_HEADER, "Bearer " + token)
        });
    }
};
AuthInterceptor.ctorParameters = () => [
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_WEB_URL',] }] }
];
AuthInterceptor = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])(),
    __param(0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_WEB_URL')),
    __metadata("design:paramtypes", [String])
], AuthInterceptor);



/***/ }),

/***/ "./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.ts ***!
  \*******************************************************************************/
/*! exports provided: MoratoriumWarningDialog */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoratoriumWarningDialog", function() { return MoratoriumWarningDialog; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var src_app_moratorium_management_moratorium_management_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/moratorium-management/moratorium-management.service */ "./src/app/moratorium-management/moratorium-management.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};



let MoratoriumWarningDialog = class MoratoriumWarningDialog {
    constructor(dialogRef, data, moratoriumManagementService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.moratoriumManagementService = moratoriumManagementService;
    }
    onCancel() {
        this.dialogRef.close();
    }
};
MoratoriumWarningDialog.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_1__["MatDialogRef"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"] }, { type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: [_angular_material__WEBPACK_IMPORTED_MODULE_1__["MAT_DIALOG_DATA"],] }] },
    { type: src_app_moratorium_management_moratorium_management_service__WEBPACK_IMPORTED_MODULE_2__["MoratoriumManagementService"] }
];
MoratoriumWarningDialog = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'moratorium-warning-dialog',
        template: __importDefault(__webpack_require__(/*! raw-loader!./moratorium-warning-dialog.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/moratorium-warning-dialog/moratorium-warning-dialog.html")).default
    }),
    __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Optional"])()), __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])(_angular_material__WEBPACK_IMPORTED_MODULE_1__["MAT_DIALOG_DATA"])),
    __metadata("design:paramtypes", [_angular_material__WEBPACK_IMPORTED_MODULE_1__["MatDialogRef"], String, src_app_moratorium_management_moratorium_management_service__WEBPACK_IMPORTED_MODULE_2__["MoratoriumManagementService"]])
], MoratoriumWarningDialog);



/***/ }),

/***/ "./src/app/shared/mortgagee.model.ts":
/*!*******************************************!*\
  !*** ./src/app/shared/mortgagee.model.ts ***!
  \*******************************************/
/*! exports provided: Mortgagee */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mortgagee", function() { return Mortgagee; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class Mortgagee {
}


/***/ }),

/***/ "./src/app/shared/redirect.service.ts":
/*!********************************************!*\
  !*** ./src/app/shared/redirect.service.ts ***!
  \********************************************/
/*! exports provided: RedirectService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RedirectService", function() { return RedirectService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let RedirectService = class RedirectService {
    constructor(httpClient, arcWebUrl, arcApiBaseUrl) {
        this.httpClient = httpClient;
        this.arcApiBaseUrl = arcApiBaseUrl;
        this.arcWebUrl = arcWebUrl;
    }
    xenithRedirect(policyNumber) {
        let refreshToken = sessionStorage.getItem("refreshToken");
        let exp = sessionStorage.getItem("token_expiration");
        let userToken = {
            ExpirationDate: exp,
            RefreshToken: refreshToken
        };
        let userObject = {
            user_permissions: sessionStorage.getItem('permissions'),
            user_id: sessionStorage.getItem('user_id'),
            user_fullname: sessionStorage.getItem('name'),
            agency: sessionStorage.getItem("user_agency"),
            user_roles: sessionStorage.getItem('user_roles'),
            user_token: userToken,
            token_expiration: exp,
            agentId: sessionStorage.getItem('agentId'),
            state_access: sessionStorage.getItem("state_access"),
            agencyId: sessionStorage.getItem("agencyId")
        };
        let userString = btoa(JSON.stringify(userObject));
        let src = "hiscox";
        let queryString = `u=${userString}&src=${src}&policyNumber=${policyNumber}`;
        let url = `${this.arcWebUrl}policy/floodSearch?${queryString}`;
        window.location.replace(url);
    }
    policyByQuoteNumber(quoteNumber) {
        return this.httpClient.post(this.arcApiBaseUrl + `/api/1000/hiscox/quote/${quoteNumber}/policy`, null);
    }
};
RedirectService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_WEB_URL',] }] },
    { type: String, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['ARC_API_URL',] }] }
];
RedirectService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    }),
    __param(1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_WEB_URL')), __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('ARC_API_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], String, String])
], RedirectService);



/***/ }),

/***/ "./src/app/shared/role-mapper.service.ts":
/*!***********************************************!*\
  !*** ./src/app/shared/role-mapper.service.ts ***!
  \***********************************************/
/*! exports provided: RoleMapperService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RoleMapperService", function() { return RoleMapperService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let RoleMapperService = class RoleMapperService {
    mapRole(roles) {
        let parsedRoles = JSON.parse(roles);
        let role = '';
        if (parsedRoles.indexOf('Hiscox Agent') > -1) {
            role = 'agent';
        }
        else if (parsedRoles.indexOf('Underwriting') > -1 || parsedRoles.indexOf('Underwriting Manager') > -1) {
            role = 'underwriter';
        }
        return role;
    }
};
RoleMapperService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    })
], RoleMapperService);



/***/ }),

/***/ "./src/app/shared/unquotableZips.ts":
/*!******************************************!*\
  !*** ./src/app/shared/unquotableZips.ts ***!
  \******************************************/
/*! exports provided: UnquotableZips */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnquotableZips", function() { return UnquotableZips; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class UnquotableZips {
}
UnquotableZips.zips = ['77510', '77517', '77518', '77539', '77546', '77549', '77550', '77551', '77552', '77553', '77554', '77555', '77563', '77565', '77568', '77573', '77574', '77590', '77591', '77592', '77617', '77623', '77650'];


/***/ }),

/***/ "./src/app/shared/userDto.model.ts":
/*!*****************************************!*\
  !*** ./src/app/shared/userDto.model.ts ***!
  \*****************************************/
/*! exports provided: UserDto */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserDto", function() { return UserDto; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class UserDto {
}


/***/ }),

/***/ "./src/app/validators/custom-matching-directive.ts":
/*!*********************************************************!*\
  !*** ./src/app/validators/custom-matching-directive.ts ***!
  \*********************************************************/
/*! exports provided: CustomMatchingDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomMatchingDirective", function() { return CustomMatchingDirective; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _custom_matching_validator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./custom-matching-validator */ "./src/app/validators/custom-matching-validator.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CustomMatchingDirective_1;



let CustomMatchingDirective = CustomMatchingDirective_1 = class CustomMatchingDirective {
    constructor() {
        this.mustMatch = [];
    }
    validate(formGroup) {
        return Object(_custom_matching_validator__WEBPACK_IMPORTED_MODULE_2__["mustMatch"])(this.mustMatch[0], this.mustMatch[1])(formGroup);
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])('mustMatch'),
    __metadata("design:type", Array)
], CustomMatchingDirective.prototype, "mustMatch", void 0);
CustomMatchingDirective = CustomMatchingDirective_1 = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"])({
        selector: '[mustMatch]',
        providers: [{ provide: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["NG_VALIDATORS"], useExisting: CustomMatchingDirective_1, multi: true }]
    })
], CustomMatchingDirective);



/***/ }),

/***/ "./src/app/validators/custom-matching-validator.ts":
/*!*********************************************************!*\
  !*** ./src/app/validators/custom-matching-validator.ts ***!
  \*********************************************************/
/*! exports provided: mustMatch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mustMatch", function() { return mustMatch; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
// custom validator to check that two fields match
function mustMatch(controlName, matchingControlName) {
    return (formGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        // return null if controls haven't initialised yet
        if (!control || !matchingControl) {
            return null;
        }
        // return null if another validator has already found an error on the matchingControl
        // ReSharper disable once TsResolvedFromInaccessibleModule
        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            return null;
        }
        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        }
        else {
            matchingControl.setErrors(null);
        }
    };
}


/***/ }),

/***/ "./src/app/validators/custom-max-validator.directive.ts":
/*!**************************************************************!*\
  !*** ./src/app/validators/custom-max-validator.directive.ts ***!
  \**************************************************************/
/*! exports provided: CustomMaxDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomMaxDirective", function() { return CustomMaxDirective; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CustomMaxDirective_1;


let CustomMaxDirective = CustomMaxDirective_1 = class CustomMaxDirective {
    validate(c) {
        let v = c.value;
        return (v > this.customMax) ? { "customMax": true } : null;
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Number)
], CustomMaxDirective.prototype, "customMax", void 0);
CustomMaxDirective = CustomMaxDirective_1 = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"])({
        selector: '[customMax][formControlName],[customMax][formControl],[customMax][ngModel]',
        providers: [{ provide: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["NG_VALIDATORS"], useExisting: CustomMaxDirective_1, multi: true }]
    })
], CustomMaxDirective);



/***/ }),

/***/ "./src/app/validators/custom-min-validator.directive.ts":
/*!**************************************************************!*\
  !*** ./src/app/validators/custom-min-validator.directive.ts ***!
  \**************************************************************/
/*! exports provided: CustomMinDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomMinDirective", function() { return CustomMinDirective; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CustomMinDirective_1;


let CustomMinDirective = CustomMinDirective_1 = class CustomMinDirective {
    validate(c) {
        let v = c.value;
        if (v == null) {
            return null;
        }
        return (v < this.customMin) ? { "customMin": true } : null;
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Number)
], CustomMinDirective.prototype, "customMin", void 0);
CustomMinDirective = CustomMinDirective_1 = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"])({
        selector: '[customMin][formControlName],[customMin][formControl],[customMin][ngModel]',
        providers: [{ provide: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["NG_VALIDATORS"], useExisting: CustomMinDirective_1, multi: true }]
    })
], CustomMinDirective);



/***/ }),

/***/ "./src/app/validators/custom-quotable-state-directive.ts":
/*!***************************************************************!*\
  !*** ./src/app/validators/custom-quotable-state-directive.ts ***!
  \***************************************************************/
/*! exports provided: CustomQuotableStateDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomQuotableStateDirective", function() { return CustomQuotableStateDirective; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CustomQuotableStateDirective_1;


let CustomQuotableStateDirective = CustomQuotableStateDirective_1 = class CustomQuotableStateDirective {
    validate(c) {
        let v = c.value;
        if (v == null || v == undefined) {
            return null;
        }
        return v.FlgQuotable == false ? { "quotableState": true } : null;
    }
};
CustomQuotableStateDirective = CustomQuotableStateDirective_1 = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"])({
        selector: '[quotableState][formControlName],[quotableState][formControl],[quotableState][ngModel]',
        providers: [{ provide: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["NG_VALIDATORS"], useExisting: CustomQuotableStateDirective_1, multi: true }]
    })
], CustomQuotableStateDirective);



/***/ }),

/***/ "./src/app/validators/custom-routing-match-directive.ts":
/*!**************************************************************!*\
  !*** ./src/app/validators/custom-routing-match-directive.ts ***!
  \**************************************************************/
/*! exports provided: CustomRoutingMatchDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomRoutingMatchDirective", function() { return CustomRoutingMatchDirective; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _custom_matching_validator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./custom-matching-validator */ "./src/app/validators/custom-matching-validator.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CustomRoutingMatchDirective_1;



let CustomRoutingMatchDirective = CustomRoutingMatchDirective_1 = class CustomRoutingMatchDirective {
    constructor() {
        this.mustMatch = [];
    }
    validate(formGroup) {
        return Object(_custom_matching_validator__WEBPACK_IMPORTED_MODULE_2__["mustMatch"])(this.mustMatch[0], this.mustMatch[1])(formGroup);
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])('routingMatch'),
    __metadata("design:type", Array)
], CustomRoutingMatchDirective.prototype, "mustMatch", void 0);
CustomRoutingMatchDirective = CustomRoutingMatchDirective_1 = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"])({
        selector: '[routingMatch]',
        providers: [{ provide: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["NG_VALIDATORS"], useExisting: CustomRoutingMatchDirective_1, multi: true }]
    })
], CustomRoutingMatchDirective);



/***/ }),

/***/ "./src/app/validators/custom-unquotable-zip-directive.ts":
/*!***************************************************************!*\
  !*** ./src/app/validators/custom-unquotable-zip-directive.ts ***!
  \***************************************************************/
/*! exports provided: CustomUnquotableZipDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomUnquotableZipDirective", function() { return CustomUnquotableZipDirective; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _shared_unquotableZips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/unquotableZips */ "./src/app/shared/unquotableZips.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CustomUnquotableZipDirective_1;



let CustomUnquotableZipDirective = CustomUnquotableZipDirective_1 = class CustomUnquotableZipDirective {
    validate(c) {
        let v = c.value;
        return (_shared_unquotableZips__WEBPACK_IMPORTED_MODULE_2__["UnquotableZips"].zips.indexOf(v) > -1) ? { "unquotableZip": true } : null;
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", String)
], CustomUnquotableZipDirective.prototype, "unquotableZip", void 0);
CustomUnquotableZipDirective = CustomUnquotableZipDirective_1 = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Directive"])({
        selector: '[unquotableZip][formControlName],[unquotableZip][formControl],[unquotableZip][ngModel]',
        providers: [{ provide: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["NG_VALIDATORS"], useExisting: CustomUnquotableZipDirective_1, multi: true }]
    })
], CustomUnquotableZipDirective);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
const environment = {
    local: false,
    dev: false,
    qa: false,
    stage: false,
    production: false,
    xenithApiEndpoint: 'https://ws-twfg-dev.xenithx.com',
    xenithWeb: 'https://dev-twfg.xenithx.com'
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! exports provided: getBaseUrl, getArcBaseUrl, getArcWebUrl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaseUrl", function() { return getBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArcBaseUrl", function() { return getArcBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArcWebUrl", function() { return getArcWebUrl; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
function getArcBaseUrl() {
    //return "http://localhost:50290";
    return _environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].xenithApiEndpoint;
}
function getArcWebUrl(parameters) {
    return _environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].xenithWeb;
}
const providers = [
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
    { provide: 'ARC_API_URL', useFactory: getArcBaseUrl, deps: [] },
    { provide: 'ARC_WEB_URL', useFactory: getArcWebUrl, deps: [] }
];
if (_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_1__["platformBrowserDynamic"])(providers).bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_2__["AppModule"])
    .catch(err => console.log(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\Users\tom.king\source\Workspaces\Workspace\Twico\HiscoxFlood\HiscoxFlood\ClientApp\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map